import React from "react";
import {INominee, NomineeIdType} from "API/types";
import socials from "components/UI/icons/socials";
import icons from "components/UI/icons/icons";
import Card from "components/UI/Card";

interface INomineeListProps {
    nominees: INominee[],
    makeVote: (id: NomineeIdType) => Promise<void | true>;
    connectWallet: () => Promise<void | true>;
}

const NomineesList: React.FC<INomineeListProps> = (
    {
        nominees,
        makeVote,
        connectWallet,
    }
) => {
    const {IconColorFacebook, IconColorInstagram, IconColorTiktok, IconColorTwitter, IconColorYoutube} = socials;
    const {IconLike} = icons;

    const participants = [
        {
          "Title": "Dancer: Alcy",
          "Description": "Alcy, is a dancer from Mozambique, Africa. He is 28 and he loves to perform hip hop and dubstep style dances.",
          "YT": "https://youtu.be/LkFpQrj2lRU",
          "Type": "Dancer",
          "": "",
          "topInfo": "Top 4: won $800"
        },
        {
          "Title": "Dancer: Mess Dance Studio",
          "Description": "Irakli Fifia and his crew are part of the Mess Dance Studio in Georgia. They perform dances in street jazz, dancehall and hip hop styles.",
          "YT": "https://www.youtube.com/watch?v=WMhSN_U3DJI",
          "Type": "Dancer",
          "": "",
          "topInfo": "Top 1:  won $5,000 + $30,000 <span class='marketing-budget'>(marketing budget for the winner and the product)</span>"
        },
        {
          "Title": "Dancer: F4Team",
          "Description": "F4 Team are young guys from Kazakhstan who were able to reach almost a million TikTok followers in 3 months! They are known for their hip hop dances and K-Pop-inspired style.",
          "YT": "https://youtu.be/b_kLoLvCXX4",
          "Type": "Dancer",
          "": "",
          "topInfo": "Top 7: won $300"
        },
        {
          "Title": "Dancer: Jika",
          "Description": "Jika is a dancer who has been featured in popular music videos, including \"Japan\" by Famous Dex. She has been trained at such dance studios as Millennium, Playground, Ida and others.",
          "YT": "https://youtu.be/wANdZTntUzI",
          "Type": "Dancer",
          "": "",
          "topInfo": "Top 5: won $600"
        },
        {
          "Title": "Dancer: Nero Dance Center",
          "Description": "Nero Dance Center is a dance school from Baku, Azerbaijan specializing in all kinds of dance, from jazz-funk and strip-plastic to zumba and belly dancing.",
          "YT": "https://www.youtube.com/watch?v=ZMDlhyMdtFE",
          "Type": "Dancer",
          "": "",
          "topInfo": "Top 2: won $2,000"
        },
        {
          "Title": "Dancer: Jan Voinov",
          "Description": "Jan is a participant from Kyrgyzstan, who performs hip hop and street style dances. He has been dancing for years and is part of the Let's Dance studio.",
          "YT": "https://www.youtube.com/watch?v=_5Rg673rfqI&ab_channel=1ATH.Studio",
          "Type": "Dancer",
          "": "",
          "topInfo": "Top 9: won $200"
        },
        {
          "Title": "Dancer: Nicholas and Luka",
          "Description": "Nicholas and Luka are dancers from Georgia, who have won a couple of dance battles and championships in Georgia and in other countries. They were also featured on Georgia’s Got Talent.",
          "YT": "https://www.youtube.com/watch?v=si5rvWDBDwU&ab_channel=1ATH.Studio",
          "Type": "Dancer",
          "": "",
          "topInfo": "Top 10: won $200"
        },
        {
          "Title": "Dancer: Hamutsun Serve Crew",
          "Description": "Hamutsun Serve Crew is a Japanese dance unit formed in 1999. They gained reputation as performers of 'Animation Dance' through TV appearances in Japan. Most recently, they have collaborated with Madonna for her 2008 \"Sticky & Sweet Tour\".",
          "YT": "https://www.youtube.com/watch?v=tMiMI6h8L-k&ab_channel=1ATH.Studio",
          "Type": "Dancer",
          "": "",
          "topInfo": "Top 3: won $1,000"
        },
        {
          "Title": "Dancer: Triplets Ghetto Kids",
          "Description": "TGK is an NGO based in Uganda, with a mission of using Music, Dance and Drama to help disadvantaged children, street children and orphans to achieve basic needs.",
          "YT": "https://www.youtube.com/watch?v=Hz_2qvJCPvo&ab_channel=1ATH.Studio",
          "Type": "Dancer",
          "": "",
          "topInfo": "Top 6: won $600"
        },
        {
          "Title": "Dancer: Hoofer Dance Mob",
          "Description": "Hoofer Dance Mob is a fun dance crew from Georgia, known for their original concept of wearing masks of digital characters in their dance videos.",
          "YT": "https://www.youtube.com/watch?v=8xfPCWv9-LM&ab_channel=1ATH.Studio",
          "Type": "Dancer",
          "": "",
          "topInfo": "Top 8: won $300"
        },
        {
          "Title": "DJ: Alex BLGN",
          "Description": "Alex has been creating music and working with sound for over eight years. He currently works as a sound designer, while also making music and sounds for games and movies. He writes dubstep, house, pop music and performs DJ sets under the alias BLGN. He was also praised for his performance at Eurovision 2019 selection stage.",
          "YT": "https://www.youtube.com/watch?v=Fj1Ndzi0Mds&ab_channel=1ATH.Studio",
          "Type": "DJ",
          "": "",
          "topInfo": "Top 4: won $200"
        },
        {
          "Title": "DJ: Greg beat",
          "Description": "Greg Beat is a DJ and beatmaker from France. He's known for producing scratch beat hip hop tracks.",
          "YT": "https://www.youtube.com/watch?v=Xo_Zl_jZFOI&ab_channel=1ATH.Studio",
          "Type": "DJ",
          "": "",
          "topInfo": "Top 3: won $300"
        },
        {
          "Title": "DJ: Charlie Atom",
          "Description": "Charlie is a music producer, composer & DJ from Mexico with over 5,000,000 Plays on Spotify.",
          "YT": "https://www.youtube.com/watch?v=aQcueL-yOEw&ab_channel=1ATH.Studio",
          "Type": "DJ",
          "": "",
          "topInfo": "Top 1: won $2,000 + $30,000 <span class='marketing-budget'>(marketing budget for the winner and the product)</span>"
        },
        {
          "Title": "DJ: Zinnat",
          "Description": "Zinnat is a DJ and Producer at Zinnat Music Studio. He's been producing music for more than 16 years in variety of styles, making songs for big artists , beats for artists like Eminems band D12 Bizzare, Fly Boy Keno, Bunji and many more. His remix for Iggy Dance & DJ Challenge was made in the style of Future House.",
          "YT": "https://www.youtube.com/watch?v=9839e-ppk8s&ab_channel=1ATH.Studio",
          "Type": "DJ",
          "": "",
          "topInfo": "Top 2: won $500"
        }
      ]

      const socialMedia =  [
        {
          Participant: "Nihal",
          "TT (Alisa)":
            "https://www.tiktok.com/@1ath.studio/video/7112039766434057473?is_copy_url=1&is_from_webapp=v1",
          "": "",
          "IG (Ramiz)":
            "https://www.instagram.com/tv/CfG2BZJM85o/?utm_source=ig_web_copy_link",
          __1: "",
          "YT full vid (Ira)": "https://youtu.be/rMma51GSVXU",
          __2: "",
          "TW (Ramiz)":
            "https://twitter.com/1ATHStudio/status/1539582729507028993",
          __3: "",
          "FB (Ira Erika)": "https://fb.watch/dOMtYrZwNY/",
        },
        {
          Participant: "Enoch",
          "TT (Alisa)":
            "https://www.tiktok.com/@1ath.studio/video/7112041435267910914?is_from_webapp=1&sender_device=pc",
          "": "",
          "IG (Ramiz)":
            "https://www.instagram.com/tv/CfG4GZbsc7c/?utm_source=ig_web_copy_link",
          __1: "",
          "YT full vid (Ira)": "https://youtu.be/GD6BSXaxZnY",
          __2: "",
          "TW (Ramiz)":
            "https://twitter.com/1ATHStudio/status/1539586234405703681",
          __3: "",
          "FB (Ira Erika)": "https://fb.watch/dON7lGqCXE/",
        },
        {
          Participant: "Nicholas and Luka",
          "TT (Alisa)": "https://vt.tiktok.com/ZSd3rWPYw/?k=1",
          "": "",
          "IG (Ramiz)":
            "https://www.instagram.com/tv/CfG5S3UlyeC/?utm_source=ig_web_copy_link",
          __1: "",
          "YT full vid (Ira)": "https://youtu.be/si5rvWDBDwU",
          __2: "",
          "TW (Ramiz)":
            "https://twitter.com/1ATHStudio/status/1539589239062536193",
          __3: "",
          "FB (Ira Erika)": "https://fb.watch/dOOeggEECc/",
        },
        {
          Participant: "Alex Keston",
          "TT (Alisa)": "https://vt.tiktok.com/ZSd3hBDRr/?k=1",
          "": "",
          "IG (Ramiz)":
            "https://www.instagram.com/tv/CfG6j5Brrel/?utm_source=ig_web_copy_link",
          __1: "",
          "YT full vid (Ira)": "https://youtu.be/hijy9viyuzc",
          __2: "",
          "TW (Ramiz)":
            "https://twitter.com/1ATHStudio/status/1539591553320091650",
          __3: "",
          "FB (Ira Erika)": "https://fb.watch/dOOPFD0iHG/",
        },
        {
          Participant: "Joseph Nerzie",
          "TT (Alisa)":
            "https://www.tiktok.com/@1ath.studio/video/7112050211886877954?is_from_webapp=1&sender_device=pc&web_id=7112032987612562950",
          "": "",
          "IG (Ramiz)":
            "https://www.instagram.com/tv/CfG8IfuOrIM/?utm_source=ig_web_copy_link",
          __1: "",
          "YT full vid (Ira)": "https://youtu.be/KIPKyw6HZD4",
          __2: "",
          "TW (Ramiz)":
            "https://twitter.com/1ATHStudio/status/1539595170248810501",
          __3: "",
          "FB (Ira Erika)": "https://fb.watch/dOPhCy0A9K/",
        },
        {
          Participant: "The Big Sound",
          "TT (Alisa)":
            "https://www.tiktok.com/@1ath.studio/video/7112053035123117314?is_from_webapp=1&sender_device=pc&web_id=7112032987612562950",
          "": "",
          "IG (Ramiz)":
            "https://www.instagram.com/tv/CfG9mtHAfvx/?utm_source=ig_web_copy_link",
          __1: "",
          "YT full vid (Ira)": "https://youtu.be/-vHpOI3bczQ",
          __2: "",
          "TW (Ramiz)":
            "https://twitter.com/1ATHStudio/status/1539598417252458496",
          __3: "",
          "FB (Ira Erika)": "https://fb.watch/dOQo9AakYF/",
        },
        {
          Participant: "Daulet Anarbekov",
          "TT (Alisa)":
            "https://www.tiktok.com/@1ath.studio/video/7112054477103860994?is_from_webapp=1&sender_device=pc&web_id=7112032987612562950",
          "": "",
          "IG (Ramiz)":
            "https://www.instagram.com/tv/CfG_LLPO1PE/?utm_source=ig_web_copy_link",
          __1: "",
          "YT full vid (Ira)": "https://www.youtube.com/watch?v=JI-oIBStPFI",
          __2: "",
          "TW (Ramiz)":
            "https://twitter.com/1ATHStudio/status/1539601486358929410",
          __3: "",
          "FB (Ira Erika)": "https://fb.watch/dOQQVt5yD-/",
        },
        {
          Participant: "Charlie Atom",
          "TT (Alisa)":
            "https://www.tiktok.com/@1ath.studio/video/7112056218142772482?is_from_webapp=1&sender_device=pc&web_id=7112032987612562950",
          "": "",
          "IG (Ramiz)":
            "https://www.instagram.com/tv/CfG_5n4js0K/?utm_source=ig_web_copy_link",
          __1: "",
          "YT full vid (Ira)": "https://youtu.be/aQcueL-yOEw",
          __2: "",
          "TW (Ramiz)":
            "https://twitter.com/1ATHStudio/status/1539603575814426627",
          __3: "",
          "FB (Ira Erika)": "https://fb.watch/dORaZbF9D6/",
        },
        {
          Participant: "Paula Grueso",
          "TT (Alisa)":
            "https://www.tiktok.com/@1ath.studio/video/7112056967752912129?is_from_webapp=1&sender_device=pc&web_id=7112032987612562950",
          "": "",
          "IG (Ramiz)":
            "https://www.instagram.com/tv/CfHBO03MqDR/?utm_source=ig_web_copy_link",
          __1: "",
          "YT full vid (Ira)": "https://youtu.be/EQxggM1lzfg",
          __2: "",
          "TW (Ramiz)":
            "https://twitter.com/1ATHStudio/status/1539606886546345984",
          __3: "",
          "FB (Ira Erika)": "https://fb.watch/dOS1olrq2F/",
        },
        {
          Participant: "Greg Beat",
          "TT (Alisa)":
            "https://www.tiktok.com/@1ath.studio/video/7112070528810159362?is_from_webapp=1&sender_device=pc&web_id=7112032987612562950",
          "": "",
          "IG (Ramiz)":
            "https://www.instagram.com/tv/CfHFe7DrbYY/?utm_source=ig_web_copy_link",
          __1: "",
          "YT full vid (Ira)": "https://youtu.be/Xo_Zl_jZFOI",
          __2: "",
          "TW (Ramiz)":
            "https://twitter.com/1ATHStudio/status/1539640062228705280/photo/1",
          __3: "",
          "FB (Ira Erika)": "https://fb.watch/dOYLa3Ro71/",
        },
        {
          Participant: "Nero Dance Center",
          "TT (Alisa)":
            "https://www.tiktok.com/@1ath.studio/video/7117314356169264386?is_from_webapp=1&sender_device=pc&web_id=7113634897173022214",
          "": "",
          "IG (Ramiz)":
            "https://www.instagram.com/tv/CfrnHqCuuLQGJvKQkeDQecc7UehbJb_bg7Cg4A0/",
          __1: "",
          "YT full vid (Ira)": "https://www.youtube.com/watch?v=ZMDlhyMdtFE",
          __2: "",
          "TW (Ramiz)":
            "https://twitter.com/1ATHStudio/status/1544722872031125507",
          __3: "",
          "FB (Ira Erika)": "https://fb.watch/e5sTgDSrNT/",
        },
        {
          Participant: "Mess Dance Studio",
          "TT (Alisa)":
            "https://www.tiktok.com/@1ath.studio/video/7117313868736580866?is_from_webapp=1&sender_device=pc&web_id=7113634897173022214",
          "": "",
          "IG (Ramiz)":
            "https://www.instagram.com/tv/Cfrm8wNMgl7F7ov7lFtX0G5NPBlbexCMWI67zg0/",
          __1: "",
          "YT full vid (Ira)": "https://www.youtube.com/watch?v=WMhSN_U3DJI",
          __2: "",
          "TW (Ramiz)":
            "https://twitter.com/1ATHStudio/status/1544725272049721346",
          __3: "",
          "FB (Ira Erika)": "https://fb.watch/e6FhRs1WyX/",
        },
        {
          Participant: "Rebeca (Ladytron)",
          "TT (Alisa)":
            "https://www.tiktok.com/@1ath.studio/video/7112074842509184258?is_from_webapp=1&sender_device=pc&web_id=7112032987612562950",
          "": "",
          "IG (Ramiz)":
            "https://www.instagram.com/tv/CfHKwFwuFP_/?utm_source=ig_web_copy_link",
          __1: "",
          "YT full vid (Ira)": "https://www.youtube.com/watch?v=pAFKN4EUDZM",
          __2: "",
          "TW (Ramiz)":
            "https://twitter.com/1ATHStudio/status/1539627030198771712",
          __3: "",
          "FB (Ira Erika)": "https://fb.watch/dO_k3mxWS8/",
        },
        {
          Participant: "Karol Mental",
          "TT (Alisa)":
            "https://www.tiktok.com/@1ath.studio/video/7112079477596884225?is_from_webapp=1&sender_device=pc&web_id=7112032987612562950",
          "": "",
          "IG (Ramiz)": "https://www.instagram.com/p/CfHMBh5vSU7/",
          __1: "",
          "YT full vid (Ira)": "https://www.youtube.com/watch?v=z3i2F2qxGvw",
          __2: "",
          "TW (Ramiz)":
            "https://twitter.com/1ATHStudio/status/1539630729797181441",
          __3: "",
          "FB (Ira Erika)": "https://fb.watch/dO_N127Pu0/",
        },
        {
          Participant: "Ilias",
          "TT (Alisa)":
            "https://www.tiktok.com/@1ath.studio/video/7112087902380690689?is_from_webapp=1&sender_device=pc&web_id=7112032987612562950",
          "": "",
          "IG (Ramiz)":
            "https://www.instagram.com/tv/CfHNMMDu8QK/?utm_source=ig_web_copy_link",
          __1: "",
          "YT full vid (Ira)": "https://www.youtube.com/watch?v=zmQM-FkcI9g",
          __2: "",
          "TW (Ramiz)":
            "https://twitter.com/1ATHStudio/status/1539641597910220800",
          __3: "",
          "FB (Ira Erika)": "https://fb.watch/dO-jyM6nNR/",
        },
        {
          Participant: "Estefanía Navas",
          "TT (Alisa)":
            "https://www.tiktok.com/@1ath.studio/video/7112088785747250433?is_from_webapp=1&sender_device=pc&web_id=7112032987612562950",
          "": "",
          "IG (Ramiz)":
            "https://www.instagram.com/tv/CfHOOXPt0iv/?utm_source=ig_web_copy_link",
          __1: "",
          "YT full vid (Ira)": "https://youtu.be/UOTZkrsAeKM",
          __2: "",
          "TW (Ramiz)":
            "https://twitter.com/1ATHStudio/status/1539634920833835011",
          __3: "",
          "FB (Ira Erika)": "https://fb.watch/dO-OeItB1E/",
        },
        {
          Participant: "Hoofer Dance Mob",
          "TT (Alisa)":
            "https://www.tiktok.com/@1ath.studio/video/7112091696585821441?is_from_webapp=1&sender_device=pc&web_id=7112032987612562950",
          "": "",
          "IG (Ramiz)":
            "https://www.instagram.com/tv/CfHPbNtOdRI/?utm_source=ig_web_copy_link",
          __1: "",
          "YT full vid (Ira)": "https://youtu.be/8xfPCWv9-LM",
          __2: "",
          "TW (Ramiz)":
            "https://twitter.com/1ATHStudio/status/1539638154185117696",
          __3: "",
          "FB (Ira Erika)": "https://fb.watch/dOYZ09GBL6/",
        },
        {
          Participant: "Uniqueens Dance Team",
          "TT (Alisa)":
            "https://www.tiktok.com/@1ath.studio/video/7112100766151757057?is_from_webapp=1&sender_device=pc&web_id=7112032987612562950",
          "": "",
          "IG (Ramiz)":
            "https://www.instagram.com/tv/CfHSEN9spim/?utm_source=ig_web_copy_link",
          __1: "",
          "YT full vid (Ira)": "https://youtu.be/bbIsfxQYh7M",
          __2: "",
          "TW (Ramiz)":
            "https://twitter.com/1ATHStudio/status/1539643015429603328",
          __3: "",
          "FB (Ira Erika)": "https://fb.watch/dO_qgn9Ung/",
        },
        {
          Participant: "Vlad Kim",
          "TT (Alisa)":
            "https://www.tiktok.com/@1ath.studio/video/7112102946866777346?is_from_webapp=1&sender_device=pc&web_id=7112032987612562950",
          "": "",
          "IG (Ramiz)":
            "https://www.instagram.com/tv/CfHSnRMLarU/?utm_source=ig_web_copy_link",
          __1: "",
          "YT full vid (Ira)": "https://youtu.be/iBv9YZqeCvE",
          __2: "",
          "TW (Ramiz)":
            "https://twitter.com/1ATHStudio/status/1539645181191790593",
          __3: "",
          "FB (Ira Erika)": "https://fb.watch/dO-hjGgut1/",
        },
        {
          Participant: "Zinco18",
          "TT (Alisa)":
            "https://www.tiktok.com/@1ath.studio/video/7112103529828961538?is_from_webapp=1&sender_device=pc&web_id=7112032987612562950",
          "": "",
          "IG (Ramiz)":
            "https://www.instagram.com/tv/CfHUvU1vXiI/?utm_source=ig_web_copy_link",
          __1: "",
          "YT full vid (Ira)": "https://youtu.be/VIjQOr18oVo",
          __2: "",
          "TW (Ramiz)":
            "https://twitter.com/1ATHStudio/status/1539648897366491136",
          __3: "",
          "FB (Ira Erika)": "https://fb.watch/dO-LD8pw4g/",
        },
        {
          Participant: "Jika",
          "TT (Alisa)":
            "https://www.tiktok.com/@1ath.studio/video/7112105570030685441?is_from_webapp=1&sender_device=pc&web_id=7112032987612562950",
          "": "",
          "IG (Ramiz)":
            "https://www.instagram.com/tv/CfHVdHULBFV/?utm_source=ig_web_copy_link",
          __1: "",
          "YT full vid (Ira)": "https://youtu.be/wANdZTntUzI",
          __2: "",
          "TW (Ramiz)":
            "https://twitter.com/1ATHStudio/status/1539651152324984832",
          __3: "",
          "FB (Ira Erika)": "https://fb.watch/dP0d8WX4_1/",
        },
        {
          Participant: "Hamutsun Serve Crew",
          "TT (Alisa)":
            "https://www.tiktok.com/@1ath.studio/video/7112107039475682561?is_from_webapp=1&sender_device=pc&web_id=7112032987612562950",
          "": "",
          "IG (Ramiz)":
            "https://www.instagram.com/tv/CfHWpIVNpuA/?utm_source=ig_web_copy_link",
          __1: "",
          "YT full vid (Ira)": "https://youtu.be/tMiMI6h8L-k",
          __2: "",
          "TW (Ramiz)":
            "https://twitter.com/1ATHStudio/status/1539653138072084480",
          __3: "",
          "FB (Ira Erika)": "https://fb.watch/dP0sH-cYwW/",
        },
        {
          Participant: "Alcy",
          "TT (Alisa)":
            "https://www.tiktok.com/@1ath.studio/video/7112108135258574082?is_from_webapp=1&sender_device=pc&web_id=7112032987612562950",
          "": "",
          "IG (Ramiz)":
            "https://www.instagram.com/tv/CfHXLCGsERx/?utm_source=ig_web_copy_link",
          __1: "",
          "YT full vid (Ira)": "https://youtu.be/LkFpQrj2lRU",
          __2: "",
          "TW (Ramiz)":
            "https://twitter.com/1ATHStudio/status/1539654387311661057",
          __3: "",
          "FB (Ira Erika)": "https://fb.watch/dP0QtOM7pM/",
        },
        {
          Participant: "Densley Carolissen",
          "TT (Alisa)":
            "https://www.tiktok.com/@1ath.studio/video/7112110666130918658?is_from_webapp=1&sender_device=pc",
          "": "",
          "IG (Ramiz)":
            "https://www.instagram.com/tv/CfHX-2OMf96/?utm_source=ig_web_copy_link",
          __1: "",
          "YT full vid (Ira)": "https://youtu.be/VO_qvTuYMhs",
          __2: "",
          "TW (Ramiz)":
            "https://twitter.com/1ATHStudio/status/1539655927607205888",
          __3: "",
          "FB (Ira Erika)": "https://fb.watch/dP102O07tj/",
        },
        {
          Participant: "Jan Voinov",
          "TT (Alisa)":
            "https://www.tiktok.com/@1ath.studio/video/7112114046933011713?is_from_webapp=1&sender_device=pc&web_id=7112032987612562950",
          "": "",
          "IG (Ramiz)":
            "https://www.instagram.com/tv/CfHYosDspx4/?utm_source=ig_web_copy_link",
          __1: "",
          "YT full vid (Ira)": "https://youtu.be/_5Rg673rfqI",
          __2: "",
          "TW (Ramiz)":
            "https://twitter.com/1ATHStudio/status/1539658116497022976",
          __3: "",
          "FB (Ira Erika)": "https://fb.watch/dP1wQb9_EH/",
        },
        {
          Participant: "XP-TEAM",
          "TT (Alisa)":
            "https://www.tiktok.com/@1ath.studio/video/7112115401617591554?is_from_webapp=1&sender_device=pc&web_id=7112032987612562950",
          "": "",
          "IG (Ramiz)":
            "https://www.instagram.com/tv/CfHZpW1srxk/?utm_source=ig_web_copy_link",
          __1: "",
          "YT full vid (Ira)": "https://youtu.be/s0BNb5Auf6s",
          __2: "",
          "TW (Ramiz)":
            "https://twitter.com/1ATHStudio/status/1539659716716285954",
          __3: "",
          "FB (Ira Erika)": "https://fb.watch/dP21g2yoag/",
        },
        {
          Participant: "F4Team",
          "TT (Alisa)":
            "https://www.tiktok.com/@1ath.studio/video/7112116276805242113?is_from_webapp=1&sender_device=pc&web_id=7112032987612562950",
          "": "",
          "IG (Ramiz)":
            "https://www.instagram.com/tv/CfHaTuKMPzO/?utm_source=ig_web_copy_link",
          __1: "",
          "YT full vid (Ira)": "https://youtu.be/b_kLoLvCXX4",
          __2: "",
          "TW (Ramiz)":
            "https://twitter.com/1ATHStudio/status/1539661099406336000",
          __3: "",
          "FB (Ira Erika)": "https://fb.watch/dP2AG6JP-k/",
        },
        {
          Participant: "Triplets Ghetto Kids",
          "TT (Alisa)":
            "https://www.tiktok.com/@1ath.studio/video/7112117380519628034?is_from_webapp=1&sender_device=pc&web_id=7112032987612562950",
          "": "",
          "IG (Ramiz)":
            "https://www.instagram.com/tv/CfHa77tLKkk/?utm_source=ig_web_copy_link",
          __1: "",
          "YT full vid (Ira)": "https://youtu.be/Hz_2qvJCPvo",
          __2: "",
          "TW (Ramiz)":
            "https://twitter.com/1ATHStudio/status/1539662488458764289",
          __3: "",
          "FB (Ira Erika)": "https://fb.watch/dP2JxwqZaH/",
        },
        {
          Participant: "Alex BLGN",
          "TT (Alisa)":
            "https://www.tiktok.com/@1ath.studio/video/7112345705439694082?is_from_webapp=1&sender_device=pc&web_id=7112032987612562950",
          "": "",
          "IG (Ramiz)":
            "https://www.instagram.com/tv/CfI-Yqdprsd/?igshid=YmMyMTA2M2Y=",
          __1: "",
          "YT full vid (Ira)": "https://youtu.be/Fj1Ndzi0Mds",
          __2: "",
          "TW (Ramiz)":
            "https://twitter.com/1ATHStudio/status/1539878453750550528",
          __3: "",
          "FB (Ira Erika)": "https://fb.watch/dPQNr-7wz4/",
        },
        {
          Participant: "Zinnat",
          "TT (Alisa)":
            "https://www.tiktok.com/@1ath.studio/video/7112364066869349633?is_from_webapp=1&sender_device=pc&web_id=7112032987612562950",
          "": "",
          "IG (Ramiz)":
            "https://www.instagram.com/tv/CfJJcIdDhlE/?igshid=YmMyMTA2M2Y=",
          __1: "",
          "YT full vid (Ira)": "https://youtu.be/9839e-ppk8s",
          __2: "",
          "TW (Ramiz)":
            "https://twitter.com/1ATHStudio/status/1539903694619021312",
          __3: "",
          "FB (Ira Erika)":
            "https://www.facebook.com/1ATH.Studio/videos/1199783084166442",
        },
        {
          Participant: "DYtalentve",
          "TT (Alisa)":
            "https://www.tiktok.com/@1ath.studio/video/7112348026353634561?is_from_webapp=1&sender_device=pc&web_id=7112032987612562950",
          "": "",
          "IG (Ramiz)":
            "https://www.instagram.com/tv/CfJB0AGjuvp/?igshid=YmMyMTA2M2Y=",
          __1: "",
          "YT full vid (Ira)": "https://youtu.be/AOoV_dggptc",
          __2: "",
          "TW (Ramiz)":
            "https://twitter.com/1ATHStudio/status/1539891840643567617",
          __3: "",
          "FB (Ira Erika)": "https://fb.watch/dPTcvtAEzE/",
        },
        ]

        const introductionData = [
            {
                "#": 1,
                "Name": "Zinco",
                "Dancer/DJ?": "Dancer",
                "Agreement": "sent video",
                "Name_Official": "Zinco18",
                "Inrto/Description_Official": "",
                "top 1": "https://www.instagram.com/p/B9PnIISpiNv/?igshid=MDJmNzVkMjY=",
                "top 2": "https://www.instagram.com/p/B6vkvuspVXv/?igshid=MDJmNzVkMjY=",
                "top 3": "https://www.instagram.com/p/CCjsD8RJcCv/?igshid=MDJmNzVkMjY=",
                "repost by sponsor": "",
                "comment by participant": "",
                "Main Video/Track (gdrive)": "https://drive.google.com/drive/u/1/folders/1FmjwnNs-RGTggPNd-xWzpk3fvR4DWvFc",
                "Introduction Video (gdrive)": "https://drive.google.com/drive/u/1/folders/1FmjwnNs-RGTggPNd-xWzpk3fvR4DWvFc",
                "IG                                                         4.6 Mio": "10k https://www.instagram.com/zinco18",
                "(Main) post by sponsor": "TT: https://www.tiktok.com/@1ath.studio/video/7112103529828961538?is_from_webapp=1&sender_device=pc&web_id=7112032987612562950 \nYT: https://youtu.be/VIjQOr18oVo \nIG: https://www.instagram.com/tv/CfHUvU1vXiI/?utm_source=ig_web_copy_link                                                                                                                                                                                                                                                      \nTW: https://twitter.com/1ATHStudio/status/1539648897366491136 \nFB: https://fb.watch/dO-LD8pw4g/",
                "(Main) repost by participant": "Asked to repost",
                "(Intro) post by sponsor": "TT: https://www.tiktok.com/@1ath.studio/video/7113179390527294722?is_from_webapp=1&sender_device=pc&web_id=7112032987612562950  \nFB: https://fb.watch/dSQU5ava7W  \nYT: https://youtu.be/dsXkolLI090  \nIG https://www.instagram.com/tv/CfOuK4opAK-/?utm_source=ig_web_copy_link  \nTW https://twitter.com/1ATHStudio/status/1540690250896482304",
                "(Intro) repost by participant": "Asked to repost",
                "(Promo) post by sponsor": "IG: https://www.instagram.com/p/CfJer0GMnlE/\nTW: https://twitter.com/1ATHStudio/status/1539949458065985536   \nFB: https://fb.watch/dQ6p7i-EWP/  \nTT: https://www.tiktok.com/@1ath.studio/video/7112457528650272001?_t=8TP8BeGudxS&_r=1 \nYT: https://www.youtube.com/shorts/wJWR9oULbCo",
                "(Promo) repost by participant": "Requested to disregard",
                "TT                       1.5Mio": "54k https://www.tiktok.com/@zinco18_",
                "(Main) post by sponsor__1": "",
                "(Main) repost by participant__1": "",
                "(Intro) post by sponsor__1": "",
                "(Intro) repost by participant__1": "",
                "(Promo) post by sponsor__1": "",
                "(Promo) repost by participant__1": "",
                "Youtube       1.1Mio": "",
                "(Main) post by sponsor__2": "",
                "(Main) repost by participant__2": "",
                "(Intro) post by sponsor__2": "",
                "(Intro) repost by participant__2": "",
                "(Promo) post by sponsor__2": "",
                "(Promo) repost by participant__2": "",
                "TW": "",
                "(Main) post by sponsor__3": "",
                "(Main) repost by participant__3": "",
                "(Intro) post by sponsor__3": "",
                "(Intro) repost by participant__3": "",
                "(Promo) post by sponsor__3": "TW: https://twitter.com/1ATHStudio/status/1539949458065985536",
                "(Promo) repost by participant__3": "",
                "FB                3.8 Mio": "",
                "(Main) post by sponsor__4": "",
                "(Main) repost by participant__4": "",
                "(Intro) post by sponsor__4": "",
                "(Intro) repost by participant__4": "",
                "(Promo) post by sponsor__4": "FB: https://fb.watch/dQ6p7i-EWP/",
                "(Promo) repost by participant__4": "",
                "Contact": "email",
                "Manager": "Aziz",
                "Conditions/Comments": "prize pool",
                "Country": "UK"
            },
            {
                "#": 2,
                "Name": "F4Team \nManager: Ulan",
                "Dancer/DJ?": "Dancer / Group",
                "Agreement": "sent video",
                "Name_Official": "F4team",
                "Inrto/Description_Official": "Meet F4 Team. These young guys from Kazakhstan are self-made and were able to reach almost a million TikTok followers in 3 months! They are known for their hip hop dances and K-Pop-inspired style. Are you excited for their upcoming video drop? @F4team.q #dance\n#music\n#metaverse\n#nft\n#iggyboy",
                "top 1": "https://vt.tiktok.com/ZSdsQtFr7/?k=1",
                "top 2": "https://vt.tiktok.com/ZSdsQtpAd/?k=1",
                "top 3": "https://vt.tiktok.com/ZSdsQxbRT/?k=1",
                "repost by sponsor": "TT: https://www.tiktok.com/foryou?_r=1&_t=8TBZoy951s2&is_from_webapp=v1&item_id=7109497814111014146#/@1ath.studio/video/7109497814111014146 \nYT: https://www.youtube.com/watch?v=BDL33CTruHk \nIG: https://www.instagram.com/reel/Ce1RNYDDOvl/?igshid=YmMyMTA2M2Y%3D \nTw: https://twitter.com/1ATHStudio/status/1537358440674123777 \nFB: https://fb.watch/dGRJIs53Z9/",
                "comment by participant": "TT: https://www.tiktok.com/@1ath.studio/video/7109497814111014146?is_copy_url=1&is_from_webapp=v1\nIG: https://www.instagram.com/tv/CfHaTuKMPzO/?utm_source=ig_web_copy_link",
                "Main Video/Track (gdrive)": "https://drive.google.com/drive/folders/1dl0cg1DMrgzBGq8FBeZgsXFJTbKlGowE?usp=sharing",
                "Introduction Video (gdrive)": "https://drive.google.com/drive/u/0/folders/1dl0cg1DMrgzBGq8FBeZgsXFJTbKlGowE",
                "IG                                                         4.6 Mio": "45.2K https://www.instagram.com/f4team.q/",
                "(Main) post by sponsor": "TT: https://www.tiktok.com/@1ath.studio/video/7112116276805242113?is_from_webapp=1&sender_device=pc&web_id=7112032987612562950 \nYT: https://youtu.be/b_kLoLvCXX4 \nIG: https://www.instagram.com/tv/CfHaTuKMPzO/?utm_source=ig_web_copy_link                                                                                                                                                                                                                                              \nTW: https://twitter.com/1ATHStudio/status/1539661099406336000 \nFB: https://fb.watch/dP2AG6JP-k/",
                "(Main) repost by participant": "IG: https://instagram.com/stories/f4team.q/2866823055462573475?utm_source=ig_story_item_share&igshid=YmMyMTA2M2Y=",
                "(Intro) post by sponsor": "YT: https://youtu.be/-vqVWN6ukng  \nFB: https://fb.watch/dSOAi4-PvK/  \nTT: https://www.tiktok.com/@1ath.studio/video/7113169727551278337?is_from_webapp=1&sender_device=pc&web_id=7112032987612562950  \nIG: https://www.instagram.com/tv/CfOs2FALa7p/?utm_source=ig_web_copy_link \nTW: https://twitter.com/1ATHStudio/status/1540687328804470786?s=20&t=jRfmDgiDjPts4repOGe8KQ",
                "(Intro) repost by participant": "Asked to repost",
                "(Promo) post by sponsor": "The link is above",
                "(Promo) repost by participant": "Requested to disregard",
                "TT                       1.5Mio": "828k https://www.tiktok.com/@f4team.q",
                "(Main) post by sponsor__1": "",
                "(Main) repost by participant__1": "",
                "(Intro) post by sponsor__1": "",
                "(Intro) repost by participant__1": "",
                "(Promo) post by sponsor__1": "",
                "(Promo) repost by participant__1": "",
                "Youtube       1.1Mio": "N/A",
                "(Main) post by sponsor__2": "",
                "(Main) repost by participant__2": "",
                "(Intro) post by sponsor__2": "",
                "(Intro) repost by participant__2": "",
                "(Promo) post by sponsor__2": "",
                "(Promo) repost by participant__2": "",
                "TW": "N/A",
                "(Main) post by sponsor__3": "",
                "(Main) repost by participant__3": "",
                "(Intro) post by sponsor__3": "",
                "(Intro) repost by participant__3": "",
                "(Promo) post by sponsor__3": "the link is above",
                "(Promo) repost by participant__3": "",
                "FB                3.8 Mio": "N/A",
                "(Main) post by sponsor__4": "",
                "(Main) repost by participant__4": "",
                "(Intro) post by sponsor__4": "",
                "(Intro) repost by participant__4": "",
                "(Promo) post by sponsor__4": "The link is above",
                "(Promo) repost by participant__4": "",
                "Contact": "whatsapp: +7 706 415 5169",
                "Manager": "Aziz",
                "Conditions/Comments": "$1k grtd + 50% prize pool ($200 paid)",
                "Country": "Kazakhstan"
            },
            {
                "#": 3,
                "Name": "Vlad Kim",
                "Dancer/DJ?": "Dancer / Group",
                "Agreement": "sent video",
                "Name_Official": "Vlad Kim",
                "Inrto/Description_Official": "",
                "top 1": "https://www.instagram.com/tv/CbsUlMVpBA5/?igshid=YmMyMTA2M2Y=",
                "top 2": "https://www.instagram.com/tv/CZj4nTLPHhu/?igshid=YmMyMTA2M2Y=",
                "top 3": "https://www.instagram.com/tv/Cd56QH5Jvfy/?igshid=YmMyMTA2M2Y=",
                "repost by sponsor": "TT:  https://www.tiktok.com/@1ath.studio/video/7111386953559444738?is_from_webapp=1&sender_device=pc&web_id=7111236788357891589 \nIG: https://www.instagram.com/reel/CfCaoQrDdjh/?utm_source=ig_web_copy_link \nYT:  https://youtube.com/shorts/zkoB6Mg6UqI?feature=share \nFB: https://www.facebook.com/watch/?v=714831186453865 \nTW: https://twitter.com/1athstudio/status/1538961025956990977?s=21&t=--GBgAAh7pICSplI0n1Zpg",
                "comment by participant": "",
                "Main Video/Track (gdrive)": "https://drive.google.com/drive/u/1/folders/1Lyd8tlgcxn8-qiDh5aTUVlnMZQA8j1oS",
                "Introduction Video (gdrive)": "",
                "IG                                                         4.6 Mio": "44k https://www.instagram.com/_vladkim/",
                "(Main) post by sponsor": "TT: https://www.tiktok.com/@1ath.studio/video/7112102946866777346?is_from_webapp=1&sender_device=pc&web_id=7112032987612562950 \nYT: https://youtu.be/iBv9YZqeCvE \nIG: https://www.instagram.com/tv/CfHSnRMLarU/?utm_source=ig_web_copy_link                                                                                                                                                                                                                                       \nTW: https://twitter.com/1ATHStudio/status/1539645181191790593 \nFB: https://fb.watch/dO-hjGgut1/",
                "(Main) repost by participant": "Asked to repost",
                "(Intro) post by sponsor": "YT: \nTT:\nFB:\nIG:\nTW:",
                "(Intro) repost by participant": "",
                "(Promo) post by sponsor": "The link is above",
                "(Promo) repost by participant": "Requested to disregard",
                "TT                       1.5Mio": "4K https://www.tiktok.com/@_vladkim",
                "(Main) post by sponsor__1": "",
                "(Main) repost by participant__1": "",
                "(Intro) post by sponsor__1": "",
                "(Intro) repost by participant__1": "",
                "(Promo) post by sponsor__1": "",
                "(Promo) repost by participant__1": "",
                "Youtube       1.1Mio": "N/A",
                "(Main) post by sponsor__2": "",
                "(Main) repost by participant__2": "",
                "(Intro) post by sponsor__2": "",
                "(Intro) repost by participant__2": "",
                "(Promo) post by sponsor__2": "",
                "(Promo) repost by participant__2": "",
                "TW": "N/A",
                "(Main) post by sponsor__3": "",
                "(Main) repost by participant__3": "",
                "(Intro) post by sponsor__3": "",
                "(Intro) repost by participant__3": "",
                "(Promo) post by sponsor__3": "the link is above",
                "(Promo) repost by participant__3": "",
                "FB                3.8 Mio": "N/A",
                "(Main) post by sponsor__4": "",
                "(Main) repost by participant__4": "",
                "(Intro) post by sponsor__4": "",
                "(Intro) repost by participant__4": "",
                "(Promo) post by sponsor__4": "The link is above",
                "(Promo) repost by participant__4": "",
                "Contact": "email",
                "Manager": "Aziz",
                "Conditions/Comments": "prize pool",
                "Country": "Russia"
            },
            {
                "#": 4,
                "Name": "Irakli Fifia",
                "Dancer/DJ?": "Dancer / Group",
                "Agreement": "sent video",
                "Name_Official": "Mess Dance Studio",
                "Inrto/Description_Official": "https://drive.google.com/drive/u/3/folders/1gWg2Cy5hAy1GP5iW-iff3NEST5hAPBM0",
                "top 1": "https://fb.watch/dwuDushDHh/",
                "top 2": "https://fb.watch/dwuGtHjwAK/",
                "top 3": "https://youtu.be/ZKn2MSiOnbA",
                "repost by sponsor": "TT: https://www.tiktok.com/foryou?_r=1&_t=8TDR2oTPUeI&is_from_webapp=v1&item_id=7109900343726656769#/@1ath.studio/video/7109900343726656769 \nIG https://www.instagram.com/reel/Ce4CifCvPpf/?igshid=YmMyMTA2M2Y%3D \nYT https://www.youtube.com/shorts/67BlxYPe-yM \nFB https://fb.watch/dHXyjYXoIA/ \nTW https://twitter.com/1ATHStudio/status/1537621908031930368",
                "comment by participant": "IG: https://www.instagram.com/tv/CfHD20fpoaa/?utm_source=ig_web_copy_link\nFB: https://www.facebook.com/watch/?v=1199214134211749&extid=NS-UNK-UNK-UNK-IOS_GK0T-GK1C&ref=sharing",
                "Main Video/Track (gdrive)": "https://drive.google.com/file/d/1y-6Ft3gKhsRWmH083BxaBtKE0FlB-TFS/view?usp=sharing",
                "Introduction Video (gdrive)": "https://drive.google.com/drive/u/3/folders/1gWg2Cy5hAy1GP5iW-iff3NEST5hAPBM0",
                "IG                                                         4.6 Mio": "5k https://www.instagram.com/messdancestudio/ 19.5K https://www.instagram.com/iraklififia1/?hl=en",
                "(Main) post by sponsor": "TT: https://www.tiktok.com/@1ath.studio/video/7112066324947275010?is_from_webapp=1&sender_device=pc&web_id=7112032987612562950 \nYT: https://youtu.be/wCNAtdPv3w8 \nIG: https://www.instagram.com/tv/CfHD20fpoaa/?utm_source=ig_web_copy_link                                                                                                                                                                                                                                 \nTW: https://twitter.com/1ATHStudio/status/1539612024103211008 \nFB: https://fb.watch/dOTmQ81dV2/",
                "(Main) repost by participant": "IG: https://www.instagram.com/stories/iraklififia1/2866362285613694772/?hl=en  \nFB: https://www.facebook.com/1ATH.Studio/videos/1199214134211749",
                "(Intro) post by sponsor": "FB: https://fb.watch/dQl1dLlgqo/ \nYT: https://youtu.be/BJi-CIBb0So \nTW https://twitter.com/1ATHStudio/status/1540016824078815232 \nIG: https://www.instagram.com/tv/CfJ7XFwNH--/?utm_source=ig_web_copy_link \nTT: https://www.tiktok.com/@1ath.studio/video/7112481643142728961?is_from_webapp=1&sender_device=pc&web_id=7094173033330034182",
                "(Intro) repost by participant": "Asked to repost",
                "(Promo) post by sponsor": "The link is above",
                "(Promo) repost by participant": "Requested to disregard",
                "TT                       1.5Mio": "7K https://www.tiktok.com/@messdancestudio 3K https://www.tiktok.com/@fifiairakli",
                "(Main) post by sponsor__1": "",
                "(Main) repost by participant__1": "",
                "(Intro) post by sponsor__1": "",
                "(Intro) repost by participant__1": "",
                "(Promo) post by sponsor__1": "",
                "(Promo) repost by participant__1": "",
                "Youtube       1.1Mio": "5K https://www.youtube.com/user/STREETDANCEFAMILY",
                "(Main) post by sponsor__2": "",
                "(Main) repost by participant__2": "",
                "(Intro) post by sponsor__2": "",
                "(Intro) repost by participant__2": "",
                "(Promo) post by sponsor__2": "",
                "(Promo) repost by participant__2": "",
                "TW": "N/A",
                "(Main) post by sponsor__3": "",
                "(Main) repost by participant__3": "",
                "(Intro) post by sponsor__3": "",
                "(Intro) repost by participant__3": "",
                "(Promo) post by sponsor__3": "the link is above",
                "(Promo) repost by participant__3": "",
                "FB                3.8 Mio": "43k https://www.facebook.com/MessDanceStudio/",
                "(Main) post by sponsor__4": "",
                "(Main) repost by participant__4": "",
                "(Intro) post by sponsor__4": "",
                "(Intro) repost by participant__4": "",
                "(Promo) post by sponsor__4": "The link is above",
                "(Promo) repost by participant__4": "",
                "Contact": "whatsapp",
                "Manager": "Aigerim",
                "Conditions/Comments": "prize pool",
                "Country": "Georgia"
            },
            {
                "#": 5,
                "Name": "Daulet Anarbekov",
                "Dancer/DJ?": "Dancer / Group",
                "Agreement": "sent video",
                "Name_Official": "Daulet Anarbekov",
                "Inrto/Description_Official": "",
                "top 1": "",
                "top 2": "",
                "top 3": "",
                "repost by sponsor": "IG https://www.instagram.com/reel/Ce5rN1Esdwa/?igshid=YmMyMTA2M2Y%3D \nIGS https://www.instagram.com/stories/1ath.studio/2862511879777961113/?utm_source=ig_story_item_share&igshid=YmMyMTA2M2Y%3D \nTW https://twitter.com/1athstudio/status/1537754467352838144?s=21&t=8iGI1wzttH4DhDuGWfxkSQ \nYt https://www.youtube.com/watch?v=_1fDG4m58kY \nFb https://www.facebook.com/watch/?v=689064368827598&extid=NS-UNK-UNK-UNK-IOS_GK0T-GK1C&ref=sharing \nTT https://www.tiktok.com/@1ath.studio/video/7110163128230464769?_t=8TEd8LvBGVd&_r=1",
                "comment by participant": "",
                "Main Video/Track (gdrive)": "https://drive.google.com/drive/u/3/folders/1Hd_sm-MHYr_ayAHloMnfX7A09SgpeKby",
                "Introduction Video (gdrive)": "",
                "IG                                                         4.6 Mio": "7k https://www.instagram.com/bboycreate/",
                "(Main) post by sponsor": "TT: https://www.tiktok.com/@1ath.studio/video/7112054477103860994?is_from_webapp=1&sender_device=pc&web_id=7112032987612562950 \nYT: https://www.youtube.com/watch?v=JI-oIBStPFI \nIG: https://www.instagram.com/tv/CfG_LLPO1PE/?utm_source=ig_web_copy_link                                                                                                                                                                                                                              \nTW: https://twitter.com/1ATHStudio/status/1539601486358929410 \nFB: https://fb.watch/dOQQVt5yD-/",
                "(Main) repost by participant": "Asked to repost IG: https://www.instagram.com/stories/bboycreate/2866310239008056418/",
                "(Intro) post by sponsor": "YT: \nTT:\nFB:\nIG:\nTW:",
                "(Intro) repost by participant": "",
                "(Promo) post by sponsor": "The link is above",
                "(Promo) repost by participant": "Requested to disregard",
                "TT                       1.5Mio": "0 https://www.tiktok.com/@bboycreate",
                "(Main) post by sponsor__1": "",
                "(Main) repost by participant__1": "",
                "(Intro) post by sponsor__1": "",
                "(Intro) repost by participant__1": "",
                "(Promo) post by sponsor__1": "",
                "(Promo) repost by participant__1": "",
                "Youtube       1.1Mio": "N/A",
                "(Main) post by sponsor__2": "",
                "(Main) repost by participant__2": "",
                "(Intro) post by sponsor__2": "",
                "(Intro) repost by participant__2": "",
                "(Promo) post by sponsor__2": "",
                "(Promo) repost by participant__2": "",
                "TW": "N/A",
                "(Main) post by sponsor__3": "",
                "(Main) repost by participant__3": "",
                "(Intro) post by sponsor__3": "",
                "(Intro) repost by participant__3": "",
                "(Promo) post by sponsor__3": "the link is above",
                "(Promo) repost by participant__3": "",
                "FB                3.8 Mio": "https://www.facebook.com/Bboy-Create-1073772302741182/",
                "(Main) post by sponsor__4": "",
                "(Main) repost by participant__4": "",
                "(Intro) post by sponsor__4": "",
                "(Intro) repost by participant__4": "",
                "(Promo) post by sponsor__4": "The link is above",
                "(Promo) repost by participant__4": "",
                "Contact": "whatsapp",
                "Manager": "Aziz",
                "Conditions/Comments": "prize pool",
                "Country": "Kazakhstan"
            },
            {
                "#": 6,
                "Name": "Jan Voinov",
                "Dancer/DJ?": "Dancer / Group",
                "Agreement": "sent video",
                "Name_Official": "Jan Voinov",
                "Inrto/Description_Official": "",
                "top 1": "",
                "top 2": "",
                "top 3": "",
                "repost by sponsor": "TT: https://vt.tiktok.com/ZSdvMcsXB/?k=1 \nIG stories : https://instagram.com/stories/1ath.studio/2863204513353113922?utm_source=ig_story_item_share&igshid=YmMyMTA2M2Y=  \nIG: https://www.instagram.com/reel/Ce8Fjm7Mw62/?igshid=YmMyMTA2M2Y=  \nYT: https://youtube.com/shorts/G33vDRKKb3g?feature=share  \nTW: https://twitter.com/1athstudio/status/1538126208956878853?s=21&t=tshld1DoW2IOVta-XnyOng \nFB: https://fb.watch/dJtunsbOms/",
                "comment by participant": "",
                "Main Video/Track (gdrive)": "https://drive.google.com/drive/u/3/folders/1LxB15L8iYLxML4ms3LoE2Fqb2cbfFg0U",
                "Introduction Video (gdrive)": "https://drive.google.com/drive/u/1/folders/1oggTyGDeo5ZsOxhpjjdo9D8uv1wqBF2x",
                "IG                                                         4.6 Mio": "217k https://www.instagram.com/jan_voinov/",
                "(Main) post by sponsor": "TT: https://www.tiktok.com/@1ath.studio/video/7112114046933011713?is_from_webapp=1&sender_device=pc&web_id=7112032987612562950 \nYT: https://youtu.be/_5Rg673rfqI \nIG: https://www.instagram.com/tv/CfHYosDspx4/?utm_source=ig_web_copy_link                                                                                                                                                                                                      \nTW: https://twitter.com/1ATHStudio/status/1539658116497022976 \nFB: https://fb.watch/dP1wQb9_EH/",
                "(Main) repost by participant": "Asked to repost IG: https://www.instagram.com/stories/jan_voinov/2866482524046019148/4",
                "(Intro) post by sponsor": "FB: https://fb.watch/dQnmxEmr9u  \nIG https://www.instagram.com/tv/CfKBQbapBAn/?utm_source=ig_web_copy_link \nYT https://youtu.be/7Z15USxOBDo \nTT https://www.tiktok.com/@1ath.studio/video/7112494681300258050?is_from_webapp=1&sender_device=pc&web_id=7094173033330034182 \nTW https://twitter.com/1ATHStudio/status/1540029151033311237",
                "(Intro) repost by participant": "Asked to repost",
                "(Promo) post by sponsor": "The link is above",
                "(Promo) repost by participant": "Requested to disregard",
                "TT                       1.5Mio": "https://www.tiktok.com/@janvoinov2020",
                "(Main) post by sponsor__1": "",
                "(Main) repost by participant__1": "",
                "(Intro) post by sponsor__1": "",
                "(Intro) repost by participant__1": "",
                "(Promo) post by sponsor__1": "",
                "(Promo) repost by participant__1": "",
                "Youtube       1.1Mio": "N/A",
                "(Main) post by sponsor__2": "",
                "(Main) repost by participant__2": "",
                "(Intro) post by sponsor__2": "",
                "(Intro) repost by participant__2": "",
                "(Promo) post by sponsor__2": "",
                "(Promo) repost by participant__2": "",
                "TW": "https://twitter.com/janvoinov",
                "(Main) post by sponsor__3": "",
                "(Main) repost by participant__3": "",
                "(Intro) post by sponsor__3": "",
                "(Intro) repost by participant__3": "",
                "(Promo) post by sponsor__3": "the link is above",
                "(Promo) repost by participant__3": "",
                "FB                3.8 Mio": "3K https://www.facebook.com/Jan.voinov",
                "(Main) post by sponsor__4": "",
                "(Main) repost by participant__4": "",
                "(Intro) post by sponsor__4": "",
                "(Intro) repost by participant__4": "",
                "(Promo) post by sponsor__4": "The link is above",
                "(Promo) repost by participant__4": "",
                "Contact": "whatsapp",
                "Manager": "Aziz",
                "Conditions/Comments": "prize pool",
                "Country": "Kyrgyzstan"
            },
            {
                "#": 7,
                "Name": "DJ Tommy",
                "Dancer/DJ?": "DJ",
                "Agreement": "pinged 13",
                "Name_Official": "",
                "Inrto/Description_Official": "",
                "top 1": "",
                "top 2": "",
                "top 3": "",
                "repost by sponsor": "",
                "comment by participant": "",
                "Main Video/Track (gdrive)": "",
                "Introduction Video (gdrive)": "",
                "IG                                                         4.6 Mio": "61k https://www.instagram.com/djtommy_il/",
                "(Main) post by sponsor": "",
                "(Main) repost by participant": "",
                "(Intro) post by sponsor": "",
                "(Intro) repost by participant": "",
                "(Promo) post by sponsor": "The link is above",
                "(Promo) repost by participant": "",
                "TT                       1.5Mio": "",
                "(Main) post by sponsor__1": "",
                "(Main) repost by participant__1": "",
                "(Intro) post by sponsor__1": "",
                "(Intro) repost by participant__1": "",
                "(Promo) post by sponsor__1": "",
                "(Promo) repost by participant__1": "",
                "Youtube       1.1Mio": "",
                "(Main) post by sponsor__2": "",
                "(Main) repost by participant__2": "",
                "(Intro) post by sponsor__2": "",
                "(Intro) repost by participant__2": "",
                "(Promo) post by sponsor__2": "",
                "(Promo) repost by participant__2": "",
                "TW": "",
                "(Main) post by sponsor__3": "",
                "(Main) repost by participant__3": "",
                "(Intro) post by sponsor__3": "",
                "(Intro) repost by participant__3": "",
                "(Promo) post by sponsor__3": "the link is above",
                "(Promo) repost by participant__3": "",
                "FB                3.8 Mio": "",
                "(Main) post by sponsor__4": "",
                "(Main) repost by participant__4": "",
                "(Intro) post by sponsor__4": "",
                "(Intro) repost by participant__4": "",
                "(Promo) post by sponsor__4": "The link is above",
                "(Promo) repost by participant__4": "",
                "Contact": "whatsapp",
                "Manager": "Aziz",
                "Conditions/Comments": "prize pool",
                "Country": "Israel"
            },
            {
                "#": 8,
                "Name": "GregB",
                "Dancer/DJ?": "DJ",
                "Agreement": "sent track",
                "Name_Official": "Greg beat",
                "Inrto/Description_Official": "",
                "top 1": "https://www.instagram.com/p/CY6zBNvK-It/",
                "top 2": "https://www.instagram.com/p/CaU9xIEIsyo/",
                "top 3": "https://www.instagram.com/p/CYWv5v_q1Za/",
                "repost by sponsor": "IG https://www.instagram.com/reel/CfEeQwvjgpf/?utm_source=ig_web_copy_link \nTT https://www.tiktok.com/@1ath.studio/video/7111689064570572034?is_from_webapp=1&sender_device=pc&web_id=7111687643494647301 \nTW https://twitter.com/1athstudio/status/1539247615270952967?s=21&t=DPKH-i7j40YPY_Ir_RH-cg \nYT https://youtube.com/shorts/25zjJ981tdY?feature=share \nFB https://fb.watch/dNyF1uiaf9",
                "comment by participant": "IG: https://www.instagram.com/reel/CfEeQwvjgpf/?utm_source=ig_web_copy_link",
                "Main Video/Track (gdrive)": "https://drive.google.com/drive/u/1/folders/1XWArvl9cBxgqd5M9Ujp5pXVv5z8YEmHf",
                "Introduction Video (gdrive)": "https://drive.google.com/drive/u/0/folders/1XWArvl9cBxgqd5M9Ujp5pXVv5z8YEmHf",
                "IG                                                         4.6 Mio": "10k https://www.instagram.com/greg_beat/",
                "(Main) post by sponsor": "TT: https://www.tiktok.com/@1ath.studio/video/7112070528810159362?is_from_webapp=1&sender_device=pc&web_id=7112032987612562950 \nYT: https://youtu.be/Xo_Zl_jZFOI \nIG: https://www.instagram.com/tv/CfHFe7DrbYY/?utm_source=ig_web_copy_link                                                                                                                                                                                        \nTW: https://twitter.com/1ATHStudio/status/1539640062228705280/photo/1 \nFB: https://fb.watch/dOYLa3Ro71/",
                "(Main) repost by participant": "Asked to repost",
                "(Intro) post by sponsor": "YT: https://youtu.be/x9mEOLxF9fc \nTT: https://www.tiktok.com/@1ath.studio/video/7114241364988153090?is_from_webapp=1&sender_device=pc&web_id=7113634897173022214 \nFB: https://fb.watch/dWBREmXJKG/ \nIG: https://www.instagram.com/tv/CfWKBZ-pIJf/?utm_source=ig_web_copy_link \nTW: https://twitter.com/1ATHStudio/status/1541737376762023936 ",
                "(Intro) repost by participant": "",
                "(Promo) post by sponsor": "The link is above",
                "(Promo) repost by participant": "Requested to disregard",
                "TT                       1.5Mio": "N/A",
                "(Main) post by sponsor__1": "",
                "(Main) repost by participant__1": "",
                "(Intro) post by sponsor__1": "",
                "(Intro) repost by participant__1": "",
                "(Promo) post by sponsor__1": "",
                "(Promo) repost by participant__1": "",
                "Youtube       1.1Mio": "https://www.youtube.com/channel/UCgYt2FhXr4gbW_1EKj1lW2g",
                "(Main) post by sponsor__2": "",
                "(Main) repost by participant__2": "",
                "(Intro) post by sponsor__2": "",
                "(Intro) repost by participant__2": "",
                "(Promo) post by sponsor__2": "",
                "(Promo) repost by participant__2": "",
                "TW": "N/A",
                "(Main) post by sponsor__3": "",
                "(Main) repost by participant__3": "",
                "(Intro) post by sponsor__3": "",
                "(Intro) repost by participant__3": "",
                "(Promo) post by sponsor__3": "the link is above",
                "(Promo) repost by participant__3": "",
                "FB                3.8 Mio": "https://www.facebook.com/greg_beat-101887921382139",
                "(Main) post by sponsor__4": "",
                "(Main) repost by participant__4": "",
                "(Intro) post by sponsor__4": "",
                "(Intro) repost by participant__4": "",
                "(Promo) post by sponsor__4": "The link is above",
                "(Promo) repost by participant__4": "",
                "Contact": "email",
                "Manager": "Aziz",
                "Conditions/Comments": "prize pool",
                "Country": "France"
            },
            {
                "#": 9,
                "Name": "Tilan",
                "Dancer/DJ?": "Dancer",
                "Agreement": "pinged 13, has another big project so declined ours",
                "Name_Official": "",
                "Inrto/Description_Official": "",
                "top 1": "",
                "top 2": "",
                "top 3": "",
                "repost by sponsor": "",
                "comment by participant": "",
                "Main Video/Track (gdrive)": "",
                "Introduction Video (gdrive)": "",
                "IG                                                         4.6 Mio": "21k https://www.instagram.com/tilan_sadyrbaev/",
                "(Main) post by sponsor": "",
                "(Main) repost by participant": "",
                "(Intro) post by sponsor": "",
                "(Intro) repost by participant": "",
                "(Promo) post by sponsor": "The link is above",
                "(Promo) repost by participant": "",
                "TT                       1.5Mio": "",
                "(Main) post by sponsor__1": "",
                "(Main) repost by participant__1": "",
                "(Intro) post by sponsor__1": "",
                "(Intro) repost by participant__1": "",
                "(Promo) post by sponsor__1": "",
                "(Promo) repost by participant__1": "",
                "Youtube       1.1Mio": "6k https://www.youtube.com/c/TilanSadyrbaev",
                "(Main) post by sponsor__2": "",
                "(Main) repost by participant__2": "",
                "(Intro) post by sponsor__2": "",
                "(Intro) repost by participant__2": "",
                "(Promo) post by sponsor__2": "",
                "(Promo) repost by participant__2": "",
                "TW": "",
                "(Main) post by sponsor__3": "",
                "(Main) repost by participant__3": "",
                "(Intro) post by sponsor__3": "",
                "(Intro) repost by participant__3": "",
                "(Promo) post by sponsor__3": "the link is above",
                "(Promo) repost by participant__3": "",
                "FB                3.8 Mio": "",
                "(Main) post by sponsor__4": "",
                "(Main) repost by participant__4": "",
                "(Intro) post by sponsor__4": "",
                "(Intro) repost by participant__4": "",
                "(Promo) post by sponsor__4": "The link is above",
                "(Promo) repost by participant__4": "",
                "Contact": "whatsapp",
                "Manager": "Aziz",
                "Conditions/Comments": "prize pool",
                "Country": "Kazakhstan"
            },
            {
                "#": 10,
                "Name": "Arden Formento",
                "Dancer/DJ?": "DJ",
                "Agreement": "pinged 13, not able to fix the DAW and participate",
                "Name_Official": "",
                "Inrto/Description_Official": "",
                "top 1": "",
                "top 2": "",
                "top 3": "",
                "repost by sponsor": "",
                "comment by participant": "",
                "Main Video/Track (gdrive)": "",
                "Introduction Video (gdrive)": "",
                "IG                                                         4.6 Mio": "1.7k https://www.instagram.com/ardenformento_/",
                "(Main) post by sponsor": "",
                "(Main) repost by participant": "",
                "(Intro) post by sponsor": "",
                "(Intro) repost by participant": "",
                "(Promo) post by sponsor": "The link is above",
                "(Promo) repost by participant": "",
                "TT                       1.5Mio": "0 https://www.tiktok.com/@itsardenflojo",
                "(Main) post by sponsor__1": "",
                "(Main) repost by participant__1": "",
                "(Intro) post by sponsor__1": "",
                "(Intro) repost by participant__1": "",
                "(Promo) post by sponsor__1": "",
                "(Promo) repost by participant__1": "",
                "Youtube       1.1Mio": "0 https://www.youtube.com/channel/UClS7mBZIC0sINia895aiyLQ",
                "(Main) post by sponsor__2": "",
                "(Main) repost by participant__2": "",
                "(Intro) post by sponsor__2": "",
                "(Intro) repost by participant__2": "",
                "(Promo) post by sponsor__2": "",
                "(Promo) repost by participant__2": "",
                "TW": "https://twitter.com/ardenformento_",
                "(Main) post by sponsor__3": "",
                "(Main) repost by participant__3": "",
                "(Intro) post by sponsor__3": "",
                "(Intro) repost by participant__3": "",
                "(Promo) post by sponsor__3": "the link is above",
                "(Promo) repost by participant__3": "",
                "FB                3.8 Mio": "",
                "(Main) post by sponsor__4": "",
                "(Main) repost by participant__4": "",
                "(Intro) post by sponsor__4": "",
                "(Intro) repost by participant__4": "",
                "(Promo) post by sponsor__4": "The link is above",
                "(Promo) repost by participant__4": "",
                "Contact": "email",
                "Manager": "Aziz",
                "Conditions/Comments": "prize pool",
                "Country": "Phillipines"
            },
            {
                "#": 11,
                "Name": "Dilya (Unidance)",
                "Dancer/DJ?": "Dancer / Group",
                "Agreement": "sent video",
                "Name_Official": "Uniqueens Dance Team",
                "Inrto/Description_Official": "we are a group of 7 people. We have been dancing for over 2-3 years. dancing is our life, and we are happy to take part in the project",
                "top 1": "https://www.instagram.com/p/CZEB9hXs2Xf/?igshid=YmMyMTA2M2Y=",
                "top 2": "https://www.instagram.com/p/CQLzGMnFs-O/?igshid=YmMyMTA2M2Y=",
                "top 3": "https://www.instagram.com/p/CQLzGMnFs-O/?igshid=YmMyMTA2M2Y=",
                "repost by sponsor": "",
                "comment by participant": "",
                "Main Video/Track (gdrive)": "https://drive.google.com/drive/u/1/folders/1mcetDdZgTgn3lNmDAM-czacEQCACdYkI",
                "Introduction Video (gdrive)": "https://drive.google.com/drive/u/1/folders/1SemZjKDZqpQmGQu0YaUjLkeuaWfOVbvn",
                "IG                                                         4.6 Mio": "18k https://www.instagram.com/unidance_kazakhstan/?hl=en",
                "(Main) post by sponsor": "TT: https://www.tiktok.com/@1ath.studio/video/7112100766151757057?is_from_webapp=1&sender_device=pc&web_id=7112032987612562950 \nYT: https://youtu.be/bbIsfxQYh7M \nIG: https://www.instagram.com/tv/CfHSEN9spim/?utm_source=ig_web_copy_link                                                                                                                                                                                    \nTW: https://twitter.com/1ATHStudio/status/1539643015429603328 \nFB: https://fb.watch/dO_qgn9Ung/",
                "(Main) repost by participant": "Asked to repost",
                "(Intro) post by sponsor": "YT: https://youtu.be/JGBOb8IofIk \nFB: https://fb.watch/dSPH3pWDFg/  \nTT:  https://www.tiktok.com/@1ath.studio/video/7113174784673910017?  \nIG https://www.instagram.com/tv/CfOtn6zNXaB/?utm_source=ig_web_copy_link  \nTW https://twitter.com/1ATHStudio/status/1540688673905070080",
                "(Intro) repost by participant": "Asked to repost",
                "(Promo) post by sponsor": "The link is above",
                "(Promo) repost by participant": "Requested to disregard",
                "TT                       1.5Mio": "64k https://www.tiktok.com/@ddixvibes",
                "(Main) post by sponsor__1": "",
                "(Main) repost by participant__1": "",
                "(Intro) post by sponsor__1": "",
                "(Intro) repost by participant__1": "",
                "(Promo) post by sponsor__1": "",
                "(Promo) repost by participant__1": "",
                "Youtube       1.1Mio": "1.3K https://www.youtube.com/c/UnidanceKazakhstan",
                "(Main) post by sponsor__2": "",
                "(Main) repost by participant__2": "",
                "(Intro) post by sponsor__2": "",
                "(Intro) repost by participant__2": "",
                "(Promo) post by sponsor__2": "",
                "(Promo) repost by participant__2": "",
                "TW": "N/A",
                "(Main) post by sponsor__3": "",
                "(Main) repost by participant__3": "",
                "(Intro) post by sponsor__3": "",
                "(Intro) repost by participant__3": "",
                "(Promo) post by sponsor__3": "the link is above",
                "(Promo) repost by participant__3": "",
                "FB                3.8 Mio": "https://www.facebook.com/unidance.kz",
                "(Main) post by sponsor__4": "",
                "(Main) repost by participant__4": "",
                "(Intro) post by sponsor__4": "",
                "(Intro) repost by participant__4": "",
                "(Promo) post by sponsor__4": "The link is above",
                "(Promo) repost by participant__4": "",
                "Contact": "whatsapp",
                "Manager": "Aziz",
                "Conditions/Comments": "prize pool",
                "Country": "Kazakhstan"
            },
            {
                "#": 12,
                "Name": "Madina",
                "Dancer/DJ?": "Dancer",
                "Agreement": "NOGO expensive",
                "Name_Official": "",
                "Inrto/Description_Official": "",
                "top 1": "",
                "top 2": "",
                "top 3": "",
                "repost by sponsor": "",
                "comment by participant": "",
                "Main Video/Track (gdrive)": "",
                "Introduction Video (gdrive)": "",
                "IG                                                         4.6 Mio": "80k https://www.instagram.com/iam.madiina/",
                "(Main) post by sponsor": "",
                "(Main) repost by participant": "",
                "(Intro) post by sponsor": "",
                "(Intro) repost by participant": "",
                "(Promo) post by sponsor": "The link is above",
                "(Promo) repost by participant": "",
                "TT                       1.5Mio": "",
                "(Main) post by sponsor__1": "",
                "(Main) repost by participant__1": "",
                "(Intro) post by sponsor__1": "",
                "(Intro) repost by participant__1": "",
                "(Promo) post by sponsor__1": "",
                "(Promo) repost by participant__1": "",
                "Youtube       1.1Mio": "5.5K https://www.youtube.com/user/madinnadin",
                "(Main) post by sponsor__2": "",
                "(Main) repost by participant__2": "",
                "(Intro) post by sponsor__2": "",
                "(Intro) repost by participant__2": "",
                "(Promo) post by sponsor__2": "",
                "(Promo) repost by participant__2": "",
                "TW": "N/A",
                "(Main) post by sponsor__3": "",
                "(Main) repost by participant__3": "",
                "(Intro) post by sponsor__3": "",
                "(Intro) repost by participant__3": "",
                "(Promo) post by sponsor__3": "the link is above",
                "(Promo) repost by participant__3": "",
                "FB                3.8 Mio": "1.2K https://www.facebook.com/madina.beisekeeva",
                "(Main) post by sponsor__4": "",
                "(Main) repost by participant__4": "",
                "(Intro) post by sponsor__4": "",
                "(Intro) repost by participant__4": "",
                "(Promo) post by sponsor__4": "The link is above",
                "(Promo) repost by participant__4": "",
                "Contact": "email: madinabookings@gmail.com",
                "Manager": "Aziz",
                "Conditions/Comments": "Agreed grtd $1000 + full prize pool if wins.",
                "Country": "USA"
            },
            {
                "#": 13,
                "Name": "Karol Mental",
                "Dancer/DJ?": "Dancer",
                "Agreement": "sent video",
                "Name_Official": "Karol Mental",
                "Inrto/Description_Official": "https://drive.google.com/drive/u/3/folders/1z2H8DQckuDl3jgQ_caySV1ejVBGPHeiB",
                "top 1": "https://www.youtube.com/watch?v=0x_d-mEIAcg&ab_channel=KarolMental",
                "top 2": "https://www.youtube.com/watch?v=iOTk2ERxqNA&ab_channel=KarolMental",
                "top 3": "https://www.youtube.com/watch?v=AWMjfObDBL4&ab_channel=KarolMental",
                "repost by sponsor": "IG https://www.instagram.com/reel/Ce37cTjDVMs/?utm_source=ig_web_copy_link \nTT https://www.tiktok.com/@1ath.studio/video/7109869815094988034?_t=8TDM06gSxs6&_r=1 \nTW https://twitter.com/1athstudio/status/1537507594251665410?s=21&t=BZsImbm6tiTCggmXOWvlGQ \nYT https://www.youtube.com/shorts/rG2EZnQQ1n0 \nFB https://www.facebook.com/watch/?extid=NS-UNK-UNK-UNK-IOS_GK0T-GK1C&v=1034079850550873",
                "comment by participant": "IG: https://www.instagram.com/p/Ce37cTjDVMs/\nYT: https://www.youtube.com/shorts/rG2EZnQQ1n0?&ab_channel=NekAoofficial\nFB: https://www.facebook.com/1ATH.Studio/videos/1034079850550873",
                "Main Video/Track (gdrive)": "https://drive.google.com/drive/u/1/folders/1gwDDXh2x99YXH0cs-jE5aMdLtlKBgKJ0",
                "Introduction Video (gdrive)": "https://drive.google.com/drive/u/1/folders/1z2H8DQckuDl3jgQ_caySV1ejVBGPHeiB",
                "IG                                                         4.6 Mio": "11k https://www.instagram.com/karolmental/",
                "(Main) post by sponsor": "TT: https://www.tiktok.com/@1ath.studio/video/7112079477596884225?is_from_webapp=1&sender_device=pc&web_id=7112032987612562950 \nYT: https://www.youtube.com/watch?v=z3i2F2qxGvw \nIG: https://www.instagram.com/p/CfHMBh5vSU7/                                                                                                                                                                                   \nTW: https://twitter.com/1ATHStudio/status/1539630729797181441 \nFB: https://fb.watch/dO_N127Pu0/",
                "(Main) repost by participant": "Asked to repost",
                "(Intro) post by sponsor": "YT: https://youtu.be/YfgrcwUxSAs \nTT: https://www.tiktok.com/@1ath.studio/video/7113948245730151681?is_from_webapp=1&sender_device=pc&web_id=7113634897173022214 \nFB: https://fb.watch/dVzt9c8VwK/ \nIG: https://www.instagram.com/tv/CfUG6QErHa0/?utm_source=ig_web_copy_link \nTW: https://twitter.com/1ATHStudio/status/1541448802300723200",
                "(Intro) repost by participant": "",
                "(Promo) post by sponsor": "The link is above",
                "(Promo) repost by participant": "Requested to disregard",
                "TT                       1.5Mio": "N/A",
                "(Main) post by sponsor__1": "",
                "(Main) repost by participant__1": "",
                "(Intro) post by sponsor__1": "",
                "(Intro) repost by participant__1": "",
                "(Promo) post by sponsor__1": "",
                "(Promo) repost by participant__1": "",
                "Youtube       1.1Mio": "https://www.youtube.com/channel/UCzbtw122DZ6-udtUJBtouww",
                "(Main) post by sponsor__2": "",
                "(Main) repost by participant__2": "",
                "(Intro) post by sponsor__2": "",
                "(Intro) repost by participant__2": "",
                "(Promo) post by sponsor__2": "",
                "(Promo) repost by participant__2": "",
                "TW": "N/A",
                "(Main) post by sponsor__3": "",
                "(Main) repost by participant__3": "",
                "(Intro) post by sponsor__3": "",
                "(Intro) repost by participant__3": "",
                "(Promo) post by sponsor__3": "the link is above",
                "(Promo) repost by participant__3": "",
                "FB                3.8 Mio": "2.2K https://www.facebook.com/karolmental",
                "(Main) post by sponsor__4": "",
                "(Main) repost by participant__4": "",
                "(Intro) post by sponsor__4": "",
                "(Intro) repost by participant__4": "",
                "(Promo) post by sponsor__4": "The link is above",
                "(Promo) repost by participant__4": "",
                "Contact": "karolmentalofficial@gmail.com",
                "Manager": "Aziz",
                "Conditions/Comments": "Agreed on 500$ + prize pool (not yet paid)",
                "Country": "Poland"
            },
            {
                "#": 14,
                "Name": "Valerie",
                "Dancer/DJ?": "DJ",
                "Agreement": "pinged 13, has busy time and lot of work so will not be able to participate",
                "Name_Official": "",
                "Inrto/Description_Official": "",
                "top 1": "",
                "top 2": "",
                "top 3": "",
                "repost by sponsor": "",
                "comment by participant": "",
                "Main Video/Track (gdrive)": "",
                "Introduction Video (gdrive)": "",
                "IG                                                         4.6 Mio": "1.6k https://www.instagram.com/vaaleriejane/",
                "(Main) post by sponsor": "",
                "(Main) repost by participant": "",
                "(Intro) post by sponsor": "",
                "(Intro) repost by participant": "",
                "(Promo) post by sponsor": "The link is above",
                "(Promo) repost by participant": "",
                "TT                       1.5Mio": "N/A",
                "(Main) post by sponsor__1": "",
                "(Main) repost by participant__1": "",
                "(Intro) post by sponsor__1": "",
                "(Intro) repost by participant__1": "",
                "(Promo) post by sponsor__1": "",
                "(Promo) repost by participant__1": "",
                "Youtube       1.1Mio": "",
                "(Main) post by sponsor__2": "",
                "(Main) repost by participant__2": "",
                "(Intro) post by sponsor__2": "",
                "(Intro) repost by participant__2": "",
                "(Promo) post by sponsor__2": "",
                "(Promo) repost by participant__2": "",
                "TW": "",
                "(Main) post by sponsor__3": "",
                "(Main) repost by participant__3": "",
                "(Intro) post by sponsor__3": "",
                "(Intro) repost by participant__3": "",
                "(Promo) post by sponsor__3": "the link is above",
                "(Promo) repost by participant__3": "",
                "FB                3.8 Mio": "",
                "(Main) post by sponsor__4": "",
                "(Main) repost by participant__4": "",
                "(Intro) post by sponsor__4": "",
                "(Intro) repost by participant__4": "",
                "(Promo) post by sponsor__4": "The link is above",
                "(Promo) repost by participant__4": "",
                "Contact": "email: valeriejane@cabanalibre.com",
                "Manager": "Aziz",
                "Conditions/Comments": "prize pool",
                "Country": "Spain"
            },
            {
                "#": 15,
                "Name": "Densley Carolissen",
                "Dancer/DJ?": "Dancer",
                "Agreement": "sent video",
                "Name_Official": "Densley Carolissen",
                "Inrto/Description_Official": "",
                "top 1": "",
                "top 2": "",
                "top 3": "",
                "repost by sponsor": "TT: https://vt.tiktok.com/ZSd3YFYkL/?k=1 \nIGR: https://www.instagram.com/reel/CfGZW7FJ6DX/?igshid=YmMyMTA2M2Y=  \nIG stories: https://instagram.com/stories/1ath.studio/2866092787902347973?utm_source=ig_story_item_share&igshid=YmMyMTA2M2Y= \nTW: https://twitter.com/1athstudio/status/1539526526617649158?s=21&t=spfV0jr0YAxKfg6bSHEHcQ  \nFB: https://fb.watch/dOzpORtpJm/ \nYTS: https://www.youtube.com/shorts/r3M1fmJ8ppU",
                "comment by participant": "YT: https://www.youtube.com/watch?v=VO_qvTuYMhs&ab_channel=1ATH.Studio\nIG: https://www.instagram.com/reel/CfGZW7FJ6DX/?igshid=YmMyMTA2M2Y%3D\nTT: https://www.tiktok.com/@1ath.studio/video/7111955350349155586?is_copy_url=1&is_from_webapp=v1",
                "Main Video/Track (gdrive)": "https://drive.google.com/drive/u/1/folders/1agzJoohEn8Si_12z_08_efLkoYCiNMJ8",
                "Introduction Video (gdrive)": "https://drive.google.com/drive/folders/1drZDb9JcEOvSfKEMpndinf0myGpwUau7",
                "IG                                                         4.6 Mio": "12k https://www.instagram.com/lyricaldeezy/",
                "(Main) post by sponsor": "TT: https://www.tiktok.com/@1ath.studio/video/7112110666130918658?is_from_webapp=1&sender_device=pc \nYT: https://youtu.be/VO_qvTuYMhs \nIG: https://www.instagram.com/tv/CfHX-2OMf96/?utm_source=ig_web_copy_link                                                                                                                                                                            \nTW: https://twitter.com/1ATHStudio/status/1539655927607205888 \nFB: https://fb.watch/dP102O07tj/",
                "(Main) repost by participant": "Asked to repost IG: https://www.instagram.com/stories/lyricaldeezy/2866118182254823217/",
                "(Intro) post by sponsor": "YT: https://youtu.be/xiqe8v_Mw-g \nTT: https://www.tiktok.com/@1ath.studio/video/7113511313866755330?is_from_webapp=1&sender_device=pc&web_id=7094173033330034182 \nFB: https://fb.watch/dU0F6R1cfF/ \nIG: https://www.instagram.com/tv/CfRGzHrjW-K/?utm_source=ig_web_copy_link \nTW: https://twitter.com/1ATHStudio/status/1541026907008925701?s=20&t=cnkr8tQX0a4HMUqVhUAGhQ",
                "(Intro) repost by participant": "Asked to repost",
                "(Promo) post by sponsor": "The link is above",
                "(Promo) repost by participant": "Requested to disregard",
                "TT                       1.5Mio": "280k https://www.tiktok.com/@lyricaldeezy",
                "(Main) post by sponsor__1": "",
                "(Main) repost by participant__1": "",
                "(Intro) post by sponsor__1": "",
                "(Intro) repost by participant__1": "",
                "(Promo) post by sponsor__1": "",
                "(Promo) repost by participant__1": "",
                "Youtube       1.1Mio": "1k https://www.youtube.com/channel/UC0MipvERTF6DNgtmMzSjnGw",
                "(Main) post by sponsor__2": "",
                "(Main) repost by participant__2": "",
                "(Intro) post by sponsor__2": "",
                "(Intro) repost by participant__2": "",
                "(Promo) post by sponsor__2": "",
                "(Promo) repost by participant__2": "",
                "TW": "https://twitter.com/lyricaldeezy",
                "(Main) post by sponsor__3": "",
                "(Main) repost by participant__3": "",
                "(Intro) post by sponsor__3": "",
                "(Intro) repost by participant__3": "",
                "(Promo) post by sponsor__3": "the link is above",
                "(Promo) repost by participant__3": "",
                "FB                3.8 Mio": "https://www.facebook.com/DensleyCarolissenOfficial/",
                "(Main) post by sponsor__4": "",
                "(Main) repost by participant__4": "",
                "(Intro) post by sponsor__4": "",
                "(Intro) repost by participant__4": "",
                "(Promo) post by sponsor__4": "The link is above",
                "(Promo) repost by participant__4": "",
                "Contact": "email: lyricaldeezy.info@gmail.com\nwhatsapp: +27 84 318 0441",
                "Manager": "Aziz",
                "Conditions/Comments": "prize pool",
                "Country": "South Africa"
            },
            {
                "#": 16,
                "Name": "DJ Stale / Brian Kohl",
                "Dancer/DJ?": "DJ",
                "Agreement": "pinged 21, I don't think I'm gonna have enough time but I will keep trying",
                "Name_Official": "",
                "Inrto/Description_Official": "",
                "top 1": "",
                "top 2": "",
                "top 3": "",
                "repost by sponsor": "",
                "comment by participant": "",
                "Main Video/Track (gdrive)": "",
                "Introduction Video (gdrive)": "",
                "IG                                                         4.6 Mio": "1k https://www.instagram.com/brianscustomtackle/",
                "(Main) post by sponsor": "",
                "(Main) repost by participant": "",
                "(Intro) post by sponsor": "",
                "(Intro) repost by participant": "",
                "(Promo) post by sponsor": "The link is above",
                "(Promo) repost by participant": "",
                "TT                       1.5Mio": "0 https://www.tiktok.com/@brianscustomtackle",
                "(Main) post by sponsor__1": "",
                "(Main) repost by participant__1": "",
                "(Intro) post by sponsor__1": "",
                "(Intro) repost by participant__1": "",
                "(Promo) post by sponsor__1": "",
                "(Promo) repost by participant__1": "",
                "Youtube       1.1Mio": "2k https://www.youtube.com/c/BriansCustomTackle",
                "(Main) post by sponsor__2": "",
                "(Main) repost by participant__2": "",
                "(Intro) post by sponsor__2": "",
                "(Intro) repost by participant__2": "",
                "(Promo) post by sponsor__2": "",
                "(Promo) repost by participant__2": "",
                "TW": "N/A",
                "(Main) post by sponsor__3": "",
                "(Main) repost by participant__3": "",
                "(Intro) post by sponsor__3": "",
                "(Intro) repost by participant__3": "",
                "(Promo) post by sponsor__3": "the link is above",
                "(Promo) repost by participant__3": "",
                "FB                3.8 Mio": "N/A",
                "(Main) post by sponsor__4": "",
                "(Main) repost by participant__4": "",
                "(Intro) post by sponsor__4": "",
                "(Intro) repost by participant__4": "",
                "(Promo) post by sponsor__4": "The link is above",
                "(Promo) repost by participant__4": "",
                "Contact": "email: briankohl89@gmail.com",
                "Manager": "Aziz",
                "Conditions/Comments": "prize pool",
                "Country": "US"
            },
            {
                "#": 17,
                "Name": "Eleven Jack",
                "Dancer/DJ?": "DJ",
                "Agreement": "pinged 20,  I read everything well thank you very much for sending me the audio.  I'm going to do the remix, when is it due?",
                "Name_Official": "",
                "Inrto/Description_Official": "",
                "top 1": "-",
                "top 2": "-",
                "top 3": "-",
                "repost by sponsor": "-",
                "comment by participant": "-",
                "Main Video/Track (gdrive)": "",
                "Introduction Video (gdrive)": "",
                "IG                                                         4.6 Mio": "0 https://www.instagram.com/elevenjackmusic/",
                "(Main) post by sponsor": "",
                "(Main) repost by participant": "",
                "(Intro) post by sponsor": "",
                "(Intro) repost by participant": "",
                "(Promo) post by sponsor": "The link is above",
                "(Promo) repost by participant": "",
                "TT                       1.5Mio": "0 https://www.tiktok.com/@elevenjack?lang=fr",
                "(Main) post by sponsor__1": "",
                "(Main) repost by participant__1": "",
                "(Intro) post by sponsor__1": "",
                "(Intro) repost by participant__1": "",
                "(Promo) post by sponsor__1": "",
                "(Promo) repost by participant__1": "",
                "Youtube       1.1Mio": "0 https://www.instagram.com/elevenjackmusic/",
                "(Main) post by sponsor__2": "",
                "(Main) repost by participant__2": "",
                "(Intro) post by sponsor__2": "",
                "(Intro) repost by participant__2": "",
                "(Promo) post by sponsor__2": "",
                "(Promo) repost by participant__2": "",
                "TW": "0 https://twitter.com/11Jack9",
                "(Main) post by sponsor__3": "",
                "(Main) repost by participant__3": "",
                "(Intro) post by sponsor__3": "",
                "(Intro) repost by participant__3": "",
                "(Promo) post by sponsor__3": "the link is above",
                "(Promo) repost by participant__3": "",
                "FB                3.8 Mio": "N/A",
                "(Main) post by sponsor__4": "",
                "(Main) repost by participant__4": "",
                "(Intro) post by sponsor__4": "",
                "(Intro) repost by participant__4": "",
                "(Promo) post by sponsor__4": "The link is above",
                "(Promo) repost by participant__4": "",
                "Contact": "email",
                "Manager": "Aziz",
                "Conditions/Comments": "prize pool",
                "Country": "Switzerland"
            },
            {
                "#": 18,
                "Name": "Sultan Beibars",
                "Dancer/DJ?": "Dancer",
                "Agreement": "pinged 20, thinking",
                "Name_Official": "",
                "Inrto/Description_Official": "",
                "top 1": "",
                "top 2": "",
                "top 3": "",
                "repost by sponsor": "",
                "comment by participant": "",
                "Main Video/Track (gdrive)": "",
                "Introduction Video (gdrive)": "",
                "IG                                                         4.6 Mio": "223k https://www.instagram.com/auda_amar",
                "(Main) post by sponsor": "",
                "(Main) repost by participant": "",
                "(Intro) post by sponsor": "",
                "(Intro) repost by participant": "",
                "(Promo) post by sponsor": "The link is above",
                "(Promo) repost by participant": "",
                "TT                       1.5Mio": "3m https://www.tiktok.com/@audaamar?lang=en",
                "(Main) post by sponsor__1": "",
                "(Main) repost by participant__1": "",
                "(Intro) post by sponsor__1": "",
                "(Intro) repost by participant__1": "",
                "(Promo) post by sponsor__1": "",
                "(Promo) repost by participant__1": "",
                "Youtube       1.1Mio": "21k https://www.youtube.com/c/audaamar99",
                "(Main) post by sponsor__2": "",
                "(Main) repost by participant__2": "",
                "(Intro) post by sponsor__2": "",
                "(Intro) repost by participant__2": "",
                "(Promo) post by sponsor__2": "",
                "(Promo) repost by participant__2": "",
                "TW": "N/A",
                "(Main) post by sponsor__3": "",
                "(Main) repost by participant__3": "",
                "(Intro) post by sponsor__3": "",
                "(Intro) repost by participant__3": "",
                "(Promo) post by sponsor__3": "the link is above",
                "(Promo) repost by participant__3": "",
                "FB                3.8 Mio": "N/A",
                "(Main) post by sponsor__4": "",
                "(Main) repost by participant__4": "",
                "(Intro) post by sponsor__4": "",
                "(Intro) repost by participant__4": "",
                "(Promo) post by sponsor__4": "The link is above",
                "(Promo) repost by participant__4": "",
                "Contact": "whatsapp",
                "Manager": "Aziz",
                "Conditions/Comments": "Wants $500 prepayment, suggested 100-200-200 scheme.",
                "Country": "Kazakhstan"
            },
            {
                "#": 19,
                "Name": "Mikaila Murphy",
                "Dancer/DJ?": "Dancer",
                "Agreement": "declined/negotiating",
                "Name_Official": "",
                "Inrto/Description_Official": "",
                "top 1": "",
                "top 2": "",
                "top 3": "",
                "repost by sponsor": "",
                "comment by participant": "",
                "Main Video/Track (gdrive)": "",
                "Introduction Video (gdrive)": "",
                "IG                                                         4.6 Mio": "1M https://www.instagram.com/mikailadancer/?hl=en",
                "(Main) post by sponsor": "",
                "(Main) repost by participant": "",
                "(Intro) post by sponsor": "",
                "(Intro) repost by participant": "",
                "(Promo) post by sponsor": "The link is above",
                "(Promo) repost by participant": "",
                "TT                       1.5Mio": "15 M https://www.tiktok.com/@mikailadancer",
                "(Main) post by sponsor__1": "",
                "(Main) repost by participant__1": "",
                "(Intro) post by sponsor__1": "",
                "(Intro) repost by participant__1": "",
                "(Promo) post by sponsor__1": "",
                "(Promo) repost by participant__1": "",
                "Youtube       1.1Mio": "127K https://www.youtube.com/channel/UCYm38HA-cBsrpZ6jBBKuRVw",
                "(Main) post by sponsor__2": "",
                "(Main) repost by participant__2": "",
                "(Intro) post by sponsor__2": "",
                "(Intro) repost by participant__2": "",
                "(Promo) post by sponsor__2": "",
                "(Promo) repost by participant__2": "",
                "TW": "50.1K https://twitter.com/mikailadancer?lang=en",
                "(Main) post by sponsor__3": "",
                "(Main) repost by participant__3": "",
                "(Intro) post by sponsor__3": "",
                "(Intro) repost by participant__3": "",
                "(Promo) post by sponsor__3": "the link is above",
                "(Promo) repost by participant__3": "",
                "FB                3.8 Mio": "3.6 K https://www.facebook.com/mikailadancer",
                "(Main) post by sponsor__4": "",
                "(Main) repost by participant__4": "",
                "(Intro) post by sponsor__4": "",
                "(Intro) repost by participant__4": "",
                "(Promo) post by sponsor__4": "The link is above",
                "(Promo) repost by participant__4": "",
                "Contact": "email",
                "Manager": "Aziz",
                "Conditions/Comments": "5K guaranteed cash prize",
                "Country": "USA"
            },
            {
                "#": 20,
                "Name": "Josh Killacky",
                "Dancer/DJ?": "Dancer",
                "Agreement": "pinged 21, thinking",
                "Name_Official": "",
                "Inrto/Description_Official": "",
                "top 1": "",
                "top 2": "",
                "top 3": "",
                "repost by sponsor": "",
                "comment by participant": "",
                "Main Video/Track (gdrive)": "",
                "Introduction Video (gdrive)": "",
                "IG                                                         4.6 Mio": "555K https://www.instagram.com/joshkillacky/",
                "(Main) post by sponsor": "",
                "(Main) repost by participant": "",
                "(Intro) post by sponsor": "",
                "(Intro) repost by participant": "",
                "(Promo) post by sponsor": "The link is above",
                "(Promo) repost by participant": "",
                "TT                       1.5Mio": "984.2 K https://www.tiktok.com/@joshkillacky",
                "(Main) post by sponsor__1": "",
                "(Main) repost by participant__1": "",
                "(Intro) post by sponsor__1": "",
                "(Intro) repost by participant__1": "",
                "(Promo) post by sponsor__1": "",
                "(Promo) repost by participant__1": "",
                "Youtube       1.1Mio": "100K https://www.youtube.com/user/JoshLaDancer",
                "(Main) post by sponsor__2": "",
                "(Main) repost by participant__2": "",
                "(Intro) post by sponsor__2": "",
                "(Intro) repost by participant__2": "",
                "(Promo) post by sponsor__2": "",
                "(Promo) repost by participant__2": "",
                "TW": "16.2 K https://twitter.com/JoshKillacky?ref_src=twsrc%5Egoogle%7Ctwcamp%5Eserp%7Ctwgr%5Eauthor",
                "(Main) post by sponsor__3": "",
                "(Main) repost by participant__3": "",
                "(Intro) post by sponsor__3": "",
                "(Intro) repost by participant__3": "",
                "(Promo) post by sponsor__3": "the link is above",
                "(Promo) repost by participant__3": "",
                "FB                3.8 Mio": "32K https://www.facebook.com/joshladancer",
                "(Main) post by sponsor__4": "",
                "(Main) repost by participant__4": "",
                "(Intro) post by sponsor__4": "",
                "(Intro) repost by participant__4": "",
                "(Promo) post by sponsor__4": "The link is above",
                "(Promo) repost by participant__4": "",
                "Contact": "email",
                "Manager": "Aziz",
                "Conditions/Comments": "Wants 4.4k - expensive.",
                "Country": "USA"
            },
            {
                "#": 21,
                "Name": "Jade Chynoweth",
                "Dancer/DJ?": "Dancer",
                "Agreement": "pinged 13, declined",
                "Name_Official": "",
                "Inrto/Description_Official": "",
                "top 1": "",
                "top 2": "",
                "top 3": "",
                "repost by sponsor": "",
                "comment by participant": "",
                "Main Video/Track (gdrive)": "",
                "Introduction Video (gdrive)": "",
                "IG                                                         4.6 Mio": "2.1 M https://www.instagram.com/jadebug98/?hl=en",
                "(Main) post by sponsor": "",
                "(Main) repost by participant": "",
                "(Intro) post by sponsor": "",
                "(Intro) repost by participant": "",
                "(Promo) post by sponsor": "The link is above",
                "(Promo) repost by participant": "",
                "TT                       1.5Mio": "204.5K https://www.tiktok.com/@thejadec?lang=en",
                "(Main) post by sponsor__1": "",
                "(Main) repost by participant__1": "",
                "(Intro) post by sponsor__1": "",
                "(Intro) repost by participant__1": "",
                "(Promo) post by sponsor__1": "",
                "(Promo) repost by participant__1": "",
                "Youtube       1.1Mio": "389K https://www.youtube.com/c/JadeChynowethFans",
                "(Main) post by sponsor__2": "",
                "(Main) repost by participant__2": "",
                "(Intro) post by sponsor__2": "",
                "(Intro) repost by participant__2": "",
                "(Promo) post by sponsor__2": "",
                "(Promo) repost by participant__2": "",
                "TW": "52.7K https://twitter.com/jadechynoweth?lang=en",
                "(Main) post by sponsor__3": "",
                "(Main) repost by participant__3": "",
                "(Intro) post by sponsor__3": "",
                "(Intro) repost by participant__3": "",
                "(Promo) post by sponsor__3": "the link is above",
                "(Promo) repost by participant__3": "",
                "FB                3.8 Mio": "8K https://www.facebook.com/OfficialJadeChynoweth",
                "(Main) post by sponsor__4": "",
                "(Main) repost by participant__4": "",
                "(Intro) post by sponsor__4": "",
                "(Intro) repost by participant__4": "",
                "(Promo) post by sponsor__4": "The link is above",
                "(Promo) repost by participant__4": "",
                "Contact": "email",
                "Manager": "Aziz",
                "Conditions/Comments": "Offered 1.5K guaranteed cash prize",
                "Country": "USA"
            },
            {
                "#": 22,
                "Name": "Mayca Delduque",
                "Dancer/DJ?": "Dancer",
                "Agreement": "Pinged 20, I thought the deadline was over. I will send as soon as possible.",
                "Name_Official": "",
                "Inrto/Description_Official": "",
                "top 1": "",
                "top 2": "",
                "top 3": "",
                "repost by sponsor": "IG : https://www.instagram.com/reel/CfBzaq6DEFU/?utm_source=ig_web_copy_link \nTT : https://www.tiktok.com/@1ath.studio/video/7111298208373984513?is_from_webapp=1&sender_device=pc&web_id=7111236788357891589 \nTW : https://twitter.com/1ATHStudio/status/1538876156736413699?s=20&t=fourgabKK7YVA1FvCtSRBg \nYT :  https://youtube.com/shorts/QBmZO1z1Ktg?feature=share \nFB : https://www.facebook.com/watch",
                "comment by participant": "",
                "Main Video/Track (gdrive)": "",
                "Introduction Video (gdrive)": "",
                "IG                                                         4.6 Mio": "1.2 M https://www.instagram.com/maycabrasil/?hl=en",
                "(Main) post by sponsor": "",
                "(Main) repost by participant": "",
                "(Intro) post by sponsor": "",
                "(Intro) repost by participant": "",
                "(Promo) post by sponsor": "The link is above",
                "(Promo) repost by participant": "",
                "TT                       1.5Mio": "9.1 M https://www.tiktok.com/@maycabrasil?lang=en",
                "(Main) post by sponsor__1": "",
                "(Main) repost by participant__1": "",
                "(Intro) post by sponsor__1": "",
                "(Intro) repost by participant__1": "",
                "(Promo) post by sponsor__1": "",
                "(Promo) repost by participant__1": "",
                "Youtube       1.1Mio": "10.9K https://www.youtube.com/channel/UCLytPjAioH-nM_70CqbGF-w",
                "(Main) post by sponsor__2": "",
                "(Main) repost by participant__2": "",
                "(Intro) post by sponsor__2": "",
                "(Intro) repost by participant__2": "",
                "(Promo) post by sponsor__2": "",
                "(Promo) repost by participant__2": "",
                "TW": "116 https://twitter.com/maycadelduque?lang=en",
                "(Main) post by sponsor__3": "",
                "(Main) repost by participant__3": "",
                "(Intro) post by sponsor__3": "",
                "(Intro) repost by participant__3": "",
                "(Promo) post by sponsor__3": "the link is above",
                "(Promo) repost by participant__3": "",
                "FB                3.8 Mio": "5K https://www.facebook.com/maycabrasil",
                "(Main) post by sponsor__4": "",
                "(Main) repost by participant__4": "",
                "(Intro) post by sponsor__4": "",
                "(Intro) repost by participant__4": "",
                "(Promo) post by sponsor__4": "The link is above",
                "(Promo) repost by participant__4": "",
                "Contact": "WA",
                "Manager": "Aigerim",
                "Conditions/Comments": "Aziz proposed 5K guaranteed cash prize + no prize pool claim",
                "Country": "Brasil"
            },
            {
                "#": 23,
                "Name": "Aljona Savchenko",
                "Dancer/DJ?": "Dancer",
                "Agreement": "thinking",
                "Name_Official": "",
                "Inrto/Description_Official": "",
                "top 1": "",
                "top 2": "",
                "top 3": "",
                "repost by sponsor": "",
                "comment by participant": "",
                "Main Video/Track (gdrive)": "",
                "Introduction Video (gdrive)": "",
                "IG                                                         4.6 Mio": "11K https://www.instagram.com/al.dancealena/",
                "(Main) post by sponsor": "",
                "(Main) repost by participant": "",
                "(Intro) post by sponsor": "",
                "(Intro) repost by participant": "",
                "(Promo) post by sponsor": "The link is above",
                "(Promo) repost by participant": "",
                "TT                       1.5Mio": "N/A",
                "(Main) post by sponsor__1": "",
                "(Main) repost by participant__1": "",
                "(Intro) post by sponsor__1": "",
                "(Intro) repost by participant__1": "",
                "(Promo) post by sponsor__1": "",
                "(Promo) repost by participant__1": "",
                "Youtube       1.1Mio": "1.4K https://www.youtube.com/channel/UCnUcLWDNbw_R2YhQabdemqA",
                "(Main) post by sponsor__2": "",
                "(Main) repost by participant__2": "",
                "(Intro) post by sponsor__2": "",
                "(Intro) repost by participant__2": "",
                "(Promo) post by sponsor__2": "",
                "(Promo) repost by participant__2": "",
                "TW": "N/A",
                "(Main) post by sponsor__3": "",
                "(Main) repost by participant__3": "",
                "(Intro) post by sponsor__3": "",
                "(Intro) repost by participant__3": "",
                "(Promo) post by sponsor__3": "the link is above",
                "(Promo) repost by participant__3": "",
                "FB                3.8 Mio": "70 https://www.facebook.com/al.dancealena/",
                "(Main) post by sponsor__4": "",
                "(Main) repost by participant__4": "",
                "(Intro) post by sponsor__4": "",
                "(Intro) repost by participant__4": "",
                "(Promo) post by sponsor__4": "The link is above",
                "(Promo) repost by participant__4": "",
                "Contact": "WA",
                "Manager": "Aigerim",
                "Conditions/Comments": "$400 no prize pool",
                "Country": "Ukraine"
            },
            {
                "#": 24,
                "Name": "Alex Komulainen",
                "Dancer/DJ?": "Dancer",
                "Agreement": "pinged for contract details",
                "Name_Official": "",
                "Inrto/Description_Official": "",
                "top 1": "",
                "top 2": "",
                "top 3": "",
                "repost by sponsor": "",
                "comment by participant": "",
                "Main Video/Track (gdrive)": "",
                "Introduction Video (gdrive)": "",
                "IG                                                         4.6 Mio": "22.6K https://www.instagram.com/alex_komulainen/?hl=en",
                "(Main) post by sponsor": "",
                "(Main) repost by participant": "",
                "(Intro) post by sponsor": "",
                "(Intro) repost by participant": "",
                "(Promo) post by sponsor": "The link is above",
                "(Promo) repost by participant": "",
                "TT                       1.5Mio": "5K https://www.tiktok.com/@alex_komulainen",
                "(Main) post by sponsor__1": "",
                "(Main) repost by participant__1": "",
                "(Intro) post by sponsor__1": "",
                "(Intro) repost by participant__1": "",
                "(Promo) post by sponsor__1": "",
                "(Promo) repost by participant__1": "",
                "Youtube       1.1Mio": "241 https://www.youtube.com/channel/UCLvTF5v32LogeWW8TNcakdg",
                "(Main) post by sponsor__2": "",
                "(Main) repost by participant__2": "",
                "(Intro) post by sponsor__2": "",
                "(Intro) repost by participant__2": "",
                "(Promo) post by sponsor__2": "",
                "(Promo) repost by participant__2": "",
                "TW": "N/A",
                "(Main) post by sponsor__3": "",
                "(Main) repost by participant__3": "",
                "(Intro) post by sponsor__3": "",
                "(Intro) repost by participant__3": "",
                "(Promo) post by sponsor__3": "the link is above",
                "(Promo) repost by participant__3": "",
                "FB                3.8 Mio": "15 https://www.facebook.com/Alex-Komulainen-360850811371228",
                "(Main) post by sponsor__4": "",
                "(Main) repost by participant__4": "",
                "(Intro) post by sponsor__4": "",
                "(Intro) repost by participant__4": "",
                "(Promo) post by sponsor__4": "The link is above",
                "(Promo) repost by participant__4": "",
                "Contact": "WA",
                "Manager": "Aigerim",
                "Conditions/Comments": "$300 + 30% prize pool claim",
                "Country": "Finland / USA"
            },
            {
                "#": 25,
                "Name": "Jaylen Brown",
                "Dancer/DJ?": "Dancer",
                "Agreement": "pinged 20, works on the video",
                "Name_Official": "",
                "Inrto/Description_Official": "",
                "top 1": "",
                "top 2": "",
                "top 3": "",
                "repost by sponsor": "",
                "comment by participant": "",
                "Main Video/Track (gdrive)": "",
                "Introduction Video (gdrive)": "",
                "IG                                                         4.6 Mio": "18.7k https://www.instagram.com/awkward.jay/",
                "(Main) post by sponsor": "",
                "(Main) repost by participant": "",
                "(Intro) post by sponsor": "",
                "(Intro) repost by participant": "",
                "(Promo) post by sponsor": "The link is above",
                "(Promo) repost by participant": "",
                "TT                       1.5Mio": "N/A",
                "(Main) post by sponsor__1": "",
                "(Main) repost by participant__1": "",
                "(Intro) post by sponsor__1": "",
                "(Intro) repost by participant__1": "",
                "(Promo) post by sponsor__1": "",
                "(Promo) repost by participant__1": "",
                "Youtube       1.1Mio": "694 https://www.youtube.com/channel/UCsczfw2qnC_KT9YYHFAlB7Q",
                "(Main) post by sponsor__2": "",
                "(Main) repost by participant__2": "",
                "(Intro) post by sponsor__2": "",
                "(Intro) repost by participant__2": "",
                "(Promo) post by sponsor__2": "",
                "(Promo) repost by participant__2": "",
                "TW": "N/A",
                "(Main) post by sponsor__3": "",
                "(Main) repost by participant__3": "",
                "(Intro) post by sponsor__3": "",
                "(Intro) repost by participant__3": "",
                "(Promo) post by sponsor__3": "the link is above",
                "(Promo) repost by participant__3": "",
                "FB                3.8 Mio": "N/A",
                "(Main) post by sponsor__4": "",
                "(Main) repost by participant__4": "",
                "(Intro) post by sponsor__4": "",
                "(Intro) repost by participant__4": "",
                "(Promo) post by sponsor__4": "The link is above",
                "(Promo) repost by participant__4": "",
                "Contact": "jaylenbusiness595@gmail.com",
                "Manager": "Aziz",
                "Conditions/Comments": "Wants $500 + prize pool",
                "Country": ""
            },
            {
                "#": 26,
                "Name": "Joseph_ Nerzie / afrodancer",
                "Dancer/DJ?": "Dancer",
                "Agreement": "sent video",
                "Name_Official": "Joseph Nerzie",
                "Inrto/Description_Official": "Joseph_ Nerzie. CEO of d_swagger_dancerz . I run a dance institute. I have achieved some series of awards.  Achievements: awards as the best dancer in Edo north. As the overal best dancer in civil engineering Auchi polytechnic . Award as the overall best student , award as the best dance tutor of the d_swagger_dancerz institute. On various celebrities official musical videos .",
                "top 1": "-",
                "top 2": "-",
                "top 3": "-",
                "repost by sponsor": "-",
                "comment by participant": "IG: https://www.instagram.com/p/CfG8IfuOrIM/",
                "Main Video/Track (gdrive)": "https://drive.google.com/drive/u/2/folders/1tqMxHwr0H5_Pp9ki9HPsS1o-buKf9RJ1",
                "Introduction Video (gdrive)": "https://drive.google.com/file/d/1H5tHC9M4i4eWHREZtuZJzfOUAsy5CVZc/view?usp=sharing",
                "IG                                                         4.6 Mio": "5.2K https://www.instagram.com/nerzie_dancelordzie/ \n3.7k https://www.instagram.com/d_swagger_dancerz/?hl=en",
                "(Main) post by sponsor": "TT: https://www.tiktok.com/@1ath.studio/video/7112050211886877954?is_from_webapp=1&sender_device=pc&web_id=7112032987612562950 \nYT: https://youtu.be/KIPKyw6HZD4 \nIG: https://www.instagram.com/tv/CfG8IfuOrIM/?utm_source=ig_web_copy_link                                                                                                                                                                           \nTW: https://twitter.com/1ATHStudio/status/1539595170248810501 \nFB: https://fb.watch/dOPhCy0A9K/",
                "(Main) repost by participant": "IG: https://www.instagram.com/stories/nerzie_dancelordzie/2866334388239501254/ \nTT: https://www.tiktok.com/@nerzie_dancelordzie/video/7112507761996352773?is_copy_url=1&is_from_webapp=v1",
                "(Intro) post by sponsor": "YT: https://youtu.be/GNXqaWsG1AI \nTW https://twitter.com/1ATHStudio/status/1540012296927383555 \nIG https://www.instagram.com/tv/CfJ5p8qL9q_/?utm_source=ig_web_copy_link                \nFB https://fb.watch/dQkxeh3ADp \nTT: https://www.tiktok.com/@1ath.studio/video/7112477642888154370?is_from_webapp=1&sender_device=pc&web_id=7094173033330034182",
                "(Intro) repost by participant": "",
                "(Promo) post by sponsor": "The link is above",
                "(Promo) repost by participant": "",
                "TT                       1.5Mio": "5k https://www.tiktok.com/@nerzie_dancelordzie",
                "(Main) post by sponsor__1": "",
                "(Main) repost by participant__1": "",
                "(Intro) post by sponsor__1": "",
                "(Intro) repost by participant__1": "",
                "(Promo) post by sponsor__1": "",
                "(Promo) repost by participant__1": "",
                "Youtube       1.1Mio": "https://www.youtube.com/channel/UCf6okCFKjkEVpVRISHcIUSA",
                "(Main) post by sponsor__2": "",
                "(Main) repost by participant__2": "",
                "(Intro) post by sponsor__2": "",
                "(Intro) repost by participant__2": "",
                "(Promo) post by sponsor__2": "",
                "(Promo) repost by participant__2": "",
                "TW": "N/A",
                "(Main) post by sponsor__3": "",
                "(Main) repost by participant__3": "",
                "(Intro) post by sponsor__3": "",
                "(Intro) repost by participant__3": "",
                "(Promo) post by sponsor__3": "the link is above",
                "(Promo) repost by participant__3": "",
                "FB                3.8 Mio": "N/A",
                "(Main) post by sponsor__4": "",
                "(Main) repost by participant__4": "",
                "(Intro) post by sponsor__4": "",
                "(Intro) repost by participant__4": "",
                "(Promo) post by sponsor__4": "The link is above",
                "(Promo) repost by participant__4": "",
                "Contact": "Fiverr",
                "Manager": "Milan/Anatoliy",
                "Conditions/Comments": "as per Rules file, 100 eur + 25% prize pool",
                "Country": "Nigeria"
            },
            {
                "#": 27,
                "Name": "DJ FJ (Isaac)",
                "Dancer/DJ?": "DJ",
                "Agreement": "pinged 20, working on the track",
                "Name_Official": "DJ FJ",
                "Inrto/Description_Official": "",
                "top 1": "-",
                "top 2": "-",
                "top 3": "-",
                "repost by sponsor": "-",
                "comment by participant": "-",
                "Main Video/Track (gdrive)": "",
                "Introduction Video (gdrive)": "",
                "IG                                                         4.6 Mio": "1k https://www.instagram.com/djfanaticjr/",
                "(Main) post by sponsor": "",
                "(Main) repost by participant": "",
                "(Intro) post by sponsor": "",
                "(Intro) repost by participant": "",
                "(Promo) post by sponsor": "The link is above",
                "(Promo) repost by participant": "",
                "TT                       1.5Mio": "0 https://www.tiktok.com/@djfanaticjr",
                "(Main) post by sponsor__1": "",
                "(Main) repost by participant__1": "",
                "(Intro) post by sponsor__1": "",
                "(Intro) repost by participant__1": "",
                "(Promo) post by sponsor__1": "",
                "(Promo) repost by participant__1": "",
                "Youtube       1.1Mio": "0 https://www.youtube.com/channel/UCrPJKXQx1TXxtdUw66TUDIw",
                "(Main) post by sponsor__2": "",
                "(Main) repost by participant__2": "",
                "(Intro) post by sponsor__2": "",
                "(Intro) repost by participant__2": "",
                "(Promo) post by sponsor__2": "",
                "(Promo) repost by participant__2": "",
                "TW": "N/A",
                "(Main) post by sponsor__3": "",
                "(Main) repost by participant__3": "",
                "(Intro) post by sponsor__3": "",
                "(Intro) repost by participant__3": "",
                "(Promo) post by sponsor__3": "the link is above",
                "(Promo) repost by participant__3": "",
                "FB                3.8 Mio": "N/A",
                "(Main) post by sponsor__4": "",
                "(Main) repost by participant__4": "",
                "(Intro) post by sponsor__4": "",
                "(Intro) repost by participant__4": "",
                "(Promo) post by sponsor__4": "The link is above",
                "(Promo) repost by participant__4": "",
                "Contact": "email: djfanaticjr@aol.com",
                "Manager": "Aziz",
                "Conditions/Comments": "prize pool",
                "Country": "USA"
            },
            {
                "#": 28,
                "Name": "Howard Johnson",
                "Dancer/DJ?": "Dancer",
                "Agreement": "pinged 20, applied",
                "Name_Official": "",
                "Inrto/Description_Official": "",
                "top 1": "",
                "top 2": "",
                "top 3": "",
                "repost by sponsor": "",
                "comment by participant": "",
                "Main Video/Track (gdrive)": "",
                "Introduction Video (gdrive)": "",
                "IG                                                         4.6 Mio": "85.5 https://www.instagram.com/howardjohnson_/",
                "(Main) post by sponsor": "",
                "(Main) repost by participant": "",
                "(Intro) post by sponsor": "",
                "(Intro) repost by participant": "",
                "(Promo) post by sponsor": "The link is above",
                "(Promo) repost by participant": "",
                "TT                       1.5Mio": "1.3 M https://www.tiktok.com/@howardjohnson_?lang=en",
                "(Main) post by sponsor__1": "",
                "(Main) repost by participant__1": "",
                "(Intro) post by sponsor__1": "",
                "(Intro) repost by participant__1": "",
                "(Promo) post by sponsor__1": "",
                "(Promo) repost by participant__1": "",
                "Youtube       1.1Mio": "4.5K https://www.youtube.com/channel/UCopLnNuDAygRaoemuUQuSlQ",
                "(Main) post by sponsor__2": "",
                "(Main) repost by participant__2": "",
                "(Intro) post by sponsor__2": "",
                "(Intro) repost by participant__2": "",
                "(Promo) post by sponsor__2": "",
                "(Promo) repost by participant__2": "",
                "TW": "N/A",
                "(Main) post by sponsor__3": "",
                "(Main) repost by participant__3": "",
                "(Intro) post by sponsor__3": "",
                "(Intro) repost by participant__3": "",
                "(Promo) post by sponsor__3": "the link is above",
                "(Promo) repost by participant__3": "",
                "FB                3.8 Mio": "1.2 K https://www.facebook.com/howard.johnson.12",
                "(Main) post by sponsor__4": "",
                "(Main) repost by participant__4": "",
                "(Intro) post by sponsor__4": "",
                "(Intro) repost by participant__4": "",
                "(Promo) post by sponsor__4": "The link is above",
                "(Promo) repost by participant__4": "",
                "Contact": "howardjohnson883@gmail.com",
                "Manager": "Aziz",
                "Conditions/Comments": "$350 + prize pool",
                "Country": "USA"
            },
            {
                "#": 29,
                "Name": "Triplets Ghetto Kids",
                "Dancer/DJ?": "Dancer",
                "Agreement": "sent video",
                "Name_Official": "Triplets Ghetto Kids",
                "Inrto/Description_Official": "",
                "top 1": "",
                "top 2": "",
                "top 3": "",
                "repost by sponsor": "Ig https://www.instagram.com/reel/CfFjY6qDY27/?utm_source=ig_web_copy_link \n\nYt https://youtu.be.com/shorts/trDeUunoa04?feature=share  \n\nTw https://twitter.com/1athstudio/status/1539406238219386880?s=21&t=mAaGuDClDG9nrqhS12uDGw  \n\nFb  https://fb.watch/dO6CsP0pHd/",
                "comment by participant": "",
                "Main Video/Track (gdrive)": "https://drive.google.com/drive/folders/1usd9rl3dpbyzmU85x1uld8vfFByvZtV-",
                "Introduction Video (gdrive)": "https://drive.google.com/drive/folders/1iGvU_0ziBtKRzQaB-vtdPE297yfnliG1",
                "IG                                                         4.6 Mio": "2.4 M https://www.instagram.com/ghettokids_tfug/",
                "(Main) post by sponsor": "TT: https://www.tiktok.com/@1ath.studio/video/7112117380519628034?is_from_webapp=1&sender_device=pc&web_id=7112032987612562950 \nYT: https://youtu.be/Hz_2qvJCPvo \nIG: https://www.instagram.com/tv/CfHa77tLKkk/?utm_source=ig_web_copy_link                                                                                                                                                                    \nTW: https://twitter.com/1ATHStudio/status/1539662488458764289 \nFB: https://fb.watch/dP2JxwqZaH/",
                "(Main) repost by participant": "Asked to repost",
                "(Intro) post by sponsor": "YT: https://youtu.be/hRmFVIdJyF4 \nTT: https://www.tiktok.com/@1ath.studio/video/7113519837309078786?is_from_webapp=1&sender_device=pc&web_id=7094173033330034182 \nFB: https://fb.watch/dU1vD8tZZM/ \nIG: https://www.instagram.com/tv/CfRJuQ4voAc/?utm_source=ig_web_copy_link \nTW: https://twitter.com/1ATHStudio/status/1541035050208268288?s=20&t=ZwOm9lauKag6zW5EyuZwLw",
                "(Intro) repost by participant": "",
                "(Promo) post by sponsor": "The link is above",
                "(Promo) repost by participant": "Requested to disregard",
                "TT                       1.5Mio": "31.5K https://www.tiktok.com/@ghettokids_tfug256",
                "(Main) post by sponsor__1": "",
                "(Main) repost by participant__1": "",
                "(Intro) post by sponsor__1": "",
                "(Intro) repost by participant__1": "",
                "(Promo) post by sponsor__1": "",
                "(Promo) repost by participant__1": "",
                "Youtube       1.1Mio": "350K https://www.youtube.com/c/TripletsGhettoKids",
                "(Main) post by sponsor__2": "",
                "(Main) repost by participant__2": "",
                "(Intro) post by sponsor__2": "",
                "(Intro) repost by participant__2": "",
                "(Promo) post by sponsor__2": "",
                "(Promo) repost by participant__2": "",
                "TW": "https://twitter.com/tripletsf?lang=en",
                "(Main) post by sponsor__3": "",
                "(Main) repost by participant__3": "",
                "(Intro) post by sponsor__3": "",
                "(Intro) repost by participant__3": "",
                "(Promo) post by sponsor__3": "the link is above",
                "(Promo) repost by participant__3": "",
                "FB                3.8 Mio": "1M https://www.facebook.com/TripletsGhettoKidz",
                "(Main) post by sponsor__4": "",
                "(Main) repost by participant__4": "",
                "(Intro) post by sponsor__4": "",
                "(Intro) repost by participant__4": "",
                "(Promo) post by sponsor__4": "The link is above",
                "(Promo) repost by participant__4": "",
                "Contact": "email and WA",
                "Manager": "",
                "Conditions/Comments": "$1500 + prize pool",
                "Country": "Uganda"
            },
            {
                "#": 30,
                "Name": "Nihal / naaimul",
                "Dancer/DJ?": "Dancer",
                "Agreement": "sent video",
                "Name_Official": "Nihal",
                "Inrto/Description_Official": "I'm Nihal.\nI'm a South Asian college student, currently doing BBA on Management.\nDancing is my passion. I love expressing myself through dance. My dance style is a fusion of Belly Dance and Popping.\nI've been dancing for more than 3 years now.\nAlso, I've performed and created content for various musicians and agencies.\nI was lucky to win a few awards for my dance locally.\nI'm really looking forward to spreading the beauty of Fusion Dance style with everyone.",
                "top 1": "-",
                "top 2": "-",
                "top 3": "-",
                "repost by sponsor": "-",
                "comment by participant": "IG: https://www.instagram.com/tv/CfG2BZJM85o/?utm_source=ig_web_copy_link\nFB: https://www.facebook.com/watch/?v=1163778414412190&extid=NS-UNK-UNK-UNK-IOS_GK0T-GK1C&ref=sharing\nTW: https://twitter.com/1ATHStudio/status/1539582729507028993\nYT: https://www.youtube.com/watch?v=rMma51GSVXU&ab_channel=1ATH.Studio",
                "Main Video/Track (gdrive)": "https://drive.google.com/drive/u/0/folders/1JHCyly8b_EfGoPBjZRcQ6-E0WagQ66Bh",
                "Introduction Video (gdrive)": "https://drive.google.com/drive/u/0/folders/1JHCyly8b_EfGoPBjZRcQ6-E0WagQ66Bh",
                "IG                                                         4.6 Mio": "0 https://www.instagram.com/naimulislam.nihal/",
                "(Main) post by sponsor": "TT: https://www.tiktok.com/@1ath.studio/video/7112036244032392449?is_from_webapp=1&sender_device=pc&web_id=7112032987612562950 \nYT: https://youtu.be/rMma51GSVXU \nIG: https://www.instagram.com/tv/CfG2BZJM85o/?utm_source=ig_web_copy_link                                                                                                                                                                  \nTW: https://twitter.com/1ATHStudio/status/1539582729507028993 \nFB: https://fb.watch/dOMtYrZwNY/",
                "(Main) repost by participant": "IG: https://www.instagram.com/stories/naimulislam.nihal/2866308432225810865/\nYT: https://youtube.com/shorts/yx2-dgXlPsU?feature=share \nTW: https://twitter.com/naimul_nihal  \nTT: https://www.tiktok.com/@naimul_islam_nihal/video/7112760160078089498?is_copy_url=1&is_from_webapp=v1",
                "(Intro) post by sponsor": "FB: https://fb.watch/dOMtYrZwNY \nIG https://www.instagram.com/tv/CfMG1EfD4xF/?utm_source=ig_web_copy_link   \nTW https://twitter.com/1ATHStudio/status/1540323518314958848           \nYT https://youtu.be/UtHUOHdSPjo  \nTT https://vt.tiktok.com/ZSdT6ox91/?k=1",
                "(Intro) repost by participant": "",
                "(Promo) post by sponsor": "The link is above",
                "(Promo) repost by participant": "",
                "TT                       1.5Mio": "0 https://www.tiktok.com/@naimul_islam_nihal",
                "(Main) post by sponsor__1": "",
                "(Main) repost by participant__1": "",
                "(Intro) post by sponsor__1": "",
                "(Intro) repost by participant__1": "",
                "(Promo) post by sponsor__1": "",
                "(Promo) repost by participant__1": "",
                "Youtube       1.1Mio": "0 https://www.youtube.com/c/NaimulIslamNihal",
                "(Main) post by sponsor__2": "",
                "(Main) repost by participant__2": "",
                "(Intro) post by sponsor__2": "",
                "(Intro) repost by participant__2": "",
                "(Promo) post by sponsor__2": "",
                "(Promo) repost by participant__2": "",
                "TW": "https://twitter.com/naimul_nihal",
                "(Main) post by sponsor__3": "",
                "(Main) repost by participant__3": "",
                "(Intro) post by sponsor__3": "",
                "(Intro) repost by participant__3": "",
                "(Promo) post by sponsor__3": "the link is above",
                "(Promo) repost by participant__3": "",
                "FB                3.8 Mio": "N/A",
                "(Main) post by sponsor__4": "",
                "(Main) repost by participant__4": "",
                "(Intro) post by sponsor__4": "",
                "(Intro) repost by participant__4": "",
                "(Promo) post by sponsor__4": "The link is above",
                "(Promo) repost by participant__4": "",
                "Contact": "Fiverr",
                "Manager": "Milan/Anatoliy",
                "Conditions/Comments": "as to Rules file, 40 eur, +25% prize pool",
                "Country": "Bangladesh"
            },
            {
                "#": 31,
                "Name": "Charlie Atom / charlieatom",
                "Dancer/DJ?": "DJ",
                "Agreement": "sent track",
                "Name_Official": "Charlie Atom",
                "Inrto/Description_Official": "https://www.instagram.com/stories/highlights/17849062810690239/?hl=en",
                "top 1": "",
                "top 2": "",
                "top 3": "",
                "repost by sponsor": "IG: https://www.instagram.com/reel/Ce_qZl1DIWA/?utm_source=ig_web_copy_link \nTT: https://www.tiktok.com/@1ath.studio/video/7111009876947537153?is_from_webapp=1&sender_device=pc&web_id=7111236779911955973 \nTW: https://twitter.com/1ATHStudio/status/1538590421588361218?s=20&t=QmNlrzkWfo8mtYSFrp5Bxw \nYT: https://youtube.com/shorts/bBleZp059Gw?feature=share \nFB: https://fb.watch/dLWQ_kK2MH",
                "comment by participant": "",
                "Main Video/Track (gdrive)": "https://drive.google.com/drive/u/1/folders/1-XACB6A3PFg8R5l4S81WlkgG-l0VIYy0",
                "Introduction Video (gdrive)": "https://drive.google.com/drive/u/1/folders/1-XACB6A3PFg8R5l4S81WlkgG-l0VIYy0",
                "IG                                                         4.6 Mio": "5.3k https://www.instagram.com/charlieatom/",
                "(Main) post by sponsor": "TT: https://www.tiktok.com/@1ath.studio/video/7112056218142772482?is_from_webapp=1&sender_device=pc&web_id=7112032987612562950 \nYT: https://youtu.be/aQcueL-yOEw \nIG: https://www.instagram.com/tv/CfG_5n4js0K/?utm_source=ig_web_copy_link                                                                                                                                                    \nTW: https://twitter.com/1ATHStudio/status/1539603575814426627  \nFB: https://fb.watch/dORaZbF9D6/",
                "(Main) repost by participant": "IG: https://www.instagram.com/stories/charlieatom/2866261108238830983/  \nFB: https://fb.watch/dPT-UsmdD1/ \nTW: https://twitter.com/charlie_atom",
                "(Intro) post by sponsor": "YT: https://youtu.be/qWTBZsB1Iu8\nTT: https://www.tiktok.com/@1ath.studio/video/7113536502159641857?is_from_webapp=1&sender_device=pc&web_id=7094173033330034182 \nFB: https://fb.watch/dU4-xAniNz/ \nIG: https://www.instagram.com/tv/CfRPyZwsNNP/?utm_source=ig_web_copy_link \nTW: https://twitter.com/1ATHStudio/status/1541048096322457601?s=20&t=9-EyxayWjU-IOxjUeihtRw",
                "(Intro) repost by participant": "",
                "(Promo) post by sponsor": "The link is above",
                "(Promo) repost by participant": "",
                "TT                       1.5Mio": "1.3k https://www.tiktok.com/@charlieatom",
                "(Main) post by sponsor__1": "",
                "(Main) repost by participant__1": "",
                "(Intro) post by sponsor__1": "",
                "(Intro) repost by participant__1": "",
                "(Promo) post by sponsor__1": "",
                "(Promo) repost by participant__1": "",
                "Youtube       1.1Mio": "1.6k https://www.youtube.com/c/CharlieAtom/videos",
                "(Main) post by sponsor__2": "",
                "(Main) repost by participant__2": "",
                "(Intro) post by sponsor__2": "",
                "(Intro) repost by participant__2": "",
                "(Promo) post by sponsor__2": "",
                "(Promo) repost by participant__2": "",
                "TW": "https://twitter.com/charlie_atom",
                "(Main) post by sponsor__3": "",
                "(Main) repost by participant__3": "",
                "(Intro) post by sponsor__3": "",
                "(Intro) repost by participant__3": "",
                "(Promo) post by sponsor__3": "the link is above",
                "(Promo) repost by participant__3": "",
                "FB                3.8 Mio": "15k https://www.facebook.com/charlieatom",
                "(Main) post by sponsor__4": "",
                "(Main) repost by participant__4": "",
                "(Intro) post by sponsor__4": "",
                "(Intro) repost by participant__4": "",
                "(Promo) post by sponsor__4": "The link is above",
                "(Promo) repost by participant__4": "",
                "Contact": "Fiverr",
                "Manager": "Milan/Anatoliy",
                "Conditions/Comments": "as to the Rules file, 600 eur, +25% prize pool",
                "Country": "Mexico"
            },
            {
                "#": 32,
                "Name": "fokuzbeat / The Big Sound.",
                "Dancer/DJ?": "DJ",
                "Agreement": "sent track",
                "Name_Official": "The Big Sound",
                "Inrto/Description_Official": "- We are The Big Sound.\n\n- We are a collective of artists and musicians based in Medellín, Colombia; the capital of urban music. We got over 10 years of experience and our focus is to support emergent and independent artists with their musical project at different stages such as production, composition and mix & master.\nOver the past 10 years we have created more than 5.000 tracks for other artists from all over the world achieving this 100% online.",
                "top 1": "",
                "top 2": "",
                "top 3": "",
                "repost by sponsor": "TT: https://www.tiktok.com/@1ath.studio/video/7111393503623580930?is_from_webapp=1&sender_device=pc&web_id=7111389886413964801 \nIG stories: https://instagram.com/stories/1ath.studio/2864895663058757801?utm_source=ig_story_item_share&igshid=YmMyMTA2M2Y= \nIGR: https://www.instagram.com/reel/CfCJZ3qs0ed/?igshid=YmMyMTA2M2Y= \nTW: https://twitter.com/1athstudio/status/1538927960958304262?s=21&t=pZQ3ma2RmVNpauklEVxr6A \nFB: https://fb.watch/dMo91PwFxq/  \nYTS: https://youtube.com/shorts/vJ3HP3uSaP8?feature=share",
                "comment by participant": "IG: https://www.instagram.com/p/CfCJZ3qs0ed/",
                "Main Video/Track (gdrive)": "https://drive.google.com/drive/u/1/folders/18YX0HwSDtq4g6IDzdk1q23xOripqJzd9",
                "Introduction Video (gdrive)": "https://drive.google.com/drive/u/1/folders/18YX0HwSDtq4g6IDzdk1q23xOripqJzd9",
                "IG                                                         4.6 Mio": "4.4K https://www.instagram.com/thebigsound.co/",
                "(Main) post by sponsor": "TT:  https://www.tiktok.com/@1ath.studio/video/7112053035123117314?is_from_webapp=1&sender_device=pc&web_id=7112032987612562950 \nYT: https://youtu.be/-vHpOI3bczQ \nIG: https://www.instagram.com/tv/CfG9mtHAfvx/?utm_source=ig_web_copy_link                                                                                                                                                   \nTW: https://twitter.com/1ATHStudio/status/1539598417252458496  \nFB: https://fb.watch/dOQo9AakYF/",
                "(Main) repost by participant": "IG: https://www.instagram.com/stories/thebigsound.co/2866349529275157508/\nThere is a video him talking about NFT below\nhttps://www.tiktok.com/@thebigsound.co/video/7110004881770990854?is_copy_url=1&is_from_webapp=v1",
                "(Intro) post by sponsor": "YT: \nTT:\nFB:\nIG:\nTW:",
                "(Intro) repost by participant": "",
                "(Promo) post by sponsor": "The link is above",
                "(Promo) repost by participant": "",
                "TT                       1.5Mio": "2K https://www.tiktok.com/@thebigsound.co",
                "(Main) post by sponsor__1": "",
                "(Main) repost by participant__1": "",
                "(Intro) post by sponsor__1": "",
                "(Intro) repost by participant__1": "",
                "(Promo) post by sponsor__1": "",
                "(Promo) repost by participant__1": "",
                "Youtube       1.1Mio": "0 https://www.youtube.com/channel/UCb0L-A3iNPV0YcBUuBWRKyQ",
                "(Main) post by sponsor__2": "",
                "(Main) repost by participant__2": "",
                "(Intro) post by sponsor__2": "",
                "(Intro) repost by participant__2": "",
                "(Promo) post by sponsor__2": "",
                "(Promo) repost by participant__2": "",
                "TW": "N/A",
                "(Main) post by sponsor__3": "",
                "(Main) repost by participant__3": "",
                "(Intro) post by sponsor__3": "",
                "(Intro) repost by participant__3": "",
                "(Promo) post by sponsor__3": "the link is above",
                "(Promo) repost by participant__3": "",
                "FB                3.8 Mio": "1K https://www.facebook.com/thebigsound.co",
                "(Main) post by sponsor__4": "",
                "(Main) repost by participant__4": "",
                "(Intro) post by sponsor__4": "",
                "(Intro) repost by participant__4": "",
                "(Promo) post by sponsor__4": "The link is above",
                "(Promo) repost by participant__4": "",
                "Contact": "Fiverr",
                "Manager": "Milan/Anatoliy",
                "Conditions/Comments": "as to the Rules file, 200 eur, +25% prize pool",
                "Country": "Colombia"
            },
            {
                "#": 33,
                "Name": "Alex Keston / vedantdighe",
                "Dancer/DJ?": "DJ",
                "Agreement": "sent track",
                "Name_Official": "Alex Keston",
                "Inrto/Description_Official": "My stage name is Alex and, I am a Music Producer (21), based in India. Nearly 6 years ago, I got interested in EDM music production. Since then, producing is one of my biggest passion and, affection. One of the best achievements in my musical career is to get one of my EP and, single getting featured on Paste Magazine (Ref. https://www.pastemagazine.com/noisetrade/music/alexkeston/piece-x ) and, ChartsInFrance ( http://www.chartsinfrance.net/Alex-Keston/albums-singles.html  ). Apart from this, I believe, the 50k+ mark on total streams on Spotify is a really good achievement too",
                "top 1": "-",
                "top 2": "-",
                "top 3": "-",
                "repost by sponsor": "-",
                "comment by participant": "IG: https://www.instagram.com/p/CfG6j5Brrel/\nFB: https://www.facebook.com/watch/?v=1100965980454061&extid=NS-UNK-UNK-UNK-IOS_GK0T-GK1C&ref=sharing\nTW: https://twitter.com/1ATHStudio/status/1539591553320091650",
                "Main Video/Track (gdrive)": "https://drive.google.com/drive/u/1/folders/1UvXwHFtejbsNHkgxLskLWw0k2DJ0WKJV",
                "Introduction Video (gdrive)": "https://drive.google.com/drive/u/1/folders/1UvXwHFtejbsNHkgxLskLWw0k2DJ0WKJV",
                "IG                                                         4.6 Mio": "1k https://www.instagram.com/alexkeston_/",
                "(Main) post by sponsor": "TT: https://vt.tiktok.com/ZSd3hBDRr/?k=1 \nYT: https://youtu.be/hijy9viyuzc \nIG: https://www.instagram.com/tv/CfG6j5Brrel/?utm_source=ig_web_copy_link                                                                                                                                                   \nTW: https://twitter.com/1ATHStudio/status/1539591553320091650  \nFB: https://fb.watch/dOOPFD0iHG/",
                "(Main) repost by participant": "IG: https://www.instagram.com/stories/alexkeston_/2866463494696801449/ \nTW: https://twitter.com/alexkeston6 \nFB: https://fb.watch/dQPq1u33IN/",
                "(Intro) post by sponsor": "YT: https://youtu.be/ztQ6hb4hM3s \nTT: https://www.tiktok.com/@1ath.studio/video/7113530460784839937?is_from_webapp=1&sender_device=pc&web_id=7094173033330034182 \nFB: https://fb.watch/dU44aeFDO5/ \nIG: https://www.instagram.com/tv/CfRMDOOOdav/?utm_source=ig_web_copy_link \nTW: https://twitter.com/1ATHStudio/status/1541042497232707585?s=20&t=y1HylRUzQSPh_P--1QGQaw",
                "(Intro) repost by participant": "https://www.youtube.com/shorts/Sp9XSTaI_f0\nhttps://twitter.com/alexkeston6/status/1541295698934517761",
                "(Promo) post by sponsor": "The link is above",
                "(Promo) repost by participant": "",
                "TT                       1.5Mio": "N/A",
                "(Main) post by sponsor__1": "",
                "(Main) repost by participant__1": "",
                "(Intro) post by sponsor__1": "",
                "(Intro) repost by participant__1": "",
                "(Promo) post by sponsor__1": "",
                "(Promo) repost by participant__1": "",
                "Youtube       1.1Mio": "0 https://www.youtube.com/c/AlexKeston",
                "(Main) post by sponsor__2": "",
                "(Main) repost by participant__2": "",
                "(Intro) post by sponsor__2": "",
                "(Intro) repost by participant__2": "",
                "(Promo) post by sponsor__2": "",
                "(Promo) repost by participant__2": "",
                "TW": "https://twitter.com/alexkeston6",
                "(Main) post by sponsor__3": "",
                "(Main) repost by participant__3": "",
                "(Intro) post by sponsor__3": "",
                "(Intro) repost by participant__3": "",
                "(Promo) post by sponsor__3": "the link is above",
                "(Promo) repost by participant__3": "",
                "FB                3.8 Mio": "1K https://www.facebook.com/alexkestonofficial",
                "(Main) post by sponsor__4": "",
                "(Main) repost by participant__4": "",
                "(Intro) post by sponsor__4": "",
                "(Intro) repost by participant__4": "",
                "(Promo) post by sponsor__4": "The link is above",
                "(Promo) repost by participant__4": "",
                "Contact": "Fiverr",
                "Manager": "Milan/Anatoliy",
                "Conditions/Comments": "as to the Rules file, 30 eur, +25% prize pool",
                "Country": "India"
            },
            {
                "#": 34,
                "Name": "Ilias / iliasam",
                "Dancer/DJ?": "DJ",
                "Agreement": "sent track",
                "Name_Official": "Ilias",
                "Inrto/Description_Official": "20 Years old Music Producer & Beatmaker & audio engineer and The Owner of \"TRAP MASTERY",
                "top 1": "-",
                "top 2": "-",
                "top 3": "-",
                "repost by sponsor": "-",
                "comment by participant": "-",
                "Main Video/Track (gdrive)": "https://drive.google.com/drive/u/3/folders/1eNwUHSyBKJS1q843iBlecXuF6p84weLf",
                "Introduction Video (gdrive)": "no intro agreed with him",
                "IG                                                         4.6 Mio": "0 https://www.instagram.com/trap_mastery/?hl=fr",
                "(Main) post by sponsor": "TT: https://www.tiktok.com/@1ath.studio/video/7112087902380690689?is_from_webapp=1&sender_device=pc&web_id=7112032987612562950 \nYT: https://www.youtube.com/watch?v=zmQM-FkcI9g \nIG: https://www.instagram.com/tv/CfHNMMDu8QK/?utm_source=ig_web_copy_link                                                                                                                                                 \nTW: https://twitter.com/1ATHStudio/status/1539641597910220800   \nFB: https://fb.watch/dO-jyM6nNR/",
                "(Main) repost by participant": "Asked to repost",
                "(Intro) post by sponsor": "YT: \nTT:\nFB:\nIG:\nTW:",
                "(Intro) repost by participant": "",
                "(Promo) post by sponsor": "The link is above",
                "(Promo) repost by participant": "",
                "TT                       1.5Mio": "0 https://www.tiktok.com/@trap.mastery?is_from_webapp=1&sender_device=pc",
                "(Main) post by sponsor__1": "",
                "(Main) repost by participant__1": "",
                "(Intro) post by sponsor__1": "",
                "(Intro) repost by participant__1": "",
                "(Promo) post by sponsor__1": "",
                "(Promo) repost by participant__1": "",
                "Youtube       1.1Mio": "45K https://www.youtube.com/c/TRAPMASTERY",
                "(Main) post by sponsor__2": "",
                "(Main) repost by participant__2": "",
                "(Intro) post by sponsor__2": "",
                "(Intro) repost by participant__2": "",
                "(Promo) post by sponsor__2": "",
                "(Promo) repost by participant__2": "",
                "TW": "N/A",
                "(Main) post by sponsor__3": "",
                "(Main) repost by participant__3": "",
                "(Intro) post by sponsor__3": "",
                "(Intro) repost by participant__3": "",
                "(Promo) post by sponsor__3": "the link is above",
                "(Promo) repost by participant__3": "",
                "FB                3.8 Mio": "https://m.facebook.com/pages/category/Musician/Trap-Mastery-104890837912700",
                "(Main) post by sponsor__4": "",
                "(Main) repost by participant__4": "",
                "(Intro) post by sponsor__4": "",
                "(Intro) repost by participant__4": "",
                "(Promo) post by sponsor__4": "The link is above",
                "(Promo) repost by participant__4": "",
                "Contact": "Fiverr",
                "Manager": "Milan/Anatoliy",
                "Conditions/Comments": "as to the Rules file, no intro, 50 eur, +25% prize pool",
                "Country": "Morocco"
            },
            {
                "#": 35,
                "Name": "Estefanía Navas / estefanianr",
                "Dancer/DJ?": "Dancer",
                "Agreement": "sent video",
                "Name_Official": "Estefanía Navas",
                "Inrto/Description_Official": "Venezuelan dancer with more than 10 years of experience and passionate about Latin dance, lady style, sexy style, and any style that can make a woman feel empowered with her sensuality. currently based in medellin",
                "top 1": "",
                "top 2": "",
                "top 3": "",
                "repost by sponsor": "IG: https://www.instagram.com/reel/Ce4_pgJqRLh/?igshid=YmMyMTA2M2Y= + https://instagram.com/stories/1ath.studio/2862486384240623545?utm_source=ig_story_item_share&igshid=YmMyMTA2M2Y= \nTT: https://www.tiktok.com/@1ath.studio/video/7109869815094988034?_t=8TDM06gSxs6&_r=1  \nTW: https://twitter.com/1ATHStudio/status/1537616019681853441?s=20&t=LUxV2_8jcSAFpgB4va7ILA    \nYT: https://www.youtube.com/shorts/cGDighmosCw  \nFB https://fb.watch/dHZwPnOBbd +  https://www.facebook.com/stories/110809554825834/UzpfSVNDOjMyNzc1MDUwNjIyNjczMA==/?view_single=1&source=shared_permalink",
                "comment by participant": "TW: https://twitter.com/Estefanianr/status/1537631979780378624\nIG: https://www.instagram.com/p/Ce4_pgJqRLh/\nTT: https://www.tiktok.com/@1ath.studio/video/7112088785747250433?is_from_webapp=1&sender_device=pc&web_id=7112032987612562950",
                "Main Video/Track (gdrive)": "https://drive.google.com/drive/u/1/folders/1misj8VoMe7nMWZJzu7MFZRFLPsDBpsD_",
                "Introduction Video (gdrive)": "https://drive.google.com/drive/u/1/folders/1JyIxlNpDcwki_qQ3bxh1kRJ2LD8H6EXa",
                "IG                                                         4.6 Mio": "17K https://www.instagram.com/estefanianavas.r/",
                "(Main) post by sponsor": "TT: https://www.tiktok.com/@1ath.studio/video/7112088785747250433?is_from_webapp=1&sender_device=pc&web_id=7112032987612562950 \nYT: https://youtu.be/UOTZkrsAeKM  \nIG: https://www.instagram.com/tv/CfHOOXPt0iv/?utm_source=ig_web_copy_link                                                                                                                                               \nTW: https://twitter.com/1ATHStudio/status/1539634920833835011    \nFB: https://fb.watch/dO-OeItB1E/",
                "(Main) repost by participant": "TW: https://twitter.com/estefanianr",
                "(Intro) post by sponsor": "FB https://fb.watch/dQlBkdQgr3 \nTW https://twitter.com/1ATHStudio/status/1540019167004336128 \nIG https://www.instagram.com/tv/CfJ8pCfOPgB/?utm_source=ig_web_copy_link \nYT: https://youtu.be/978EAqF6xog \nTT : https://www.tiktok.com/@1ath.studio/video/7112486028291722497?is_from_webapp=1&sender_device=pc&web_id=7094173033330034182",
                "(Intro) repost by participant": "",
                "(Promo) post by sponsor": "The link is above",
                "(Promo) repost by participant": "",
                "TT                       1.5Mio": "1.7K https://www.tiktok.com/@estefanianavasr?lang=en",
                "(Main) post by sponsor__1": "",
                "(Main) repost by participant__1": "",
                "(Intro) post by sponsor__1": "",
                "(Intro) repost by participant__1": "",
                "(Promo) post by sponsor__1": "",
                "(Promo) repost by participant__1": "",
                "Youtube       1.1Mio": "N/A",
                "(Main) post by sponsor__2": "",
                "(Main) repost by participant__2": "",
                "(Intro) post by sponsor__2": "",
                "(Intro) repost by participant__2": "",
                "(Promo) post by sponsor__2": "",
                "(Promo) repost by participant__2": "",
                "TW": "https://twitter.com/estefanianr",
                "(Main) post by sponsor__3": "",
                "(Main) repost by participant__3": "",
                "(Intro) post by sponsor__3": "",
                "(Intro) repost by participant__3": "",
                "(Promo) post by sponsor__3": "the link is above",
                "(Promo) repost by participant__3": "",
                "FB                3.8 Mio": "https://www.facebook.com/estefania.navas1",
                "(Main) post by sponsor__4": "",
                "(Main) repost by participant__4": "",
                "(Intro) post by sponsor__4": "",
                "(Intro) repost by participant__4": "",
                "(Promo) post by sponsor__4": "The link is above",
                "(Promo) repost by participant__4": "",
                "Contact": "Fiverr",
                "Manager": "Milan/Anatoliy",
                "Conditions/Comments": "as to Rules file 180 eur, +25% prize pool",
                "Country": "Colombia"
            },
            {
                "#": 36,
                "Name": "Aliaksandr Yuryeu",
                "Dancer/DJ?": "DJ",
                "Agreement": "sent track",
                "Name_Official": "Alex BLGN",
                "Inrto/Description_Official": "I've been creating music and working with sound for more than 8 years. I have a degree in music art and conducting. Now I work as a sound designer at BeatHead, a mobile music app developer, and I also make music and create sound for games and movies.\n\nBLGN is my alter ego, the other side of my creativity.\nUnder this alias I write dnb, dubstep, house, pop music and perform with dj-sets at rare festivals and private parties. I've got several releases on British and American labels and high praise for my performance at Eurovision selection in 2019.",
                "top 1": "-",
                "top 2": "-",
                "top 3": "-",
                "repost by sponsor": "-",
                "comment by participant": "-",
                "Main Video/Track (gdrive)": "https://drive.google.com/drive/u/1/folders/13kJTzsq1ROajzt7s27Ni24hQKMg9myhI",
                "Introduction Video (gdrive)": "https://drive.google.com/drive/u/1/folders/13kJTzsq1ROajzt7s27Ni24hQKMg9myhI",
                "IG                                                         4.6 Mio": "1k https://www.instagram.com/blgnmusic/",
                "(Main) post by sponsor": "TT: https://www.tiktok.com/@1ath.studio/video/7112345705439694082?is_from_webapp=1&sender_device=pc&web_id=7112032987612562950 \nYT: https://youtu.be/Fj1Ndzi0Mds \nIG: https://www.instagram.com/tv/CfI-Yqdprsd/?igshid=YmMyMTA2M2Y=                                                                                                                                              \nTW: https://twitter.com/1ATHStudio/status/1539878453750550528   \nFB: https://fb.watch/dPQNr-7wz4/",
                "(Main) repost by participant": "IG: https://www.instagram.com/stories/blgnmusic/2866834672296410421/\nYT: https://youtube.com/shorts/yx2-dgXlPsU?feature=share\nFB: https://www.facebook.com/100004988704325/posts/pfbid02nExYE322fQyzxrg3eta677fGsuN1mfTcg2wWBWw7av4nkovnXGToJNdcsKTKh11Ql/?d=n  \nTT: https://www.tiktok.com/@blgnmusic/video/7112541799599705349?is_copy_url=1&is_from_webapp=v1",
                "(Intro) post by sponsor": "YT: https://youtu.be/cALBM0WBAII \nTT: https://www.tiktok.com/@1ath.studio/video/7113543337553956097?is_from_webapp=1&sender_device=pc&web_id=7094173033330034182 \nFB: https://fb.watch/dU6C9K-UP_/ \nIG: https://www.instagram.com/tv/CfRSfEZsGfn/?utm_source=ig_web_copy_link \nTW: https://twitter.com/1ATHStudio/status/1541054868248563713?s=20&t=vZA6AgL4dyy-B--2Ndz2QQ",
                "(Intro) repost by participant": "",
                "(Promo) post by sponsor": "The link is above",
                "(Promo) repost by participant": "",
                "TT                       1.5Mio": "https://www.tiktok.com/@blgnmusic",
                "(Main) post by sponsor__1": "",
                "(Main) repost by participant__1": "",
                "(Intro) post by sponsor__1": "",
                "(Intro) repost by participant__1": "",
                "(Promo) post by sponsor__1": "",
                "(Promo) repost by participant__1": "",
                "Youtube       1.1Mio": "https://www.youtube.com/channel/UCSJuknVuTOJyrYFmIzENbFQ",
                "(Main) post by sponsor__2": "",
                "(Main) repost by participant__2": "",
                "(Intro) post by sponsor__2": "",
                "(Intro) repost by participant__2": "",
                "(Promo) post by sponsor__2": "",
                "(Promo) repost by participant__2": "",
                "TW": "N/A",
                "(Main) post by sponsor__3": "",
                "(Main) repost by participant__3": "",
                "(Intro) post by sponsor__3": "",
                "(Intro) repost by participant__3": "",
                "(Promo) post by sponsor__3": "the link is above",
                "(Promo) repost by participant__3": "",
                "FB                3.8 Mio": "1k https://www.facebook.com/sasha.balagan/",
                "(Main) post by sponsor__4": "",
                "(Main) repost by participant__4": "",
                "(Intro) post by sponsor__4": "",
                "(Intro) repost by participant__4": "",
                "(Promo) post by sponsor__4": "The link is above",
                "(Promo) repost by participant__4": "",
                "Contact": "telegram",
                "Manager": "Aziz/Anatoliy",
                "Conditions/Comments": "prize pool",
                "Country": "Belarus"
            },
            {
                "#": 37,
                "Name": "Hoofer Dance Mob / hooferism",
                "Dancer/DJ?": "Dancer/Group",
                "Agreement": "sent video",
                "Name_Official": "Hoofer Dance Mob",
                "Inrto/Description_Official": "The dancers of \"Hoofer Dance Mob\" - Guga, Nefflex and Libra joined our challenge, They are Professional Freestyle Dancers from Tbilisi, Georgia and they are making original and creative Hip-Hop dance content.",
                "top 1": "",
                "top 2": "",
                "top 3": "",
                "repost by sponsor": "TT: https://vt.tiktok.com/ZSdvBPmxg/?k=1 \nIG stories : https://instagram.com/stories/1ath.studio/2862871777699023717?utm_source=ig_story_item_share&igshid=YmMyMTA2M2Y=   \nIG: https://www.instagram.com/reel/Ce68IXtPTLo/?igshid=YmMyMTA2M2Y=  \nFB: https://fb.watch/dJrBfh6Fwo/  \nTW:   https://twitter.com/1athstudio/status/1538156031561326592?s=21&t=tshld1DoW2IOVta-XnyOng \nYTS: https://youtube.com/shorts/6n8k8CgkQdA?feature=share",
                "comment by participant": "IG: https://www.instagram.com/tv/CfHPbNtOdRI/?utm_source=ig_web_copy_link\nFB: https://www.facebook.com/watch/?v=744219956852111&ref=sharing\nTW: https://twitter.com/1ATHStudio/status/1539638154185117696\nYT: https://www.youtube.com/watch?v=8xfPCWv9-LM&ab_channel=1ATH.Studio",
                "Main Video/Track (gdrive)": "https://drive.google.com/drive/u/1/folders/1Gjj3PEpJPQrY18ModPvSsKzUCJTmgoSM",
                "Introduction Video (gdrive)": "https://drive.google.com/drive/u/1/folders/1Gjj3PEpJPQrY18ModPvSsKzUCJTmgoSM",
                "IG                                                         4.6 Mio": "https://www.instagram.com/itshoofer/ \n3.5k https://www.instagram.com/Hooferism/\n1.5k https://www.instagram.com/iivvyyyy/ \n3k https://www.instagram.com/nefflex/?hl=en \n\nNOT TO TAG the below from our side, they would us it for reposting, but ask us not to use for reposting\n25K https://www.instagram.com/nft.dance/ \n4.4K https://www.instagram.com/skimaskdancegang/",
                "(Main) post by sponsor": "TT: https://www.tiktok.com/@1ath.studio/video/7112091696585821441?is_from_webapp=1&sender_device=pc&web_id=7112032987612562950 \nYT: https://youtu.be/8xfPCWv9-LM  \nIG: https://www.instagram.com/tv/CfHPbNtOdRI/?utm_source=ig_web_copy_link                                                                                                                                            \nTW: https://twitter.com/1ATHStudio/status/1539638154185117696 \nFB: https://fb.watch/dOYZ09GBL6/",
                "(Main) repost by participant": "IG: https://www.instagram.com/stories/itshoofer/2866439310056957846/ \nTW: https://twitter.com/Hooferism\nhttps://twitter.com/iiiivvyyy/status/1539698995651551232?s=21&t=G1p_jUOpQEkCKZ5OQcYMEA",
                "(Intro) post by sponsor": "FB https://fb.watch/dQm08-AH54 \nTW https://twitter.com/1ATHStudio/status/1540022573530071043 \nIG https://www.instagram.com/tv/CfJ-WoXLXsb/?utm_source=ig_web_copy_link \nTT https://www.tiktok.com/@1ath.studio/video/7112487637067320577?is_from_webapp=1&sender_device=pc&web_id=7094173033330034182 \nYT https://www.youtube.com/watch?v=CW_KJBb6-xw",
                "(Intro) repost by participant": "",
                "(Promo) post by sponsor": "The link is above",
                "(Promo) repost by participant": "",
                "TT                       1.5Mio": "45k https://www.tiktok.com/@hooferism  81k https://www.tiktok.com/@Libra.wrld  6.5k https://www.tiktok.com/@NefflexTheGod",
                "(Main) post by sponsor__1": "",
                "(Main) repost by participant__1": "",
                "(Intro) post by sponsor__1": "",
                "(Intro) repost by participant__1": "",
                "(Promo) post by sponsor__1": "",
                "(Promo) repost by participant__1": "",
                "Youtube       1.1Mio": "https://www.youtube.com/channel/UCKQbThvdu9x-lNQc7ImySEA",
                "(Main) post by sponsor__2": "",
                "(Main) repost by participant__2": "",
                "(Intro) post by sponsor__2": "",
                "(Intro) repost by participant__2": "",
                "(Promo) post by sponsor__2": "",
                "(Promo) repost by participant__2": "",
                "TW": "https://twitter.com/Hooferism \nhttps://twitter.com/iiiivvyyy \n1k https://twitter.com/Nefflex",
                "(Main) post by sponsor__3": "",
                "(Main) repost by participant__3": "",
                "(Intro) post by sponsor__3": "",
                "(Intro) repost by participant__3": "",
                "(Promo) post by sponsor__3": "the link is above",
                "(Promo) repost by participant__3": "",
                "FB                3.8 Mio": "1k https://www.facebook.com/Hooferism \nhttps://www.facebook.com/LibraWrld \n1k https://www.facebook.com/Nefflex",
                "(Main) post by sponsor__4": "",
                "(Main) repost by participant__4": "",
                "(Intro) post by sponsor__4": "",
                "(Intro) repost by participant__4": "",
                "(Promo) post by sponsor__4": "The link is above",
                "(Promo) repost by participant__4": "",
                "Contact": "Fiverr",
                "Manager": "Milan/Anatoliy",
                "Conditions/Comments": "as to Rules file 700 eur, +25% prize pool\ntshirts, masks with Iggy NFTs etc",
                "Country": "Georgia"
            },
            {
                "#": 38,
                "Name": "Nero Dance\nEmin Useynov",
                "Dancer/DJ?": "Dancer/Group",
                "Agreement": "sent video",
                "Name_Official": "Nero Dance Center",
                "Inrto/Description_Official": "",
                "top 1": "",
                "top 2": "",
                "top 3": "",
                "repost by sponsor": "TT: https://www.tiktok.com/@1ath.studio/video/7111647312480374017?is_from_webapp=1&sender_device=pc&web_id=7094173033330034182 \nIGR: https://www.instagram.com/reel/CfEK6grD-e1/?igshid=YmMyMTA2M2Y= \nIG stories: https://instagram.com/stories/1ath.studio/2865471434178502250?utm_source=ig_story_item_share&igshid=YmMyMTA2M2Y= \nTW: https://twitter.com/1athstudio/status/1539222788191490050?s=21&t=-BADdz3Nrb69r2QNXiMKaw \nFB: https://fb.watch/dNtJIv1wmR/ \nYTS: https://youtube.com/shorts/w9RBD1pyWsk?feature=share",
                "comment by participant": "IG: https://www.instagram.com/reel/CfEK6grD-e1/?igshid=YmMyMTA2M2Y%3D\nTT: https://www.tiktok.com/@1ath.studio/video/7112063777079627009?is_from_webapp=1&sender_device=pc&web_id=7112032987612562950\nFB: https://www.facebook.com/watch/?v=3523318334615509&extid=NS-UNK-UNK-UNK-IOS_GK0T-GK1C&ref=sharing",
                "Main Video/Track (gdrive)": "https://drive.google.com/drive/u/1/folders/163kUKPt_SphwU4ABNtQc75LQJO9ylYfZ",
                "Introduction Video (gdrive)": "https://drive.google.com/drive/folders/1w4Sn9Vo5VT_akZUw46tYe8HOWM6XofUw",
                "IG                                                         4.6 Mio": "16k https://www.instagram.com/nerodancecenter",
                "(Main) post by sponsor": "TT: https://www.tiktok.com/@1ath.studio/video/7112063777079627009?is_from_webapp=1&sender_device=pc&web_id=7112032987612562950  \nYT: https://youtu.be/jiWD_Bsb0WA \nIG: https://www.instagram.com/tv/CfHC97WroOj/?utm_source=ig_web_copy_link \nTW: https://twitter.com/1ATHStudio/status/1539609787935166464 \nFB: https://fb.watch/dOSNtEhQOG/",
                "(Main) repost by participant": "Asked to repost FB: https://fb.watch/dPUVH3s6Jn/ \nIG: https://www.instagram.com/stories/nerodancecenter/2866987629874987797/\nhttps://www.facebook.com/emin.useynov",
                "(Intro) post by sponsor": "YT: https://www.youtube.com/watch?v=e6FNNQMUcaI&ab_channel=1ATH.Studio \nTT: https://www.tiktok.com/@1ath.studio/video/7114551220273941762?is_copy_url=1&is_from_webapp=v1 \nFB: https://www.facebook.com/watch/?v=410817491001748&extid=NS-UNK-UNK-UNK-IOS_GK0T-GK1C&ref=sharing \nIG:https://www.instagram.com/tv/CfWnyeUr8EZ/?utm_source=ig_web_copy_link \nTW: https://twitter.com/1ATHStudio/status/1541817623863754759",
                "(Intro) repost by participant": "",
                "(Promo) post by sponsor": "The link is above",
                "(Promo) repost by participant": "Requested to disregard the message",
                "TT                       1.5Mio": "8k https://www.tiktok.com/@nerodancecenterbaku",
                "(Main) post by sponsor__1": "",
                "(Main) repost by participant__1": "",
                "(Intro) post by sponsor__1": "",
                "(Intro) repost by participant__1": "",
                "(Promo) post by sponsor__1": "",
                "(Promo) repost by participant__1": "",
                "Youtube       1.1Mio": "11k https://www.youtube.com/c/NERODanceCentre",
                "(Main) post by sponsor__2": "",
                "(Main) repost by participant__2": "",
                "(Intro) post by sponsor__2": "",
                "(Intro) repost by participant__2": "",
                "(Promo) post by sponsor__2": "",
                "(Promo) repost by participant__2": "",
                "TW": "N/A",
                "(Main) post by sponsor__3": "",
                "(Main) repost by participant__3": "",
                "(Intro) post by sponsor__3": "",
                "(Intro) repost by participant__3": "",
                "(Promo) post by sponsor__3": "the link is above",
                "(Promo) repost by participant__3": "",
                "FB                3.8 Mio": "https://www.facebook.com/emin.useynov",
                "(Main) post by sponsor__4": "",
                "(Main) repost by participant__4": "",
                "(Intro) post by sponsor__4": "",
                "(Intro) repost by participant__4": "",
                "(Promo) post by sponsor__4": "The link is above",
                "(Promo) repost by participant__4": "",
                "Contact": "emin.useynov@gmail.com\n+994503949440",
                "Manager": "Aziz",
                "Conditions/Comments": "prize pool",
                "Country": "Azerbaijan"
            },
            {
                "#": 39,
                "Name": "HAMUTSUN_SERVE CREW",
                "Dancer/DJ?": "Dancer/Group",
                "Agreement": "sent video",
                "Name_Official": "HAMUTSUN SERVE CREW",
                "Inrto/Description_Official": "",
                "top 1": "https://vt.tiktok.com/ZSdcPkuJc/",
                "top 2": "https://vt.tiktok.com/ZSdcPkuJc/",
                "top 3": "https://www.facebook.com/riki.onodera.9",
                "repost by sponsor": "TT: https://www.tiktok.com/@1ath.studio/video/7111715765878902018?is_copy_url=1&is_from_webapp=v1&lang=en \nIGR: https://www.instagram.com/reel/CfEqyx2jN4P/?igshid=YmMyMTA2M2Y= \nIG stories: https://instagram.com/stories/1ath.studio/2865605541375083044?utm_source=ig_story_item_share&igshid=YmMyMTA2M2Y= \nFB: https://fb.watch/dNGL0CuSrg/ \nTW: https://twitter.com/1athstudio/status/1539279808462716929?s=21&t=-BADdz3Nrb69r2QNXiMKaw",
                "comment by participant": "IG: https://www.instagram.com/tv/CfHWpIVNpuA/?utm_source=ig_web_copy_link\nTT: https://www.tiktok.com/@1ath.studio/video/7112107039475682561?is_from_webapp=1&sender_device=pc&web_id=7112032987612562950\nTW: https://twitter.com/1ATHStudio/status/1539653138072084480",
                "Main Video/Track (gdrive)": "https://drive.google.com/drive/u/1/folders/11L614herS3sKtnu81iNtgLQs8C1PQ65N",
                "Introduction Video (gdrive)": "https://drive.google.com/drive/u/1/folders/14ORkiu_gu_5XpTdN_qUn12_IHLMVHUT4",
                "IG                                                         4.6 Mio": "7k https://www.instagram.com/hamutsun_serve",
                "(Main) post by sponsor": "TT: https://www.tiktok.com/@1ath.studio/video/7112107039475682561?is_from_webapp=1&sender_device=pc&web_id=7112032987612562950  \nYT: https://youtu.be/tMiMI6h8L-k  \nIG: https://www.instagram.com/tv/CfHWpIVNpuA/?utm_source=ig_web_copy_link                                                                                                                                      \nTW: https://twitter.com/1ATHStudio/status/1539653138072084480 \nFB: https://fb.watch/dP0sH-cYwW/",
                "(Main) repost by participant": "Asked to repost IG: https://www.instagram.com/p/CfHYjFnP5_d/ \nTW: https://twitter.com/hamutsunriki/status/1539876801966931969?s=20&t=ic4wtBhAz-KK_Y2VgV69cg",
                "(Intro) post by sponsor": "FB: https://fb.watch/dRgkfUP6a7/  \nIG https://www.instagram.com/tv/CfLttiYMY7c/?utm_source=ig_web_copy_link \nYT https://youtu.be/muPcAok7VPk \nTT https://www.tiktok.com/@1ath.studio/video/7112738552852663554?is_from_webapp=1&sender_device=pc&web_id=7094173033330034182 \nTW https://twitter.com/1ATHStudio/status/1540269329341636609",
                "(Intro) repost by participant": "Asked to repost",
                "(Promo) post by sponsor": "The link is above",
                "(Promo) repost by participant": "Requested to disregard the message",
                "TT                       1.5Mio": "171k https://www.tiktok.com/@rikiccho",
                "(Main) post by sponsor__1": "",
                "(Main) repost by participant__1": "",
                "(Intro) post by sponsor__1": "",
                "(Intro) repost by participant__1": "",
                "(Promo) post by sponsor__1": "",
                "(Promo) repost by participant__1": "",
                "Youtube       1.1Mio": "0 https://www.youtube.com/channel/UCvSlIHAOfODi1ZJ_lspPz5Q",
                "(Main) post by sponsor__2": "",
                "(Main) repost by participant__2": "",
                "(Intro) post by sponsor__2": "",
                "(Intro) repost by participant__2": "",
                "(Promo) post by sponsor__2": "",
                "(Promo) repost by participant__2": "",
                "TW": "https://twitter.com/hamutsunriki?t=-49E-mdautUi4CslAXArTw&s=09",
                "(Main) post by sponsor__3": "",
                "(Main) repost by participant__3": "",
                "(Intro) post by sponsor__3": "",
                "(Intro) repost by participant__3": "",
                "(Promo) post by sponsor__3": "the link is above",
                "(Promo) repost by participant__3": "",
                "FB                3.8 Mio": "N/A",
                "(Main) post by sponsor__4": "",
                "(Main) repost by participant__4": "",
                "(Intro) post by sponsor__4": "",
                "(Intro) repost by participant__4": "",
                "(Promo) post by sponsor__4": "The link is above",
                "(Promo) repost by participant__4": "",
                "Contact": "riki999riki999@ezweb.ne.jp",
                "Manager": "Aziz",
                "Conditions/Comments": "prize pool",
                "Country": "Japan"
            },
            {
                "#": 40,
                "Name": "Jika",
                "Dancer/DJ?": "Dancer",
                "Agreement": "sent video",
                "Name_Official": "Jika",
                "Inrto/Description_Official": "Been dancing in music videos, trained at dance studios like millennium, playground, ida and etc",
                "top 1": "https://youtu.be/hTLrY2tJkcc",
                "top 2": "https://www.instagram.com/tv/BwM6bf8nrwI/",
                "top 3": "https://www.instagram.com/reel/CTSODqqnGFO/?utm_source=ig_web_copy_",
                "repost by sponsor": "TT: https://www.tiktok.com/@1ath.studio/video/7110263562832055553? \n\nTW: https://twitter.com/1ATHStudio/status/1537878937040146433?s=20&t=TEdb1HW1jlCZMyeXMZMigg  \n\nFB: https://fb.watch/dIE89p_Bkd \n\nYT: https://youtube.com/shorts/eUx6sUSrSyc?feature=share \n\nIG: https://www.instagram.com/reel/Ce6rDjdD9tG/?utm_source=ig_web_copy_link",
                "comment by participant": "IG: https://www.instagram.com/tv/CfHVdHULBFV/?utm_source=ig_web_copy_link\nTT: https://www.tiktok.com/@1ath.studio/video/7112105570030685441?is_from_webapp=1&sender_device=pc&web_id=7112032987612562950\nFB: https://www.facebook.com/watch/?v=392674352825471&ref=sharing",
                "Main Video/Track (gdrive)": "https://drive.google.com/drive/folders/1kSW52OXgO3_onE41xbarj3WXnjAa6MxN",
                "Introduction Video (gdrive)": "https://drive.google.com/drive/folders/1kSW52OXgO3_onE41xbarj3WXnjAa6MxN",
                "IG                                                         4.6 Mio": "147k  https://www.instagram.com/imjika\n\n1.1M https://www.instagram.com/nampaikid/",
                "(Main) post by sponsor": "TT: https://www.tiktok.com/@1ath.studio/video/7112105570030685441?is_from_webapp=1&sender_device=pc&web_id=7112032987612562950 \nYT: https://youtu.be/wANdZTntUzI  \nIG: https://www.instagram.com/tv/CfHVdHULBFV/?utm_source=ig_web_copy_link                                                                                                                                   \nTW: https://twitter.com/1ATHStudio/status/1539651152324984832 \nFB: https://fb.watch/dP0d8WX4_1/",
                "(Main) repost by participant": "Asked to repost IG: https://www.instagram.com/p/CfHgalzp4wF/",
                "(Intro) post by sponsor": "FB: https://fb.watch/dRyqu1xYY8/ \nIG https://www.instagram.com/tv/CfMQnZTOqW0/?utm_source=ig_web_copy_link \nTT https://www.tiktok.com/@1ath.studio/video/7112820038381358337?is_from_webapp=1&sender_device=pc&web_id=7094173033330034182 \nYT https://youtu.be/stlv3ydWoi0 \nTW https://twitter.com/1ATHStudio/status/1540347561000816641",
                "(Intro) repost by participant": "IG: https://www.instagram.com/p/CfHgalzp4wF/",
                "(Promo) post by sponsor": "The link is above",
                "(Promo) repost by participant": "Deleted",
                "TT                       1.5Mio": "2k https://www.tiktok.com/@iamjika\n\n#nampakid",
                "(Main) post by sponsor__1": "",
                "(Main) repost by participant__1": "",
                "(Intro) post by sponsor__1": "",
                "(Intro) repost by participant__1": "",
                "(Promo) post by sponsor__1": "",
                "(Promo) repost by participant__1": "",
                "Youtube       1.1Mio": "1.5k https://www.youtube.com/channel/UC-2gBmH0645htoTOi_JNOqQ\n\n113k https://www.youtube.com/c/NamPaiKid",
                "(Main) post by sponsor__2": "",
                "(Main) repost by participant__2": "",
                "(Intro) post by sponsor__2": "",
                "(Intro) repost by participant__2": "",
                "(Promo) post by sponsor__2": "",
                "(Promo) repost by participant__2": "",
                "TW": "https://twitter.com/imJIKA_",
                "(Main) post by sponsor__3": "",
                "(Main) repost by participant__3": "",
                "(Intro) post by sponsor__3": "",
                "(Intro) repost by participant__3": "",
                "(Promo) post by sponsor__3": "the link is above",
                "(Promo) repost by participant__3": "",
                "FB                3.8 Mio": "4K https://www.facebook.com/JikaNurman \n\n2.7M https://www.facebook.com/thedannampaikid",
                "(Main) post by sponsor__4": "",
                "(Main) repost by participant__4": "",
                "(Intro) post by sponsor__4": "",
                "(Intro) repost by participant__4": "",
                "(Promo) post by sponsor__4": "The link is above",
                "(Promo) repost by participant__4": "",
                "Contact": "jikajagua@gmail.com",
                "Manager": "Aigerim",
                "Conditions/Comments": "$2500 + prize pool",
                "Country": "US"
            },
            {
                "#": 41,
                "Name": "Kristine May",
                "Dancer/DJ?": "Dancer",
                "Agreement": "wants payment, socials are to loow and no time, declined.",
                "Name_Official": "Kristine May",
                "Inrto/Description_Official": "I have been a professional dancer for over 19 years. I’ve danced on award shows like the ACMAS and in movies and music videos, etc",
                "top 1": "https://www.instagram.com/reel/CYFDZrMr7v6/?igshid=NmZiMzY2Mjc=",
                "top 2": "https://www.tiktok.com/t/ZTd3nPHcg/?k=1",
                "top 3": "https://www.instagram.com/reel/CWg26Ogs8Cw/?igshid=NmZiMzY2Mjc=",
                "repost by sponsor": "",
                "comment by participant": "",
                "Main Video/Track (gdrive)": "",
                "Introduction Video (gdrive)": "",
                "IG                                                         4.6 Mio": "5k https://www.instagram.com/kristinekmay/",
                "(Main) post by sponsor": "",
                "(Main) repost by participant": "",
                "(Intro) post by sponsor": "",
                "(Intro) repost by participant": "",
                "(Promo) post by sponsor": "The link is above",
                "(Promo) repost by participant": "",
                "TT                       1.5Mio": "0 https://www.tiktok.com/@kristinemay51",
                "(Main) post by sponsor__1": "",
                "(Main) repost by participant__1": "",
                "(Intro) post by sponsor__1": "",
                "(Intro) repost by participant__1": "",
                "(Promo) post by sponsor__1": "",
                "(Promo) repost by participant__1": "",
                "Youtube       1.1Mio": "N/A",
                "(Main) post by sponsor__2": "",
                "(Main) repost by participant__2": "",
                "(Intro) post by sponsor__2": "",
                "(Intro) repost by participant__2": "",
                "(Promo) post by sponsor__2": "",
                "(Promo) repost by participant__2": "",
                "TW": "500 https://mobile.twitter.com/kristinekmay/with_replies",
                "(Main) post by sponsor__3": "",
                "(Main) repost by participant__3": "",
                "(Intro) post by sponsor__3": "",
                "(Intro) repost by participant__3": "",
                "(Promo) post by sponsor__3": "the link is above",
                "(Promo) repost by participant__3": "",
                "FB                3.8 Mio": "306 https://www.facebook.com/Kristine-May-505776942794006",
                "(Main) post by sponsor__4": "",
                "(Main) repost by participant__4": "",
                "(Intro) post by sponsor__4": "",
                "(Intro) repost by participant__4": "",
                "(Promo) post by sponsor__4": "The link is above",
                "(Promo) repost by participant__4": "",
                "Contact": "kristinekellymay@gmail.com",
                "Manager": "Aziz",
                "Conditions/Comments": "wants payment, socials are to loow and no time, declined.",
                "Country": "US"
            },
            {
                "#": 42,
                "Name": "Hesham",
                "Dancer/DJ?": "DJ",
                "Agreement": "Pinged 20",
                "Name_Official": "Etch",
                "Inrto/Description_Official": "10+ years experience many cool releases and I played with the biggest names in the scene",
                "top 1": "-",
                "top 2": "-",
                "top 3": "-",
                "repost by sponsor": "-",
                "comment by participant": "-",
                "Main Video/Track (gdrive)": "",
                "Introduction Video (gdrive)": "",
                "IG                                                         4.6 Mio": "14K https://www.instagram.com/etchmuzik/",
                "(Main) post by sponsor": "",
                "(Main) repost by participant": "",
                "(Intro) post by sponsor": "",
                "(Intro) repost by participant": "",
                "(Promo) post by sponsor": "The link is above",
                "(Promo) repost by participant": "",
                "TT                       1.5Mio": "613 https://www.tiktok.com/@Etchmuzik",
                "(Main) post by sponsor__1": "",
                "(Main) repost by participant__1": "",
                "(Intro) post by sponsor__1": "",
                "(Intro) repost by participant__1": "",
                "(Promo) post by sponsor__1": "",
                "(Promo) repost by participant__1": "",
                "Youtube       1.1Mio": "N/A",
                "(Main) post by sponsor__2": "",
                "(Main) repost by participant__2": "",
                "(Intro) post by sponsor__2": "",
                "(Intro) repost by participant__2": "",
                "(Promo) post by sponsor__2": "",
                "(Promo) repost by participant__2": "",
                "TW": "N/A",
                "(Main) post by sponsor__3": "",
                "(Main) repost by participant__3": "",
                "(Intro) post by sponsor__3": "",
                "(Intro) repost by participant__3": "",
                "(Promo) post by sponsor__3": "the link is above",
                "(Promo) repost by participant__3": "",
                "FB                3.8 Mio": "4.3K https://www.facebook.com/ETCHmuzik/",
                "(Main) post by sponsor__4": "",
                "(Main) repost by participant__4": "",
                "(Intro) post by sponsor__4": "",
                "(Intro) repost by participant__4": "",
                "(Promo) post by sponsor__4": "The link is above",
                "(Promo) repost by participant__4": "",
                "Contact": "hesham@beyondmngmt.com",
                "Manager": "Aziz",
                "Conditions/Comments": "prize pool",
                "Country": "Egypt"
            },
            {
                "#": 43,
                "Name": "XP-TEAM / xpteamid",
                "Dancer/DJ?": "Dancer",
                "Agreement": "sent video",
                "Name_Official": "XP-TEAM",
                "Inrto/Description_Official": "short description:\nXP-TEAM is community based in Bandung city, Indonesia. With a lot of number teenagers as member they are active doing dance in several genres and got specialist in hip-hop and k-pop dance.",
                "top 1": "",
                "top 2": "",
                "top 3": "",
                "repost by sponsor": "TT: https://vt.tiktok.com/ZSd3Nvoho/?k=1 \nIGR: https://www.instagram.com/reel/CfGW1bxrPMc/?igshid=YmMyMTA2M2Y= \nIG stories : https://instagram.com/stories/1ath.studio/2866081465267179789?utm_source=ig_story_item_share&igshid=YmMyMTA2M2Y= \nFB : https://fb.watch/dOwHj3G-UC/ \nTW: https://twitter.com/1athstudio/status/1539516301701484545?s=21&t=spfV0jr0YAxKfg6bSHEHcQ \nYTS: https://youtube.com/shorts/0MBDVz2724Y?feature=share",
                "comment by participant": "IG: https://www.instagram.com/tv/CfHZpW1srxk/?utm_source=ig_web_copy_link",
                "Main Video/Track (gdrive)": "https://drive.google.com/drive/u/1/folders/1op3luEAbsdUQ3ngOW6QVesoRe881lqoI",
                "Introduction Video (gdrive)": "https://drive.google.com/drive/u/1/folders/1op3luEAbsdUQ3ngOW6QVesoRe881lqoI",
                "IG                                                         4.6 Mio": "4.2K https://www.instagram.com/xpteam_official/",
                "(Main) post by sponsor": "TT: https://www.tiktok.com/@1ath.studio/video/7112115401617591554?is_from_webapp=1&sender_device=pc&web_id=7112032987612562950 \nYT: https://youtu.be/s0BNb5Auf6s  \nIG: https://www.instagram.com/tv/CfHZpW1srxk/?utm_source=ig_web_copy_link                                                                                                                             \nTW: https://twitter.com/1ATHStudio/status/1539659716716285954 \nFB: https://fb.watch/dP21g2yoag/",
                "(Main) repost by participant": "Asked to repost",
                "(Intro) post by sponsor": "YT: https://youtu.be/-zOBw_cE5BY \nTT: https://www.tiktok.com/@1ath.studio/video/7113868178576428289?is_from_webapp=1&sender_device=pc&web_id=7113634897173022214 \nFB: https://fb.watch/dVhKEJJ7Yi/ \nIG: https://www.instagram.com/p/CfTkDRts7Ka/ \nTW: https://twitter.com/1ATHStudio/status/1541372966147063809",
                "(Intro) repost by participant": "",
                "(Promo) post by sponsor": "The link is above",
                "(Promo) repost by participant": "",
                "TT                       1.5Mio": "4.8K https://www.tiktok.com/@xpteam_official?lang=en",
                "(Main) post by sponsor__1": "",
                "(Main) repost by participant__1": "",
                "(Intro) post by sponsor__1": "",
                "(Intro) repost by participant__1": "",
                "(Promo) post by sponsor__1": "",
                "(Promo) repost by participant__1": "",
                "Youtube       1.1Mio": "423k https://www.youtube.com/exralproduction",
                "(Main) post by sponsor__2": "",
                "(Main) repost by participant__2": "",
                "(Intro) post by sponsor__2": "",
                "(Intro) repost by participant__2": "",
                "(Promo) post by sponsor__2": "",
                "(Promo) repost by participant__2": "",
                "TW": "https://twitter.com/exralproduction",
                "(Main) post by sponsor__3": "",
                "(Main) repost by participant__3": "",
                "(Intro) post by sponsor__3": "",
                "(Intro) repost by participant__3": "",
                "(Promo) post by sponsor__3": "the link is above",
                "(Promo) repost by participant__3": "",
                "FB                3.8 Mio": "https://www.facebook.com/exralproduction",
                "(Main) post by sponsor__4": "",
                "(Main) repost by participant__4": "",
                "(Intro) post by sponsor__4": "",
                "(Intro) repost by participant__4": "",
                "(Promo) post by sponsor__4": "The link is above",
                "(Promo) repost by participant__4": "",
                "Contact": "Fiverr",
                "Manager": "Milan/Anatoliy",
                "Conditions/Comments": "as to the Rules file, 800 eur, +25% prize pool",
                "Country": "Indonesia"
            },
            {
                "#": 44,
                "Name": "Paula / paulagrueso",
                "Dancer/DJ?": "Dancer",
                "Agreement": "sent video",
                "Name_Official": "Paula Grueso",
                "Inrto/Description_Official": "my name is Paula Grueso, I studied Acting for 3 years, Modeling and Dance courses of different Latin Rhythms. I'm currently studying English and I am preparing to study psychology since I am passionate about social work with all age ranges and it would be a great contribution to society and especially in the Foundation where I support.",
                "top 1": "-",
                "top 2": "-",
                "top 3": "-",
                "repost by sponsor": "-",
                "comment by participant": "-",
                "Main Video/Track (gdrive)": "https://drive.google.com/drive/u/1/folders/1_RvD3ybb0oGNAkr5mdDNrRO22OHXCdGq",
                "Introduction Video (gdrive)": "https://drive.google.com/drive/u/1/folders/1_RvD3ybb0oGNAkr5mdDNrRO22OHXCdGq",
                "IG                                                         4.6 Mio": "2k https://www.instagram.com/paulagrueso/?hl=en",
                "(Main) post by sponsor": "TT: https://www.tiktok.com/@1ath.studio/video/7112056967752912129?is_from_webapp=1&sender_device=pc&web_id=7112032987612562950 \nYT: https://youtu.be/EQxggM1lzfg \nIG: https://www.instagram.com/tv/CfHBO03MqDR/?utm_source=ig_web_copy_link                                                                                                                  \nTW: https://twitter.com/1ATHStudio/status/1539606886546345984 \nFB: https://fb.watch/dOS1olrq2F/",
                "(Main) repost by participant": "Asked to repost",
                "(Intro) post by sponsor": "IG https://www.instagram.com/tv/CfMYx11PAfu/?utm_source=ig_web_copy_link \nTW https://twitter.com/1ATHStudio/status/1540362999910858752 \nYT https://youtu.be/u0X74SrL-Hs \nTT https://www.tiktok.com/@1ath.studio/video/7112836933709040897?is_from_webapp=1&sender_device=pc&web_id=7094173033330034182 \nFB https://fb.watch/dRCkwTLC-z/",
                "(Intro) repost by participant": "",
                "(Promo) post by sponsor": "The link is above",
                "(Promo) repost by participant": "",
                "TT                       1.5Mio": "6K https://www.tiktok.com/@paulagrueso",
                "(Main) post by sponsor__1": "",
                "(Main) repost by participant__1": "",
                "(Intro) post by sponsor__1": "",
                "(Intro) repost by participant__1": "",
                "(Promo) post by sponsor__1": "",
                "(Promo) repost by participant__1": "",
                "Youtube       1.1Mio": "2.6k https://www.youtube.com/c/PaulaGrueso/videos",
                "(Main) post by sponsor__2": "",
                "(Main) repost by participant__2": "",
                "(Intro) post by sponsor__2": "",
                "(Intro) repost by participant__2": "",
                "(Promo) post by sponsor__2": "",
                "(Promo) repost by participant__2": "",
                "TW": "https://twitter.com/paulagruesov",
                "(Main) post by sponsor__3": "",
                "(Main) repost by participant__3": "",
                "(Intro) post by sponsor__3": "",
                "(Intro) repost by participant__3": "",
                "(Promo) post by sponsor__3": "the link is above",
                "(Promo) repost by participant__3": "",
                "FB                3.8 Mio": "https://www.facebook.com/paula.grueso1",
                "(Main) post by sponsor__4": "",
                "(Main) repost by participant__4": "",
                "(Intro) post by sponsor__4": "",
                "(Intro) repost by participant__4": "",
                "(Promo) post by sponsor__4": "The link is above",
                "(Promo) repost by participant__4": "",
                "Contact": "Fiverr",
                "Manager": "Milan/Anatoliy",
                "Conditions/Comments": "as to the Rules file, 100 eur, +25% prize pool",
                "Country": "Colombia"
            },
            {
                "#": 45,
                "Name": "Alcy / alcymedia",
                "Dancer/DJ?": "Dancer",
                "Agreement": "sent video",
                "Name_Official": "Alcy",
                "Inrto/Description_Official": "My Name is ALCY, FROM MOZAMBIQUE, Africa.\n28 years old.\nI love to dance NEW HIPHOP STYLE & DUBSTEP.",
                "top 1": "",
                "top 2": "",
                "top 3": "",
                "repost by sponsor": "YT https://www.youtube.com/shorts/q7lfKRlyku4\nIG https://www.instagram.com/reel/Ce5t0bLphdj/?igshid=YmMyMTA2M2Y%3D\nTT https://www.tiktok.com/@1ath.studio/video/7110133484374609153?_t=8TEWbRhLSJK&_r=1 \nFB https://www.facebook.com/watch/?v=699238111374357&extid=NS-UNK-UNK-UNK-IOS_GK0T-GK1C&ref=sharing \nTW https://twitter.com/1athstudio/status/1537740980606099456?s=21&t=8iGI1wzttH4DhDuGWfxkSQ  \n \nIGS https://www.instagram.com/stories/1ath.studio/2862523999156195348/?utm_source=ig_story_item_share&igshid=YmMyMTA2M2Y%3D",
                "comment by participant": "IG: https://www.instagram.com/p/Ce5t0bLphdj/\nFB: https://fb.watch/dJ0YHgDpJl/\nTT: https://www.tiktok.com/@1ath.studio/video/7110133484374609153?is_copy_url=1&is_from_webapp=v1\nTW: https://twitter.com/1ATHStudio/status/1539654387311661057\nYT: https://www.youtube.com/watch?v=LkFpQrj2lRU&ab_channel=1ATH.Studio",
                "Main Video/Track (gdrive)": "https://drive.google.com/drive/u/1/folders/1Tk_Gzz7qxhPQOB64-aeP93oSKUEkG7Lg",
                "Introduction Video (gdrive)": "https://drive.google.com/drive/u/1/folders/1Tk_Gzz7qxhPQOB64-aeP93oSKUEkG7Lg",
                "IG                                                         4.6 Mio": "299K https://www.instagram.com/alcy_caluamba/?hl=en",
                "(Main) post by sponsor": "TT: https://www.tiktok.com/@1ath.studio/video/7112108135258574082?is_from_webapp=1&sender_device=pc&web_id=7112032987612562950 \nYT: https://youtu.be/LkFpQrj2lRU \nIG: https://www.instagram.com/tv/CfHXLCGsERx/?utm_source=ig_web_copy_link                                                                                                               \nTW: https://twitter.com/1ATHStudio/status/1539654387311661057 \nFB: https://fb.watch/dP0QtOM7pM/",
                "(Main) repost by participant": "TW: https://twitter.com/Alcy_Caluamba/status/1540002395849166849?s=20&t=Qhl-G2TLwk97OSOC8lPMQw",
                "(Intro) post by sponsor": "FB https://fb.watch/dQmxGWj17c \nIG https://www.instagram.com/tv/CfJ_zsoP8Mj/?utm_source=ig_web_copy_link \nYT https://youtu.be/6dhRJo4kmEY \nTW https://twitter.com/1ATHStudio/status/1540026462698409984 \nTT https://www.tiktok.com/@1ath.studio/video/7112492501629406465?is_from_webapp=1&sender_device=pc&web_id=7094173033330034182",
                "(Intro) repost by participant": "",
                "(Promo) post by sponsor": "The link is above",
                "(Promo) repost by participant": "",
                "TT                       1.5Mio": "13K https://www.tiktok.com/@alcycaluamba173?lang=en",
                "(Main) post by sponsor__1": "",
                "(Main) repost by participant__1": "",
                "(Intro) post by sponsor__1": "",
                "(Intro) repost by participant__1": "",
                "(Promo) post by sponsor__1": "",
                "(Promo) repost by participant__1": "",
                "Youtube       1.1Mio": "115K https://www.youtube.com/ALCY",
                "(Main) post by sponsor__2": "",
                "(Main) repost by participant__2": "",
                "(Intro) post by sponsor__2": "",
                "(Intro) repost by participant__2": "",
                "(Promo) post by sponsor__2": "",
                "(Promo) repost by participant__2": "",
                "TW": "9K https://twitter.com/Alcy_Caluamba?fbclid=IwAR0OGXwXu4imybpPz1E_ejukBwdJ8anqlZAVk7RqX204WbcmRUOBTCea0ZE",
                "(Main) post by sponsor__3": "",
                "(Main) repost by participant__3": "",
                "(Intro) post by sponsor__3": "",
                "(Intro) repost by participant__3": "",
                "(Promo) post by sponsor__3": "the link is above",
                "(Promo) repost by participant__3": "",
                "FB                3.8 Mio": "22K https://www.facebook.com/AlcyActor/",
                "(Main) post by sponsor__4": "",
                "(Main) repost by participant__4": "",
                "(Intro) post by sponsor__4": "",
                "(Intro) repost by participant__4": "",
                "(Promo) post by sponsor__4": "The link is above",
                "(Promo) repost by participant__4": "",
                "Contact": "Fiverr",
                "Manager": "Milan/Anatoliy",
                "Conditions/Comments": "as to the Rules file, 645 eur, +25% prize pool",
                "Country": "India"
            },
            {
                "#": 46,
                "Name": "Enoch / knox_beats",
                "Dancer/DJ?": "DJ",
                "Agreement": "sent track",
                "Name_Official": "Enoch",
                "Inrto/Description_Official": "I'm Enoch, a musician form Johannesburg South Africa.\nIm a drummer, producer and rapper who's into sport and defi",
                "top 1": "",
                "top 2": "",
                "top 3": "",
                "repost by sponsor": "",
                "comment by participant": "IG: https://www.instagram.com/tv/CfG4GZbsc7c/?utm_source=ig_web_copy_link\nTT: https://www.tiktok.com/@1ath.studio/video/7112041435267910914?is_from_webapp=1&sender_device=pc",
                "Main Video/Track (gdrive)": "https://drive.google.com/drive/u/1/folders/1NQQQ2T4FaLRfSL7zLVATRcShFRksfsI7",
                "Introduction Video (gdrive)": "https://drive.google.com/drive/u/1/folders/1NQQQ2T4FaLRfSL7zLVATRcShFRksfsI7",
                "IG                                                         4.6 Mio": "https://www.instagram.com/knox.cc/",
                "(Main) post by sponsor": "TT: https://www.tiktok.com/@1ath.studio/video/7112041435267910914?is_from_webapp=1&sender_device=pc \nYT: https://youtu.be/GD6BSXaxZnY \nIG: https://www.instagram.com/tv/CfG4GZbsc7c/?utm_source=ig_web_copy_link                                                                                                              \nTW:  https://twitter.com/1ATHStudio/status/1539586234405703681 \nFB: https://fb.watch/dON7lGqCXE/",
                "(Main) repost by participant": "IG: https://instagram.com/stories/knox.cc/2866940317655311195?utm_source=ig_story_item_share&igshid=YmMyMTA2M2Y=   \nTT: https://www.tiktok.com/@enoch_cc",
                "(Intro) post by sponsor": "YT: https://youtu.be/3AQNVbUakNY \nTT:  https://www.tiktok.com/@1ath.studio/video/7113547819826318593?is_from_webapp=1&sender_device=pc&web_id=7094173033330034182 \nFB: https://fb.watch/dU7HjQg6_B/ \nIG: https://www.instagram.com/tv/CfRVA8bj7D-/?utm_source=ig_web_copy_link \nTW: https://twitter.com/1ATHStudio/status/1541058848462708736?s=20&t=ShtuLEzO2wfNm5PdwQexCQ",
                "(Intro) repost by participant": "TT: https://www.tiktok.com/@enoch_cc/video/7112409917969009925?is_copy_url=1&is_from_webapp=v1",
                "(Promo) post by sponsor": "The link is above",
                "(Promo) repost by participant": "",
                "TT                       1.5Mio": "https://www.tiktok.com/@enoch_cc",
                "(Main) post by sponsor__1": "",
                "(Main) repost by participant__1": "",
                "(Intro) post by sponsor__1": "",
                "(Intro) repost by participant__1": "",
                "(Promo) post by sponsor__1": "",
                "(Promo) repost by participant__1": "",
                "Youtube       1.1Mio": "https://www.youtube.com/channel/UCbU73rth7nv93iX-5bHZ-MA",
                "(Main) post by sponsor__2": "",
                "(Main) repost by participant__2": "",
                "(Intro) post by sponsor__2": "",
                "(Intro) repost by participant__2": "",
                "(Promo) post by sponsor__2": "",
                "(Promo) repost by participant__2": "",
                "TW": "",
                "(Main) post by sponsor__3": "",
                "(Main) repost by participant__3": "",
                "(Intro) post by sponsor__3": "",
                "(Intro) repost by participant__3": "",
                "(Promo) post by sponsor__3": "the link is above",
                "(Promo) repost by participant__3": "",
                "FB                3.8 Mio": "https://www.facebook.com/Knox-Music-Beats-109196631678665",
                "(Main) post by sponsor__4": "",
                "(Main) repost by participant__4": "",
                "(Intro) post by sponsor__4": "",
                "(Intro) repost by participant__4": "",
                "(Promo) post by sponsor__4": "The link is above",
                "(Promo) repost by participant__4": "",
                "Contact": "Fiverr",
                "Manager": "Milan/Anatoliy",
                "Conditions/Comments": "as to the Rules file, 400 eur, +25% prize pool",
                "Country": "South Africa"
            },
            {
                "#": 47,
                "Name": "Rebeca / rebecatomescu",
                "Dancer/DJ?": "Dancer",
                "Agreement": "sent video",
                "Name_Official": "Rebeca (Ladytron)",
                "Inrto/Description_Official": "Rebeca (Ladytron) took her first streetdance lessons when she was sixteen. Now she is a dance instructor at her own dance studio, with over 10 years of experience, teaching kids and sharing her passion.\nShe worked with several music artists and top rated brands.\nWhen she's not in the danceclass, she is performing in high-tech shows, which include optical illusions, light swords and LED Costumes.",
                "top 1": "",
                "top 2": "",
                "top 3": "",
                "repost by sponsor": "Tt https://www.tiktok.com/@1ath.studio/video/7111836087256878338?is_from_webapp=1&sender_device=pc&web_id=7111687643494647301 \nIg https://www.instagram.com/reel/CfFiyUijYaH/?utm_source=ig_web_copy_link \nYt https://youtube.com/shorts/bN5hWNJhi_Q?feature=share \nTw https://twitter.com/1athstudio/status/1539405057225109505?s=21&t=mAaGuDClDG9nrqhS12uDGw \nFb https://fb.watch/dO6rx-nhH7",
                "comment by participant": "",
                "Main Video/Track (gdrive)": "https://drive.google.com/drive/u/1/folders/1bOgO2wdMiheAo7memYWOiekqB0aTzCYA",
                "Introduction Video (gdrive)": "https://drive.google.com/drive/u/1/folders/1bOgO2wdMiheAo7memYWOiekqB0aTzCYA",
                "IG                                                         4.6 Mio": "2K https://www.instagram.com/rebeca.tms/",
                "(Main) post by sponsor": "TT: https://www.tiktok.com/@1ath.studio/video/7112074842509184258?is_from_webapp=1&sender_device=pc&web_id=7112032987612562950 \nYT: https://www.youtube.com/watch?v=pAFKN4EUDZM \nIG: https://www.instagram.com/tv/CfHKwFwuFP_/?utm_source=ig_web_copy_link                                                                                                            \nTW:  https://twitter.com/1ATHStudio/status/1539627030198771712 \nFB: https://fb.watch/dO_k3mxWS8/",
                "(Main) repost by participant": "IG:https://www.instagram.com/stories/rebeca.tms/2867767487611617408/ \nTT: https://www.tiktok.com/@rebeca.tms/video/7112835447449079045?is_copy_url=1&is_from_webapp=v1   \nFB: https://fb.watch/dSa7JvGhKE/",
                "(Intro) post by sponsor": "YT: https://youtu.be/mdyYNEJ67b8 \nTT: https://www.tiktok.com/@1ath.studio/video/7113936086979726593?is_from_webapp=1&sender_device=pc&web_id=7113634897173022214 \nFB: https://fb.watch/dVv_Rag7wu/ \nIG: https://www.instagram.com/tv/CfT_sdMrT56/?utm_source=ig_web_copy_link    \nTW: https://twitter.com/1ATHStudio/status/1541434173453262854",
                "(Intro) repost by participant": "",
                "(Promo) post by sponsor": "The link is above",
                "(Promo) repost by participant": "",
                "TT                       1.5Mio": "7.5K https://www.tiktok.com/@rebeca.tms",
                "(Main) post by sponsor__1": "",
                "(Main) repost by participant__1": "",
                "(Intro) post by sponsor__1": "",
                "(Intro) repost by participant__1": "",
                "(Promo) post by sponsor__1": "",
                "(Promo) repost by participant__1": "",
                "Youtube       1.1Mio": "40K https://www.youtube.com/LadytronDance",
                "(Main) post by sponsor__2": "",
                "(Main) repost by participant__2": "",
                "(Intro) post by sponsor__2": "",
                "(Intro) repost by participant__2": "",
                "(Promo) post by sponsor__2": "",
                "(Promo) repost by participant__2": "",
                "TW": "N/A",
                "(Main) post by sponsor__3": "",
                "(Main) repost by participant__3": "",
                "(Intro) post by sponsor__3": "",
                "(Intro) repost by participant__3": "",
                "(Promo) post by sponsor__3": "the link is above",
                "(Promo) repost by participant__3": "",
                "FB                3.8 Mio": "2K https://www.facebook.com/Rebeca.contact",
                "(Main) post by sponsor__4": "",
                "(Main) repost by participant__4": "",
                "(Intro) post by sponsor__4": "",
                "(Intro) repost by participant__4": "",
                "(Promo) post by sponsor__4": "The link is above",
                "(Promo) repost by participant__4": "",
                "Contact": "Fiverr",
                "Manager": "Milan/Anatoliy",
                "Conditions/Comments": "as to the Rules file, 85 eur, +25% prize pool",
                "Country": "Romania"
            },
            {
                "#": 48,
                "Name": "DYtalentve / reddancer",
                "Dancer/DJ?": "Dancer/Group",
                "Agreement": "sent video",
                "Name_Official": "DYtalentve",
                "Inrto/Description_Official": "DYtalentve - audiovisual production team, we create content for social networks and professional video clips.\nBarbara: Professional integral dancer for 8 years, choreographer and instructor, I am a makeup expert and I am a university student.\nOriana: I am a professional dancer, I do acrobatics, I have elasticity, I am also a model and actress. \nMaurielyz: I am a dancer, choreography, member of an elite competition group, I work as a dancer.",
                "top 1": "",
                "top 2": "",
                "top 3": "",
                "repost by sponsor": "",
                "comment by participant": "TT: https://www.tiktok.com/@1ath.studio/video/7112348026353634561?is_from_webapp=1&sender_device=pc&web_id=7112032987612562950",
                "Main Video/Track (gdrive)": "https://drive.google.com/drive/u/1/folders/1-kwNZ9FIsfUJdQuExf30WawLXS6H1csm",
                "Introduction Video (gdrive)": "https://drive.google.com/drive/u/1/folders/1-kwNZ9FIsfUJdQuExf30WawLXS6H1csm",
                "IG                                                         4.6 Mio": "DYtalentve\n1k https://www.instagram.com/visuale_producciones/ \nBarbara\nhttps://www.instagram.com/barbsdincer_1510/\nOriana\nhttps://www.instagram.com/julietaori/ \nMaurielyz\n1k https://www.instagram.com/maurielyz/",
                "(Main) post by sponsor": "TT: https://www.tiktok.com/@1ath.studio/video/7112348026353634561?is_from_webapp=1&sender_device=pc&web_id=7112032987612562950 \nYT: https://youtu.be/AOoV_dggptc \nIG: https://www.instagram.com/tv/CfJB0AGjuvp/?igshid=YmMyMTA2M2Y=                                                                                                          \nTW: https://twitter.com/1ATHStudio/status/1539891840643567617 \nFB: https://fb.watch/dPTcvtAEzE/",
                "(Main) repost by participant": "IG; https://instagram.com/stories/visuale_producciones/2866956867070163636?utm_source=ig_story_item_share&igshid=YmMyMTA2M2Y=  \nTT: https://www.tiktok.com/@dytalentve/video/7112499051311975685?is_copy_url=1&is_from_webapp=v1&lang=en",
                "(Intro) post by sponsor": "TT: https://www.tiktok.com/@1ath.studio/video/7113181052713176321?\nFB:  https://fb.watch/dSRnFVKjDL/  \nYT: https://youtu.be/pMeBgt23qA \nIG https://www.instagram.com/tv/CfOu3pGFxHL/?utm_source=ig_web_copy_link  \nTW https://twitter.com/1ATHStudio/status/1540691495812059138",
                "(Intro) repost by participant": "TT: https://www.tiktok.com/@dytalentve/video/7112499051311975685?is_copy_url=1&is_from_webapp=v1&lang=en",
                "(Promo) post by sponsor": "The link is above",
                "(Promo) repost by participant": "",
                "TT                       1.5Mio": "DYtalentve\n14K https://www.tiktok.com/@dytalentve?lang=en \nMaurielyz\n1k https://www.tiktok.com/@maugonzalezzzz \nOriana\n35k https://www.tiktok.com/@orijulietaa \nBarbara\nhttps://www.tiktok.com/@barbs_dincer",
                "(Main) post by sponsor__1": "",
                "(Main) repost by participant__1": "",
                "(Intro) post by sponsor__1": "",
                "(Intro) repost by participant__1": "",
                "(Promo) post by sponsor__1": "",
                "(Promo) repost by participant__1": "",
                "Youtube       1.1Mio": "DYtalent\nhttps://www.youtube.com/channel/UC1jrmuQYv4i4SS6ECzLBQPg",
                "(Main) post by sponsor__2": "",
                "(Main) repost by participant__2": "",
                "(Intro) post by sponsor__2": "",
                "(Intro) repost by participant__2": "",
                "(Promo) post by sponsor__2": "",
                "(Promo) repost by participant__2": "",
                "TW": "N/A",
                "(Main) post by sponsor__3": "",
                "(Main) repost by participant__3": "",
                "(Intro) post by sponsor__3": "",
                "(Intro) repost by participant__3": "",
                "(Promo) post by sponsor__3": "the link is above",
                "(Promo) repost by participant__3": "",
                "FB                3.8 Mio": "Maurielyz\nhttps://m.facebook.com/mau.gonzalez.10420 \nBarbara\n1k https://m.facebook.com/barbarasofiamachado",
                "(Main) post by sponsor__4": "",
                "(Main) repost by participant__4": "",
                "(Intro) post by sponsor__4": "",
                "(Intro) repost by participant__4": "",
                "(Promo) post by sponsor__4": "The link is above",
                "(Promo) repost by participant__4": "",
                "Contact": "Fiverr",
                "Manager": "Milan/Anatoliy",
                "Conditions/Comments": "as to the Rules file, 360 eur, +25% prize pool",
                "Country": "Venezuela"
            },
            {
                "#": 49,
                "Name": "Nicholas / nick_boneless",
                "Dancer/DJ?": "Dancer+1",
                "Agreement": "sent video",
                "Name_Official": "Nicholas and Luka",
                "Inrto/Description_Official": "Nicholas and Luka. We have won couple of dance battles and championships in Georgia and in other countries as well. We’ve been on Georgia’s got talent as well.",
                "top 1": "-",
                "top 2": "-",
                "top 3": "-",
                "repost by sponsor": "-",
                "comment by participant": "IG: https://www.instagram.com/p/CfG5S3UlyeC/",
                "Main Video/Track (gdrive)": "https://drive.google.com/drive/u/1/folders/1xQX8BgyD9ng-Riw79ATfjaf1A6SaKZb6",
                "Introduction Video (gdrive)": "https://drive.google.com/drive/u/1/folders/1xQX8BgyD9ng-Riw79ATfjaf1A6SaKZb6",
                "IG                                                         4.6 Mio": "2k https://www.instagram.com/yarmazanashvililuka/?hl=en \n0 https://www.instagram.com/nicholas_boneless/",
                "(Main) post by sponsor": "TT: https://vt.tiktok.com/ZSd3rWPYw/?k=1 \nYT: https://youtu.be/si5rvWDBDwU \nIG: https://www.instagram.com/tv/CfG5S3UlyeC/?utm_source=ig_web_copy_link                                                                                                    \nTW: https://twitter.com/1ATHStudio/status/1539589239062536193 \nFB: https://fb.watch/dOOeggEECc/",
                "(Main) repost by participant": "IG: https://instagram.com/stories/nicholas_boneless/2866511440334704090?utm_source=ig_story_item_share&igshid=YmMyMTA2M2Y=   \nfb: https://www.facebook.com/1ATH.Studio/videos/400530185372615",
                "(Intro) post by sponsor": "FB: https://www.facebook.com/108870731686383/posts/pfbid0uriQaHTfBzNWBSE33FoB7RZEE7gdPvDKpSiUD1SZxLaTkArxkXkNMnZNwE4qXNQFl/?vh=e   \nTT: https://www.tiktok.com/@1ath.studio/video/7112767022181780738?is_from_webapp=1&sender_device=pc     \nIG https://www.instagram.com/tv/CfL5WjUl5pz/?utm_source=ig_web_copy_link \nYT https://www.youtube.com/watch?v=YrTn_XqS0ss \nTW https://twitter.com/1ATHStudio/status/1540298436183982082",
                "(Intro) repost by participant": "",
                "(Promo) post by sponsor": "The link is above",
                "(Promo) repost by participant": "",
                "TT                       1.5Mio": "1k https://www.tiktok.com/@lukakarmazanashvili \n0 https://www.tiktok.com/@nicholass_official",
                "(Main) post by sponsor__1": "",
                "(Main) repost by participant__1": "",
                "(Intro) post by sponsor__1": "",
                "(Intro) repost by participant__1": "",
                "(Promo) post by sponsor__1": "",
                "(Promo) repost by participant__1": "",
                "Youtube       1.1Mio": "N/A",
                "(Main) post by sponsor__2": "",
                "(Main) repost by participant__2": "",
                "(Intro) post by sponsor__2": "",
                "(Intro) repost by participant__2": "",
                "(Promo) post by sponsor__2": "",
                "(Promo) repost by participant__2": "",
                "TW": "N/A",
                "(Main) post by sponsor__3": "",
                "(Main) repost by participant__3": "",
                "(Intro) post by sponsor__3": "",
                "(Intro) repost by participant__3": "",
                "(Promo) post by sponsor__3": "the link is above",
                "(Promo) repost by participant__3": "",
                "FB                3.8 Mio": "4K https://www.facebook.com/feedernicholas",
                "(Main) post by sponsor__4": "",
                "(Main) repost by participant__4": "",
                "(Intro) post by sponsor__4": "",
                "(Intro) repost by participant__4": "",
                "(Promo) post by sponsor__4": "The link is above",
                "(Promo) repost by participant__4": "",
                "Contact": "Fiverr",
                "Manager": "Milan/Anatoliy",
                "Conditions/Comments": "as to the Rules file, 200 eur, +25% prize pool",
                "Country": "Georgia"
            },
            {
                "#": 50,
                "Name": "Zinnat",
                "Dancer/DJ?": "DJ",
                "Agreement": "sent video",
                "Name_Official": "Zinnat",
                "Inrto/Description_Official": "Zinnat is a DJ and Producer at Zinnat Music Studio. He's been producing music for more than 16 years in variety of styles, making songs for big artists , beats for artists like Eminems band D12 Bizzare, Fly Boy Keno, Bunji and many more.\n\nHis remix for Iggy Dance & DJ Challenge was made in the style of Future House.",
                "top 1": "-",
                "top 2": "-",
                "top 3": "-",
                "repost by sponsor": "-",
                "comment by participant": "-",
                "Main Video/Track (gdrive)": "https://drive.google.com/drive/u/1/folders/1KEwObZiAniMNtGljlSl9MAnp_dfbW2ua",
                "Introduction Video (gdrive)": "https://drive.google.com/drive/u/1/folders/1KEwObZiAniMNtGljlSl9MAnp_dfbW2ua",
                "IG                                                         4.6 Mio": "",
                "(Main) post by sponsor": "TT: https://www.tiktok.com/@1ath.studio/video/7112364066869349633?is_from_webapp=1&sender_device=pc&web_id=7112032987612562950  \nYT: https://youtu.be/9839e-ppk8s \nIG: https://www.instagram.com/tv/CfJJcIdDhlE/?igshid=YmMyMTA2M2Y=                                                                                                  \nTW: https://twitter.com/1ATHStudio/status/1539903694619021312 \nFB: https://www.facebook.com/1ATH.Studio/videos/1199783084166442",
                "(Main) repost by participant": "Asked to repost  FB: https://www.facebook.com/zinnat.official \nYT: https://www.youtube.com/shorts/dKbMPwdH6yc",
                "(Intro) post by sponsor": "YT: https://www.youtube.com/watch?v=HiVUCHQOz28 \nTT: https://www.tiktok.com/@1ath.studio/video/7114284371456167170?is_from_webapp=1&sender_device=pc&web_id=7113634897173022214 \nFB: https://fb.watch/dWLUZfhPY3/ \nIG: https://www.instagram.com/tv/CfWh8darVwY/?utm_source=ig_web_copy_link \nTW: https://twitter.com/1ATHStudio/status/1541789874214289408",
                "(Intro) repost by participant": "",
                "(Promo) post by sponsor": "YT: https://www.youtube.com/watch?v=HiVUCHQOz28 \nTT: https://www.tiktok.com/@1ath.studio/video/7114284371456167170?is_from_webapp=1&sender_device=pc&web_id=7113634897173022214 \nFB: https://fb.watch/dWLUZfhPY3/ \nIG: https://www.instagram.com/tv/CfWh8darVwY/?utm_source=ig_web_copy_link \nTW: https://twitter.com/1ATHStudio/status/1541789874214289408 ",
                "(Promo) repost by participant": "",
                "TT                       1.5Mio": "",
                "(Main) post by sponsor__1": "",
                "(Main) repost by participant__1": "",
                "(Intro) post by sponsor__1": "",
                "(Intro) repost by participant__1": "",
                "(Promo) post by sponsor__1": "",
                "(Promo) repost by participant__1": "",
                "Youtube       1.1Mio": "https://www.youtube.com/channel/UCMO2IS0xvduKRApXiOMsiCw/videos",
                "(Main) post by sponsor__2": "",
                "(Main) repost by participant__2": "",
                "(Intro) post by sponsor__2": "",
                "(Intro) repost by participant__2": "",
                "(Promo) post by sponsor__2": "",
                "(Promo) repost by participant__2": "",
                "TW": "",
                "(Main) post by sponsor__3": "",
                "(Main) repost by participant__3": "",
                "(Intro) post by sponsor__3": "",
                "(Intro) repost by participant__3": "",
                "(Promo) post by sponsor__3": "the link is above",
                "(Promo) repost by participant__3": "",
                "FB                3.8 Mio": "1k https://www.facebook.com/zinnat.official",
                "(Main) post by sponsor__4": "",
                "(Main) repost by participant__4": "",
                "(Intro) post by sponsor__4": "",
                "(Intro) repost by participant__4": "",
                "(Promo) post by sponsor__4": "The link is above",
                "(Promo) repost by participant__4": "",
                "Contact": "Fiverr",
                "Manager": "Milan/Anatoliy",
                "Conditions/Comments": "as to the Rules file, 400 eur, +25% prize pool",
                "Country": "Bulgaria"
            },
            {
                "#": 51,
                "Name": "Rosey Lucci (Grace manager)",
                "Dancer/DJ?": "Dancer",
                "Agreement": "Pinged 20, working on the dance",
                "Name_Official": "Rosey Lucci",
                "Inrto/Description_Official": "",
                "top 1": "",
                "top 2": "",
                "top 3": "",
                "repost by sponsor": "",
                "comment by participant": "",
                "Main Video/Track (gdrive)": "",
                "Introduction Video (gdrive)": "",
                "IG                                                         4.6 Mio": "196k https://www.instagram.com/roseylucci/",
                "(Main) post by sponsor": "",
                "(Main) repost by participant": "",
                "(Intro) post by sponsor": "",
                "(Intro) repost by participant": "",
                "(Promo) post by sponsor": "",
                "(Promo) repost by participant": "",
                "TT                       1.5Mio": "514k https://www.tiktok.com/@roseylucci?lang=en",
                "(Main) post by sponsor__1": "",
                "(Main) repost by participant__1": "",
                "(Intro) post by sponsor__1": "",
                "(Intro) repost by participant__1": "",
                "(Promo) post by sponsor__1": "",
                "(Promo) repost by participant__1": "",
                "Youtube       1.1Mio": "https://www.youtube.com/channel/UC0txyRgnWOdBTQldmBpJCtw",
                "(Main) post by sponsor__2": "",
                "(Main) repost by participant__2": "",
                "(Intro) post by sponsor__2": "",
                "(Intro) repost by participant__2": "",
                "(Promo) post by sponsor__2": "",
                "(Promo) repost by participant__2": "",
                "TW": "",
                "(Main) post by sponsor__3": "",
                "(Main) repost by participant__3": "",
                "(Intro) post by sponsor__3": "",
                "(Intro) repost by participant__3": "",
                "(Promo) post by sponsor__3": "",
                "(Promo) repost by participant__3": "",
                "FB                3.8 Mio": "",
                "(Main) post by sponsor__4": "",
                "(Main) repost by participant__4": "",
                "(Intro) post by sponsor__4": "",
                "(Intro) repost by participant__4": "",
                "(Promo) post by sponsor__4": "",
                "(Promo) repost by participant__4": "",
                "Contact": "roseylucci.mgmt@gmail.com",
                "Manager": "Aziz",
                "Conditions/Comments": "$800 + prize pool",
                "Country": "UK"
            }
        ]

        const oldParticipants = [
                
                {
                  Name: "Estefanía Navas",
                  Type: "dancer",
                  Description:
                    "Estefanía Navas is a Venezuelan dancer with more than ten years of experience. She is passionate about Latin dancing and any style that can make a woman feel empowered with her sensuality. She is currently based in Medellín.",
                },
                {
                  Name: "Karol Mental",
                  Type: "dancer",
                  Description:
                    "Karol started his dancing career at the age of 5. Currently, he is a dancer in the Jazz One group. He is the current solo Polish Champion in jazz and modern & contemporary style dance.",
                },
                {
                  Name: "Joseph Nerzie",
                  Type: "dancer",
                  Description:
                    "Joseph is a dancer from Nigeria who runs a dance institute there. He has won many awards including the best dancer in Edo north and  the overal best dancer in civil engineering Auchi polytechnic.",
                },
                {
                  Name: "The Big Sound",
                  Type: "dj",
                  Description:
                    "The Big Sound is a collective of artists and musicians based in Medellín, Colombia. They have created more than 5000 tracks for other artists from all over the world achieving this 100% online.",
                },
                {
                  Name: "Daulet Anarbekov",
                  Type: "dancer",
                  Description:
                    'Daulet Anarbekov is a Professional Bboy/Dancer from Kazakhstan. He is an actor from "Harmony Lessons" and the founder of Steppix.',
                },
                {
                  Name: "Nihal",
                  Type: "dancer",
                  Description:
                    "Nihal is a South Asian college student with a passion for dancing. His dance style is a fusion of belly dancing and popping. Nihal also performed and created content for various musicians and agencies.",
                },
                {
                  Name: "Vlad Kim",
                  Type: "dancer",
                  Description:
                    'Vlad is a dancer and choreographer who got into Top-24 list on the 2nd Season of the Russian show "Dances" on TNT channel.',
                },
                
                {
                  Name: "Enoch",
                  Type: "dj",
                  Description:
                    "Enoch is a musician from Johannesburg, South Africa. He's a drummer, producer and rapper with an interest in sports and DeFi.",
                },
                
                
                {
                  Name: "Ilias",
                  Type: "dj",
                  Description:
                    'Ilias is a 20 year old music producer, beatmaker & audio engineer from Morocco. He\'s also the owner of "Trap Mastery".',
                },
                
                {
                  Name: "XP-TEAM",
                  Type: "dancer",
                  Description:
                    "XP-TEAM is a dance community based in Bandung city, Indonesia. With many teenagers as members, and many dancing genres represented, they specialize in hip hop and K-Pop style dances.",
                },
                {
                  Name: "Paula Grueso",
                  Type: "dancer",
                  Description:
                    "Paula Grueso studied acting, modeling and different types of Latin dance for three years. She's passionate about social work with all age ranges and wishes to contribute to society through the Foundation where she works and helps out.",
                },
                {
                  Name: "Alex Keston",
                  Type: "dj",
                  Description:
                    "Alex is a 21 year old music producer based in India. After becoming interested in EDM music production six years ago, producing has become his biggest passion. One of the best achievements in his career so far was getting his EP and a single featured in Paste Magazine.",
                },
            
                {
                  Name: "Rebeca (Ladytron)",
                  Type: "dancer",
                  Description:
                    "Rebeca (Ladytron) took her first street dance lessons when she was sixteen. Now she is a dance instructor at her own studio, with over ten years of experience. She worked with several music artists and top-rated brands. When she's not in the dance class, she is performing in high-tech shows, with optical illusions, light swords and LED Costumes.",
                },
                {
                  Name: "Zinco18",
                  Type: "dancer",
                  Description:
                    "Zinco is a dancer from West Midlands, UK, who does trend dancing and runs popular social media accounts.",
                },
                
                {
                  Name: "Densley Carolissen",
                  Type: "dancer",
                  Description:
                    'Densley Carolissen, also known as "Lyrical Deezy" is a Cape Town-born professional dancer and international choreographer. He is the owner and founder of Elite Movement Dance Studio and South Africa\'s Choreographer of The Year Award winner 2022.',
                },
                {
                  Name: "Uniqueens Dance Team",
                  Type: "dancer",
                  Description:
                    "Uniqueens Dance Team is part of a special project, created by the Russian federation of modern dance, together with the British dance studio Pineapple. Uniqueens and their Unidance studio represent over 10 of the most popular international dance styles.",
                },
                {
                  Name: "DYtalentve",
                  Type: "dancer",
                  Description:
                    "DYtalentve is an audiovisual production team, who create content for social networks and professional videos.\nBarbara is a professional integral dancer with 8 years of experience, choreographer and instructor, she is a makeup expert and a university student. Oriana is a professional dancer, who does acrobatics. She is very flexible and is also a model and an actress. Maurielyz is a dancer, choreographer and a member of an elite competition group who also works as a dancer.",
                },
                
              
        ]

        const getYouTubeIdFromUrl = (url: string) => {
            let regExp =
              /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
            let match = url.match(regExp);
            return match && match[7].length == 11 ? match[7] : false;
        };

        
        const getParticipantInfoByParticipant = (participant: string) => {
            let result = participants.find(
                // @ts-ignore
              (participantItem: object) => participantItem.Title === participant
            );

            //if result is not undefined return it, else return empty object
            return typeof result === "undefined" ? {
                "Title": "UNDEFINED",
                "Description": "Irakli Fifia and his crew are part of the Mess Dance Studio in Georgia. They perform dances in street jazz, dancehall and hip hop styles.",
                "YT": "https://youtu.be/wCNAtdPv3w8",
                "Type": "Dancer"
              } : result;
          }

        const getSocialMediaByParticipant = (participant: string) => {
            let result = socialMedia.find(
                // @ts-ignore
              (socialMediaItem: object) => socialMediaItem.Participant === participant
            );

            //if result is not undefined return it, else return empty object
            return typeof result === "undefined" ? {
                Participant: "Charlie Atom",
                "TT (Alisa)":
                    "https://www.tiktok.com/@1ath.studio/video/7112056218142772482?is_from_webapp=1&sender_device=pc&web_id=7112032987612562950",
                "": "",
                "IG (Ramiz)":
                    "https://www.instagram.com/tv/CfG_5n4js0K/?utm_source=ig_web_copy_link",
                __1: "",
                "YT full vid (Ira)": "https://youtu.be/aQcueL-yOEw",
                __2: "",
                "TW (Ramiz)":
                    "https://twitter.com/1ATHStudio/status/1539603575814426627",
                __3: "",
                "FB (Ira Erika)": "https://fb.watch/dORaZbF9D6/",
                } : result;
          }

          const getIntroductionDataByNameOfficial = (nameOfficial : string) => {
            const result = introductionData.map(item => ({
                ...item,
                lowerCaseName: item.Name_Official.toLowerCase()
                }))
    
            let lowerCaseNameOfficial = nameOfficial.toLowerCase();
          let result2 = result.find(
            (introductionData) => introductionData.lowerCaseName === lowerCaseNameOfficial
          );

          return typeof result2 === "undefined" ? {
            "#": 50,
            "Name": "Zinnat",
            "Dancer/DJ?": "DJ",
            "Agreement": "sent video",
            "Name_Official": "Zinnat",
            "Inrto/Description_Official": "Zinnat is a DJ and Producer at Zinnat Music Studio. He's been producing music for more than 16 years in variety of styles, making songs for big artists , beats for artists like Eminems band D12 Bizzare, Fly Boy Keno, Bunji and many more.\n\nHis remix for Iggy Dance & DJ Challenge was made in the style of Future House.",
            "top 1": "-",
            "top 2": "-",
            "top 3": "-",
            "repost by sponsor": "-",
            "comment by participant": "-",
            "Main Video/Track (gdrive)": "https://drive.google.com/drive/u/1/folders/1KEwObZiAniMNtGljlSl9MAnp_dfbW2ua",
            "Introduction Video (gdrive)": "https://drive.google.com/drive/u/1/folders/1KEwObZiAniMNtGljlSl9MAnp_dfbW2ua",
            "IG                                                         4.6 Mio": "",
            "(Main) post by sponsor": "TT: https://www.tiktok.com/@1ath.studio/video/7112364066869349633?is_from_webapp=1&sender_device=pc&web_id=7112032987612562950  \nYT: https://youtu.be/9839e-ppk8s \nIG: https://www.instagram.com/tv/CfJJcIdDhlE/?igshid=YmMyMTA2M2Y=                                                                                                  \nTW: https://twitter.com/1ATHStudio/status/1539903694619021312 \nFB: https://www.facebook.com/1ATH.Studio/videos/1199783084166442",
            "(Main) repost by participant": "Asked to repost  FB: https://www.facebook.com/zinnat.official \nYT: https://www.youtube.com/shorts/dKbMPwdH6yc",
            "(Intro) post by sponsor": "YT: \nTT:\nFB:\nIG:\nTW:",
            "(Intro) repost by participant": "",
            "(Promo) post by sponsor": "The link is above",
            "(Promo) repost by participant": "",
            "TT                       1.5Mio": "",
            "(Main) post by sponsor__1": "",
            "(Main) repost by participant__1": "",
            "(Intro) post by sponsor__1": "",
            "(Intro) repost by participant__1": "",
            "(Promo) post by sponsor__1": "",
            "(Promo) repost by participant__1": "",
            "Youtube       1.1Mio": "https://www.youtube.com/channel/UCMO2IS0xvduKRApXiOMsiCw/videos",
            "(Main) post by sponsor__2": "",
            "(Main) repost by participant__2": "",
            "(Intro) post by sponsor__2": "",
            "(Intro) repost by participant__2": "",
            "(Promo) post by sponsor__2": "",
            "(Promo) repost by participant__2": "",
            "TW": "",
            "(Main) post by sponsor__3": "",
            "(Main) repost by participant__3": "",
            "(Intro) post by sponsor__3": "",
            "(Intro) repost by participant__3": "",
            "(Promo) post by sponsor__3": "the link is above",
            "(Promo) repost by participant__3": "",
            "FB                3.8 Mio": "1k https://www.facebook.com/zinnat.official",
            "(Main) post by sponsor__4": "",
            "(Main) repost by participant__4": "",
            "(Intro) post by sponsor__4": "",
            "(Intro) repost by participant__4": "",
            "(Promo) post by sponsor__4": "The link is above",
            "(Promo) repost by participant__4": "",
            "Contact": "Fiverr",
            "Manager": "Milan/Anatoliy",
            "Conditions/Comments": "as to the Rules file, 400 eur, +25% prize pool",
            "Country": "Bulgaria"
        } : result2;
        }

        const getIntroBySponsorByNameOfficial = (nameOfficial : string) => {

            console.log('nameOfficial', nameOfficial);
            
            let introData = getIntroductionDataByNameOfficial(nameOfficial)['(Intro) post by sponsor'];
            
          return introData.includes('http') ? convertStringToArrayByNewLine(getIntroductionDataByNameOfficial(nameOfficial)['(Intro) post by sponsor']) : [];
        }

        const convertStringToArrayByNewLine = (string : string) => {
          return string.split('\n');
        }

        const removeTypeFromTitle = (title : string) => {
            const info = getParticipantInfoByParticipant(title);
            let result = title.replace(`${info.Type}: `, "");
            return result;
        }

    return (
        <>
            {
                nominees.length !== 0 ? <ul className="vote__list vote__list--reverse">
                    {
                        nominees.sort((a, b) => b.count_vote - a.count_vote).filter(item => getParticipantInfoByParticipant(item.name).Type === 'Dancer').map((item: INominee) =>
                            <li key={item.id} className="vote__item">
                                {/* @ts-ignore */}
                                <Card description={item.description} makeVote={makeVote} connectWallet={connectWallet} name={item.name} count_vote={item.count_vote} is_vote={item.is_vote} id={item.id} participantInfo={getParticipantInfoByParticipant(item.name)} socialMediaInfo={getSocialMediaByParticipant(removeTypeFromTitle(item.name))} introductionInfo={getIntroBySponsorByNameOfficial(removeTypeFromTitle(item.name))} />
                            </li>
                        )}
                        {
                        nominees.sort((a, b) => b.count_vote - a.count_vote).filter(item => getParticipantInfoByParticipant(item.name).Type === 'DJ').map((item: INominee) =>
                            <li key={item.id} className="vote__item">
                                {/* @ts-ignore */}
                                <Card description={item.description} makeVote={makeVote} connectWallet={connectWallet} name={item.name} count_vote={item.count_vote} is_vote={item.is_vote} id={item.id} participantInfo={getParticipantInfoByParticipant(item.name)} socialMediaInfo={getSocialMediaByParticipant(removeTypeFromTitle(item.name))} introductionInfo={getIntroBySponsorByNameOfficial(removeTypeFromTitle(item.name))} />
                            </li>
                        )}
                        {
                        oldParticipants.map((item: object, index) =>
                            <li key={index + 999} className="vote__item">
                                {/* @ts-ignore */}
                                <Card description={item.Description} makeVote={false} connectWallet={connectWallet} name={item.Name} count_vote={0} is_vote={false} id={index + 999} participantInfo={item} socialMediaInfo={getSocialMediaByParticipant(item.Name)} introductionInfo={getIntroBySponsorByNameOfficial(item.Name)} />
                            </li>
                        )}
                </ul> : <p className={"vote__description h2"}>No Nominees!</p>
            }
        </>
    );
};

export default NomineesList;